export const it = {
  app: {
    home: 'Home',
    playerScout: 'Ricerca giocatori',
    playerComparison: 'Confronta giocatori',
    playerRecruitment: 'Radar',
    collections: 'Collezioni',
    favoritePlayers: 'Giocatori preferiti',
    teamAnalytics: 'Analisi squadre',
    gameAnalysis: 'Analisi partite',
    seasonStats: 'Stagione',
    leagueTable: 'Classifiche',
    scoresAndFixtures: 'Risultati',
    notifications: 'Notifiche',
    administration: 'Amministrazione',
    inbox: 'Posta in arrivo',
    teamStats: 'Statistiche squadre',
    blog: 'Blog',
    leagues: 'Campionati',
    squadBuilder: 'Squad Builder',
    playerAlerts: 'Player Alerts',
    searchAlerts: 'Search Alerts',
    videoUploadTool: 'Video Upload Tool',
    videoPlaylists: 'Playlists',
    uploadedGames: 'Uploaded games',
    favoriteTeams: 'Favorite Teams',
    arrigo: 'Arrigo',
    validateEvents: 'Convalida eventi'
  },
  playerRecruitment: {
    title: 'Scheda giocatore',
    subtitle: 'Approfondisci le caratteristiche e le statistiche del giocatore',
    league: 'Campionato',
    selectedSeason: 'Stagione selezionata',
    year: 'Anno',
    radar: 'Radar',
    positions: 'Posizioni',
    numberOfPlayers: 'Numero giocatori',
    template: 'Rosa',
    compareWith: 'Confronta con',
    previousPerformance: 'Rendimento precedente',
    xGames: '{0} partite',
    average: 'Media',
    leagueAverage: 'Media Campionato',
    selectSeason: 'Seleziona una stagione',
    positionsPlayed: 'Ruoli giocati',
    minMax: 'Minimo e massimo',
    top5Leagues: 'Top 5 Campionati',
    infoMessage: 'Seleziona solo una stagione per abilitare minimo e massimo',
    infoMessage2: 'Seleziona la stessa stagione per entrambi',
    dataPer90MinText: 'Dati per 90 minuti',
    adjustToPossessionText: '* Regolato sul possesso',
    text: 'Testo',
    lollipop: 'Lollipop',
    polar: 'Polar',
    noGamesBetweenDates: 'Nessuna partita trovata tra le date selezionate',
    radarTemplates: {
      Goalkeeper: 'Portiere',
      GoalkeeperCustom: 'Portiere personalizzato',
      GoalkeeperCustom1: 'Portiere Cliente 1',
      GoalkeeperCustom2: 'Portiere Cliente 2',
      GoalkeeperCustom3: 'Portiere Cliente 3',
      GoalkeeperCustom4: 'Portiere Cliente 4',
      GoalkeeperCustom5: 'Portiere Cliente 5',
      GoalkeeperCustom6: 'Portiere Cliente 6',
      Defender: 'Difensore',
      DefenderCustom: 'Difensore personalizzato',
      DefenderCustom1: 'Difensore Cliente 1',
      DefenderCustom2: 'Difensore Cliente 2',
      DefenderCustom3: 'Difensore Cliente 3',
      DefenderCustom4: 'Difensore Cliente 4',
      DefenderCustom5: 'Difensore Cliente 5',
      DefenderCustom6: 'Difensore Cliente 6',
      FullBack: 'Terzino',
      FullBackCustom: 'Terzino personalizzato',
      FullBackCustom1: 'Terzino Cliente 1',
      FullBackCustom2: 'Terzino Cliente 2',
      FullBackCustom3: 'Terzino Cliente 3',
      FullBackCustom4: 'Terzino Cliente 4',
      FullBackCustom5: 'Terzino Cliente 5',
      FullBackCustom6: 'Terzino Cliente 6',
      FullBackPredictive: 'Terzino',
      Midfielder: 'Centrocampista',
      MidfielderCustom: 'Centrocampista personalizzato',
      MidfielderCustom1: 'Centrocampista Cliente 1',
      MidfielderCustom2: 'Centrocampista Cliente 2',
      MidfielderCustom3: 'Centrocampista Cliente 3',
      MidfielderCustom4: 'Centrocampista Cliente 4',
      MidfielderCustom5: 'Centrocampista Cliente 5',
      MidfielderCustom6: 'Centrocampista Cliente 6',
      MidfielderPredictive: 'Centrocampista',
      MidfielderDefensive: 'Centrocampista Difensivo',
      MidfielderOffensive: 'Centrocampista Offensivo',
      AttackingMidfielder: 'Centrocampista offensivo',
      MidfielderWing: 'Mezzala',
      Winger: 'Ala',
      WingerCustom: 'Ala personalizzata',
      WingerCustom1: 'Ala Cliente 1',
      WingerCustom2: 'Ala Cliente 2',
      WingerCustom3: 'Ala Cliente 3',
      WingerCustom4: 'Ala Cliente 4',
      WingerCustom5: 'Ala Cliente 5',
      WingerCustom6: 'Ala Cliente 6',
      WingerOffensive: 'Ala Offensiva',
      Forward: 'Attaccante',
      ForwardCustom: 'Inoltra personalizzato',
      ForwardCustom1: 'Attaccante Cliente 1',
      ForwardCustom2: 'Attaccante Cliente 2',
      ForwardCustom3: 'Attaccante Cliente 3',
      ForwardCustom4: 'Attaccante Cliente 4',
      ForwardCustom5: 'Attaccante Cliente 5',
      ForwardCustom6: 'Attaccante Cliente 6',
      ForwardPredictive: 'Attaccante',
      WingBack: 'Terzino fluidificante',
      WingBackCustom: 'WingBack personalizzato',
      WingBackCustom1: 'Terzino fluidificante Cliente 1',
      WingBackCustom2: 'Terzino fluidificante Cliente 2',
      WingBackCustom3: 'Terzino fluidificante Cliente 3',
      WingBackCustom4: 'Terzino fluidificante Cliente 4',
      WingBackCustom5: 'Terzino fluidificante Cliente 5',
      WingBackCustom6: 'Terzino fluidificante Cliente 6',
      WingBackMedia: 'Terzino fluidificante (SocialMedia)',
      FullBackMedia: 'Terzino (SocialMedia)',
      MidfielderMedia: 'Centrocampista (SocialMedia)',
      WingerMedia: 'Ala (SocialMedia)',
      ForwardMedia: 'Attaccante (SocialMedia)',
      PhysicalWingBack: 'Terzino Fluidificante Fisico',
      PhysicalForward: 'Attaccante Fisico',
      PhysicalWinger: 'Ala Fisico',
      PhysicalMidfielder: 'Centrocampista Fisico',
      PhysicalFullBack: 'Terzino Fisico',
      PhysicalDefender: 'Difensore Fisico',
      PhysicalWingBackLMO: 'Terzino Fluidificante Fisico LMO',
      PhysicalForwardLMO: 'Attaccante Fisico LMO',
      PhysicalWingerLMO: 'Ala Fisico LMO',
      PhysicalMidfielderLMO: 'Fisico Centrocampista LMO',
      PhysicalFullBackLMO: 'Fisico Terzino LMO',
      PhysicalDefenderLMO: 'Fisico Difensore LMO',
      'Centrocampista offensivo': 'Trequartista'
    },
    radarTemplatesWomen: {
      Goalkeeper: 'Portiere',
      Defender: 'Difensore',
      FullBack: 'Terzino',
      FullBackPredictive: 'Terzino',
      Midfielder: 'Centrocampista',
      MidfielderPredictive: 'Centrocampista',
      MidfielderDefensive: 'Centrocampista Difensivo',
      MidfielderOffensive: 'Centrocampista Offensivo',
      AttackingMidfielder: 'Centrocampista offensivo',
      MidfielderWing: 'Mezzala',
      Winger: 'Ala',
      WingerOffensive: 'Ala Offensiva',
      Forward: 'Attaccante',
      ForwardPredictive: 'Attaccante',
      WingBack: 'Terzino fluidificante',
      WingBackMedia: 'Terzino fluidificante (SocialMedia)',
      FullBackMedia: 'Terzino (SocialMedia)',
      MidfielderMedia: 'Centrocampista (SocialMedia)',
      WingerMedia: 'Ala (SocialMedia)',
      ForwardMedia: 'Attaccante (SocialMedia)',
      PhysicalWingBack: 'Terzino Fluidificante Fisico',
      PhysicalForward: 'Attaccante Fisico',
      PhysicalWinger: 'Ala Fisico',
      PhysicalMidfielder: 'Centrocampista Fisico',
      PhysicalFullBack: 'Terzino Fisico',
      PhysicalDefender: 'Difensore Fisico',
      PhysicalWingBackLMO: 'Terzino Fluidificante Fisico LMO',
      PhysicalForwardLMO: 'Attaccante Fisico LMO',
      PhysicalWingerLMO: 'Ala Fisico LMO',
      PhysicalMidfielderLMO: 'Fisico Centrocampista LMO',
      PhysicalFullBackLMO: 'Fisico Terzino LMO',
      PhysicalDefenderLMO: 'Fisico Difensore LMO',
      'Centrocampista offensivo': 'Trequartista'
    },
    radarDescription: {
      basicStatistics: {
        title: 'STATISTICHE BASE',
        minutes: 'minuti',
        goals: 'gol',
        assists: 'assist',
        redCards: 'Cartellini rossi',
        yellowCards: 'Cartellini gialli',
        games: 'partite',
        goalsReceived: 'Gol subiti',
        xGFaced: 'xG subiti'
      },
      profiles: {
        3: {
          1: 'Portiere abile con i piedi, sia nei passaggi corti sia in quelli lunghi.',
          2: 'Profilo in grado di giocare con i piedi e di essere importante nella costruzione dal basso. Buone percentuali sia nei passaggi corti che in quelli lunghi.',
          3: 'Portiere con buon gioco con i piedi. Profilo interessante per i parametri di passaggio.',
          4: 'Portiere che si distingue per la qualità dei passaggi, sia nella propria metà campo che in quella avversaria.',
          5: 'Profilo molto sicuro con il pallone tra i piedi e con grande abilità nel passaggio.',
          6: 'Portiere affidabile con i piedi. Garantisce una costruzione dal basso sicura grazie alle alte percentuali di passaggi corti e lunghi.',
          7: 'Portiere molto solido nel gioco con i piedi, con un’alta percentuale sia di passaggi corti che di passaggi lunghi completati.'
        },
        5: {
          1: 'Difensore bravo nell\'uno contro uno e con un gran numero di contrasti riusciti e di intercetti completati.',
          2: 'Difensore centrale molto efficace nei duelli, sia nei contrasti sia nei duelli aerei, con una buona lettura nell\'anticipo.',
          3: 'Difensore centrale con ottimo rendimento nei duelli difensivi individuali, in grado di recuperare con continuità il possesso del pallone.',
          4: 'Profilo con un livello difensivo molto alto. Recupera numerosi palloni grazie a contrasti e intercetti.',
          5: 'Difensore estremamente efficace nei contrasti e nelle intercettazioni, molto affidabile nei duelli individuali.',
          6: 'Difensore centrale con un alto numero di recuperi per 90 minuti. Ottima lettura del gioco avversario e grande continuità nel contrasto.',
          7: 'Difensore con un volume molto elevato di recuperi, grazie a contrasti efficaci e a una buona capacità di anticipo.'
        },
        6: {
          1: 'Difensore con buona visione di gioco, in grado di contribuire alla creazione di occasioni.'
        },
        7: {
          1: 'Terzino con rendimento equilibrato: forte contributo nella costruzione di xG in fase offensiva e alto numero di recuperi del possesso in fase difensiva.'
        },
        8: {
          1: 'Terzino solido nell\'uno contro uno e con un gran numero di recuperi grazie a contrasti e intercetti.'
        },
        9: {
          1: 'Terzino con un grande apporto offensivo, capace di generare azioni pericolose, ma con alcune lacune in fase difensiva.'
        },
        10: {
          1: 'Centrocampista che copre molto campo, capace di recuperare il pallone e di partecipare in modo rilevante alla costruzione di xG della squadra.'
        },
        11: {
          1: 'Centrocampista con alto rendimento difensivo ed efficace nel passaggio, pur con un contributo offensivo limitato.'
        },
        12: {
          1: 'Centrocampista completo, con impatto nella creazione di occasioni pericolose, buon gioco aereo e grande volume di recuperi tramite contrasti e intercetti.'
        },
        15: {
          1: 'Ala abile nell\'uno contro uno e con un buon livello di cross completati, capace di generare più passaggi chiave (xA) che tiri (xG).'
        },
        16: {
          1: 'Profilo bravo nei passaggi tra le linee e nelle progressioni palla al piede, capace di creare occasioni e con grande influenza nella zona centrale in fase di possesso.'
        },
        17: {
          1: 'Profilo con buon dribbling che tende a rientrare verso il centro, generando più tiri (xG) che passaggi chiave (xA).'
        },
        18: {
          1: 'Attaccante con grande lavoro senza palla e alto indice di pressing, che si traduce in numerosi recuperi del possesso.'
        },
        22: {
          1: 'Attaccante molto mobile, capace di ricevere tra le linee, allargarsi sulla fascia e creare azioni da gol. Alta percentuale di tocchi fuori area rispetto al totale dei tocchi.'
        }
      },
      description: 'DESCRIZIONE',
      conjuction: ' e ',
      conjuction2: ' e ',
      over: 'sopra',
      under: 'sotto',
      respectively: ', rispettivamente',
      Defending1: {
        1: 'Il rendimento difensivo è tra i peggiori dei Top 5 Campionati'
      },
      Defending2: {
        1: 'In fase difensiva il rendimento è sotto la media'
      },
      Defending3: {
        1: 'In fase difensiva il livello è leggermente over_under_average la media'
      },
      Defending4: {
        1: 'Lavoro notevole in fase difensiva con un rendimento sopra la media'
      },
      Defending5: {
        1: 'Eccellente nei compiti difensivi, con un rendimento superiore all’80% dei player_positions dei Top 5 Campionati'
      },
      Saving1: {
        1: 'Portiere con rendimento molto basso, con molte difficoltà nella presa'
      },
      Saving2: {
        1: 'Il livello offerto tra i pali è sotto la media'
      },
      Saving3: {
        1: 'Portiere con rendimento discreto, leggermente over_under_average la media, con margini di miglioramento in metric_name'
      },
      Saving4: {
        1: 'Portiere con buon livello, sopra la media dei Top 5 Campionati, in particolare in metric_name'
      },
      Saving5: {
        1: 'Profilo molto completo nelle parate: i parametri lo collocano nel migliore 20% dei portieri dei Top 5 campionati europei.'
      },
      Passing1: {
        1: 'Il rendimento con il pallone tra i piedi è tra i più bassi'
      },
      Passing2: {
        1: 'Per quanto riguarda i passaggi, le prestazioni sono sotto la media'
      },
      Passing3: {
        1: 'Livello di passaggio discreto, leggermente over_under_average la media'
      },
      Passing4: {
        1: 'Ottimo passatore con un livello superiore alla media in questo aspetto'
      },
      Passing5: {
        1: 'Elevata efficacia nel passaggio, con rendimento superiore alla gran parte dei giocatori'
      },
      Aerial1: {
        1: 'Profilo debole nel gioco aereo, tra i peggiori nella posizione in questo aspetto'
      },
      Aerial2: {
        1: 'Nel gioco aereo il rendimento è inferiore alla media'
      },
      Aerial3: {
        1: 'Livello discreto nel gioco aereo, leggermente over_under_average la media'
      },
      Aerial4: {
        1: 'Grande rendimento nel gioco aereo, con elevata efficacia in questo aspetto'
      },
      Aerial5: {
        1: 'I parametri nel gioco aereo collocano il profilo tra i migliori'
      },
      Shooting1: {
        1: 'Statistiche molto basse sotto porta, tra le più negative in questo aspetto'
      },
      Shooting2: {
        1: 'Livello sotto porta decisamente migliorabile, al di sotto della media'
      },
      Shooting3: {
        1: 'Rendimento accettabile nei compiti offensivi, leggermente over_under_average la media'
      },
      Shooting4: {
        1: 'Ottima presenza in area, con rendimento superiore al 60% dei giocatori'
      },
      Shooting5: {
        1: 'Grandi abilità balistiche, tra i profili migliori in questo aspetto'
      },
      Association1: {
        1: 'Il rendimento associativo con il pallone è molto basso, tra i peggiori dei Top 5 Campionati'
      },
      Association2: {
        1: 'Serve migliorare con il pallone tra i piedi, visto che il rendimento è sotto la media in questo aspetto'
      },
      Association3: {
        1: 'Buona capacità associativa, leggermente over_under_average la media'
      },
      Association4: {
        1: 'Si associa molto bene con il pallone presentando un livello notevole'
      },
      Association5: {
        1: 'Straordinaria capacità di associarsi con il pallone, tra i migliori in questo aspetto'
      },
      BallHandling1: {
        1: 'Pessimo rendimento nel controllo della palla, tra i peggiori nei Top 5 Campionati'
      },
      BallHandling2: {
        1: 'Per quanto riguarda il controllo della palla, i livelli sono al di sotto della media'
      },
      BallHandling3: {
        1: 'Discreto livello nel controllo della palla, leggermente over_under_average la media'
      },
      BallHandling4: {
        1: 'Alto livello nel controllo della palla, con numeri vicini ai migliori in questo aspetto'
      },
      BallHandling5: {
        1: 'Eccezionale capacità nel controllo della palla, tra i migliori nei Top 5 Campionati'
      },
      Crosses1: {
        1: 'Scarse prestazioni nel crossare la palla in area. Tra i peggiori profili nella metrica dei cross'
      },
      Crosses2: {
        1: 'Prestazioni inferiori alla media nel creare pericoli con i cross'
      },
      Crosses3: {
        1: 'Livello accettabile nei cross in area, un po\' sopra la media'
      },
      Crosses4: {
        1: 'Buone statistiche nei cross, chiaramente sopra la media'
      },
      Crosses5: {
        1: 'Rendimento molto elevato nei cross in area, tra il 20% dei profili più efficaci in questa categoria'
      },
      Carries1: {
        1: 'Tra il 20% dei profili con i numeri peggiori per quanto riguarda la conduzione del pallone'
      },
      Carries2: {
        1: 'La conduzione del pallone è lontana dai livelli medi dei profili nella stessa posizione'
      },
      Carries3: {
        1: 'Prestazioni vicine alla media, leggermente superiori in termini di conduzione del pallone'
      },
      Carries4: {
        1: 'Profilo molto solido con ottimi numeri in termini di profondità e conduzione palla al piede'
      },
      Carries5: {
        1: 'Profilo di grande talento nel portare la palla, con alta performance nelle metriche di conduzione'
      },
      Turnovers1: {
        1: 'Prestazione molto negativa, con un alto volume di palloni persi che facilitano la creazione di pericoli da parte degli avversari. Tra i peggiori in questa metrica'
      },
      Turnovers2: {
        1: 'Le numerose palle perse in zone pericolose favoriscono gli avversari; è necessario migliorare molto e ridurre questi errori'
      },
      Turnovers3: {
        1: 'Il profilo è leggermente sopra_sotto_la_media in termini di palloni persi, con ampi margini di miglioramento'
      },
      Turnovers4: {
        1: 'Prestazione notevole in termini di palloni persi, sopra il 60% dei profili che perdono meno il possesso'
      },
      Turnovers5: {
        1: 'Si distingue per il basso numero di palloni persi, collocandosi tra i profili più affidabili nel mantenere il possesso per la squadra'
      },
      SequenceInvolvement1: {
        1: 'In termini di possesso palla, i numeri non sono favorevoli: le azioni si concludono raramente con un tiro'
      },
      SequenceInvolvement2: {
        1: 'La rifinitura dei possessi è ampiamente migliorabile, difficilmente si arriva al tiro e questo colloca il rendimento ben al di sotto della media'
      },
      SequenceInvolvement3: {
        1: 'Livello accettabile nella conclusione dei possessi verso la porta, con un percentile di poco over_under_average la media e margini di crescita'
      },
      SequenceInvolvement4: {
        1: 'Buona capacità di concludere i possessi della squadra con tiri, alcuni dei quali si trasformano in gol. Prestazione notevole in questa categoria'
      },
      SequenceInvolvement5: {
        1: 'Si colloca tra chi conclude meglio i possessi della squadra, finalizzandoli con tiri che generano pericolo'
      },
      OutPlay1: {
        1: 'L’impatto nel disorganizzare le strutture difensive avversarie risulta minimo'
      },
      OutPlay2: {
        1: 'Il contributo alla progressione e alla rottura delle linee difensive è inferiore agli standard del ruolo'
      },
      OutPlay3: {
        1: 'In grado di generare vantaggi in alcune situazioni, con rendimento intorno alla media per il ruolo'
      },
      OutPlay4: {
        1: 'Contribuisce spesso a rompere le linee difensive e a creare squilibri'
      },
      OutPlay5: {
        1: 'Si distingue tra i profili che eliminano meglio gli avversari e generano progressioni in quel ruolo'
      },
      LineBreakingPasses1: {
        1: 'Raramente vengono tentati o completati passaggi che rompono le linee difensive, con contributo molto scarso in questo tipo di azioni'
      },
      LineBreakingPasses2: {
        1: 'Emergono difficoltà nel trovare con continuità compagne o compagni tra le linee o alle spalle della pressione, con un contributo sotto gli standard del ruolo'
      },
      LineBreakingPasses3: {
        1: 'I passaggi che rompono le linee si verificano in modo occasionale, con rendimento vicino alla media per il ruolo'
      },
      LineBreakingPasses4: {
        1: 'Si osserva una buona frequenza di passaggi che rompono le linee e contribuiscono a destabilizzare i blocchi avversari'
      },
      LineBreakingPasses5: {
        1: 'Tra i passatori più efficaci del campionato nel rompere le linee e superare la pressione. Questo rappresenta una delle principali qualità del profilo'
      },
      PassUnderPressure1: {
        1: 'Emergono difficoltà nel mantenere calma ed efficacia quando la pressione avversaria aumenta'
      },
      PassUnderPressure2: {
        1: 'La precisione di passaggio cala sensibilmente nelle situazioni di alta pressione'
      },
      PassUnderPressure3: {
        1: 'Il livello nei passaggi sotto pressione è intorno alla media. La pressione viene gestita in modo ragionevole, anche se l’esecuzione non è sempre pulita'
      },
      PassUnderPressure4: {
        1: 'Si riesce frequentemente a trovare compagne e compagni nonostante la pressione, con rendimento sopra la media in questo tipo di passaggi'
      },
      PassUnderPressure5: {
        1: 'Compostezza e precisione di alto livello nei passaggi sotto intensa pressione, tra i migliori del ruolo in questo aspetto'
      },
      BallReceived1: {
        1: 'Numero molto ridotto di ricezioni in zone avanzate; non si tratta di un profilo che opera con continuità tra le linee'
      },
      BallReceived2: {
        1: 'Si registrano alcune ricezioni smarcate nella metà campo avversaria, ma senza grande continuità'
      },
      BallReceived3: {
        1: 'Volume medio di ricezioni senza opposizione nelle zone offensive'
      },
      BallReceived4: {
        1: 'Ricezioni frequenti tra le linee e in zone libere da pressione'
      },
      BallReceived5: {
        1: 'Elevato numero di ricezioni tra le linee, libero da marcature e in zone potenzialmente decisive'
      },
      OnBallPressure1: {
        1: 'La pressione sul portatore di palla è molto sporadica e raramente vicina all’avversario in possesso. Intensità complessiva ridotta'
      },
      OnBallPressure2: {
        1: 'Si registrano alcune pressioni forti, ma non con grande frequenza. L’intensità generale rimane piuttosto bassa'
      },
      OnBallPressure3: {
        1: 'Volume medio di pressioni nelle vicinanze dell’avversario in possesso'
      },
      OnBallPressure4: {
        1: 'Profilo disciplinato nel pressing, con uscite regolari verso il portatore di palla'
      },
      OnBallPressure5: {
        1: 'Intensità molto alta senza palla, con grande disciplina e lavoro costante nel mettere pressione al portatore'
      },
      SpatialCoverage1: {
        1: 'Il contributo nell’occupazione e nel controllo degli spazi è molto limitato, con coinvolgimento minimo nella formazione e nella struttura tattica della squadra. La copertura spaziale risulta debole sia in possesso che in non possesso, con poca influenza su organizzazione e compattezza collettiva'
      },
      SpatialCoverage2: {
        1: 'La copertura spaziale è inferiore alla media: c’è una certa partecipazione nell’occupazione del campo, ma con lacune nella continuità posizionale e nella coesione con il resto della squadra. L’influenza sulla struttura tattica è intermittente e meno costante rispetto a profili meglio classificati'
      },
      SpatialCoverage3: {
        1: 'Copertura spaziale nella media, con contributo stabile all’occupazione e al controllo degli spazi. Il posizionamento è generalmente corretto e funzionale, con impatto moderato in entrambe le fasi di gioco'
      },
      SpatialCoverage4: {
        1: 'Copertura spaziale superiore alla media, con grande coinvolgimento nell’occupazione del campo e nella struttura posizionale della squadra. La capacità di mantenere la forma e di adattarsi alle transizioni favorisce compattezza e controllo delle zone chiave'
      },
      SpatialCoverage5: {
        1: 'Livello di copertura spaziale eccellente, con posizionamento ottimizzato per influire in modo decisivo sulla formazione e sulla struttura tattica. Comprensione del gioco e sincronizzazione con il blocco che consentono di massimizzare l’occupazione degli spazi strategici, sia in attacco che in difesa'
      },
      OffBallPressure1: {
        1: 'La pressione difensiva senza palla è molto limitata, con rari interventi per interrompere le azioni avversarie o provocare errori. Contributo minimo al pressing e alla struttura difensiva'
      },
      OffBallPressure2: {
        1: 'La pressione difensiva senza palla è sotto la media, con interventi occasionali ma tempismo e posizionamento poco costanti. L’impatto sulla riconquista del possesso o sulla costruzione avversaria è ridotto'
      },
      OffBallPressure3: {
        1: 'Livello medio di pressione senza palla, con contributo regolare agli sforzi difensivi. Posizionamento e tempismo risultano generalmente efficaci nel rallentare o limitare le opzioni dell’avversario'
      },
      OffBallPressure4: {
        1: 'Pressione difensiva senza palla superiore alla media, con frequente interruzione delle azioni avversarie e riduzione di tempo e spazio a disposizione. Gli sforzi sono ben coordinati e aiutano a mantenere una struttura difensiva solida'
      },
      OffBallPressure5: {
        1: 'Eccellente nell’applicare pressione difensiva senza palla, con costante disturbo agli avversari, recuperi forzati e limitazione delle linee di passaggio. Intensità, posizionamento e anticipo migliorano sensibilmente l’efficacia difensiva collettiva'
      },
      Distance1: {
        1: 'Copre significativamente meno terreno della media (i movimenti in campo sono molto limitati)'
      },
      Distance2: {
        1: 'La distanza percorsa a partita è inferiore a quanto si vede comunemente nel calcio di alto livello (meno attivo della media)'
      },
      Distance3: {
        1: 'Copre una quantità ragionevole di terreno, con numeri vicini alla media del campionato (l’impegno fisico è equilibrato)'
      },
      Distance4: {
        1: 'Copre regolarmente grandi distanze, con dati che riflettono un’ottima resistenza (mostrando un solido rendimento fisico)'
      },
      Distance5: {
        1: 'Il volume fisico è eccezionale. Tra i profili più attivi dei 5 principali campionati in termini di terreno coperto'
      },
      Sprint1: {
        1: 'Effettua pochissime corse ad alta velocità rispetto alla media (lo sforzo in sprint durante le partite è molto limitato)'
      },
      Sprint2: {
        1: 'La frequenza di sprint è inferiore alla media per il ruolo (esplosività limitata nei movimenti ad alta velocità)'
      },
      Sprint3: {
        1: 'Esegue un numero moderato di sprint a partita, in linea con la media del campionato'
      },
      Sprint4: {
        1: 'Si distingue per la frequenza degli sprint, ben al di sopra della media. Mostra un’esplosività costante, con numerose corse ad alta velocità durante la partita'
      },
      Sprint5: {
        1: 'Nel 20% dei profili con il maggior volume di sprint per 90 minuti. Prestazione fisica ai massimi livelli negli sforzi ripetuti ad alta velocità'
      },
      Acceleration1: {
        1: 'La capacità di cambiare ritmo è chiaramente inferiore alla media, con pochissime accelerazioni esplosive durante la partita'
      },
      Acceleration2: {
        1: 'Il numero di accelerazioni è inferiore alla media rispetto a profili simili, con frequenza limitata di scatti brevi'
      },
      Acceleration3: {
        1: 'Numero di accelerazioni discreto, vicino alla media del campionato. I cambi di ritmo non spiccano, ma i dati sono corretti'
      },
      Acceleration4: {
        1: 'Ottima capacità di accelerare rapidamente e in modo ripetuto, con tassi di accelerazione chiaramente sopra la media e numerosi scatti brevi'
      },
      Acceleration5: {
        1: 'Tra il 20% dei profili più esplosivi in termini di accelerazioni ripetute, con valori nettamente sopra la media negli scatti e nei cambi di ritmo'
      },
      Speed1: {
        1: 'Profilo probabilmente lento dal punto di vista fisico o che tende a gestire con parsimonia gli sforzi ad alta intensità'
      },
      Speed2: {
        1: 'Le velocità massime registrate sono leggermente inferiori alla media competitiva'
      },
      Speed3: {
        1: 'Valori di velocità massima in linea con la media durante la partita'
      },
      Speed4: {
        1: 'Raggiunge spesso alte velocità, segnale di buona rapidità e potenza'
      },
      Speed5: {
        1: 'Raggiunge velocità massime molto elevate, con forte impatto in termini di velocità'
      },
      LineBreakingCarries1: {
        1: 'Raramente vengono rotte le linee difensive tramite conduzioni palla al piede. Mancano iniziativa e continuità nell’avanzare con il pallone'
      },
      LineBreakingCarries2: {
        1: 'Si registrano alcune conduzioni che rompono le linee, ma senza grande regolarità'
      },
      LineBreakingCarries3: {
        1: 'Media moderata di conduzioni riuscite che rompono le linee avversarie'
      },
      LineBreakingCarries4: {
        1: 'Buon contributo alla costruzione, portando spesso il pallone oltre le linee e supportando la progressione'
      },
      LineBreakingCarries5: {
        1: 'Profilo specialista nella conduzione palla al piede: rompe le linee con continuità e in grande volume'
      },
      LineBreakingActions1: {
        1: 'Pochissime azioni che rompono le linee (passaggi e conduzioni). La scelta è generalmente poco rischiosa'
      },
      LineBreakingActions2: {
        1: 'Alcune azioni progressive (passaggi e conduzioni), ma con bassa frequenza. Tendenza a giocare più in orizzontale'
      },
      LineBreakingActions3: {
        1: 'Combinazione regolare di passaggi e conduzioni che rompono le linee, contribuendo alla progressione'
      },
      LineBreakingActions4: {
        1: 'Buon livello tecnico e decisionale nella produzione di azioni (passaggi e conduzioni) che rompono le linee avversarie'
      },
      LineBreakingActions5: {
        1: 'Profilo specialista nella progressione: impatto molto alto, con linee rotte di continuo grazie a passaggi e conduzioni'
      },
      OffBallRuns1: {
        1: 'Si osservano pochissimi movimenti intenzionali senza palla, con supporto limitato alla fase offensiva. I tagli raramente contribuiscono a creare spazi o a rompere le linee difensive'
      },
      OffBallRuns2: {
        1: 'Il movimento senza palla è sotto la media: il supporto all’attacco è solo occasionale e poco costante in termini di tempismo, direzione e intento tattico'
      },
      OffBallRuns3: {
        1: 'Livello medio di movimenti intenzionali senza palla, con contributo regolare alla fase offensiva. I movimenti creano spazi e sostengono il gioco di squadra con impatto moderato'
      },
      OffBallRuns4: {
        1: 'Attività senza palla superiore alla media, con movimenti intenzionali che spesso destabilizzano le difese, aprono linee di passaggio e spazi offensivi'
      },
      OffBallRuns5: {
        1: 'Eccellente qualità nei movimenti intenzionali senza palla, con letture intelligenti che massimizzano le opportunità offensive e migliorano la fluidità del gioco collettivo'
      },
      OverMaxValue: {
        1: 'Possiede una grande abilità in over_max_metric_name, con un rendimento al di sopra del valore massimo, che posiziona il profilo nel top 10% dei 5 Top campionati in questo aspetto'
      },
      OverAverageSeason: {
        1: 'Per quanto riguarda le prestazioni in over_average_metric_name, i numeri sono superiori alla media del campionato league_name (over_average_metric_value rispetto a average_metric_value)',
        2: 'Confrontando i numeri con quelli del campionato league_name, in over_average_metric_name il rendimento risulta superiore alla media (over_average_metric_value rispetto a average_metric_value) '
      },
      UnderMinValue: {
        1: 'Per quanto riguarda under_min_metric_name, il rendimento deve migliorare molto, essendo nel percent_metric_name più basso dei 5 Top campionati'
      },
      Over70Percent: {
        1: ', mettendosi in evidenza in over_70_metric_name con over_70_metric_value per 90 minuti, rispettivamente',
        2: ', al di sopra del 70% in over_70_metric_name con over_70_metric_value per 90 minuti, rispettivamente',
        3: ', svolgendo un lavoro più che notevole in over_70_metric_name con over_70_metric_value per 90 minuti, rispettivamente'
      },
      Under30Percent: {
        1: ', con la necessità di aumentare l’impatto in under_30_metric_name, visto che con under_30_metric_value per 90 minuti, rispettivamente, il rendimento è basso',
        2: ', con margine di miglioramento significativo in under_30_metric_name, poiché con under_30_metric_value per 90 minuti, rispettivamente, il rendimento è al di sotto delle aspettative',
        3: ', per quanto riguarda under_30_metric_name con under_30_metric_value per 90 minuti, rispettivamente, servono maggiori sforzi per ottenere numeri migliori'
      },
      OverAverageSeasonMoreThanOne: {
        1: 'Da segnalare il rendimento superiore alla media del campionato league_name in '
      },
      OverAverageStats: {
        1: ' over_average_metric_name (over_average_metric_value rispetto a average_metric_value di media)'
      },
      Over70PercentIndividualPressure: {
        1: ', mostrando un’ottima intensità nel pressing per recuperare il possesso',
        2: ', applicando una forte pressione sull’avversario per recuperare palla'
      },
      Under30PercentIndividualPressure: {
        1: ', con la necessità di aumentare il pressing per recuperare il pallone',
        2: ', con margine per alzare il livello di pressione sull’avversario'
      }
    },
    himSelf: 'sé',
    ownSeason: 'Stagione propria',
    minMaxTooltip: 'Adattare valori minimi e massimi del radar',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: 'Accedi',
    latestBlogPosts: 'Ultimi post',
    signIn: 'Login',
    username: 'Utente',
    password: 'Password',
    passwordForgotten: 'Recupera password',
    signUp: 'Registrati',
    enter: 'Entra',
    forceTitle: 'Account utilizzato',
    forceMessage: 'L\'account è in uso su un altro dispositivo. Vuoi collegarlo su questo dispositivo?',
    forgotMyPassword: 'Password dimenticata',
    firstLogin: 'Primo accesso',
    firstLoginMessage: 'Per motivi di sicurezza, introduci una nuova password al tuo primo accesso. Inoltre, indica una lingua di preferenza per visualizzare l\'applicazione',
    firstLoginOverview: 'Ecco una panoramica del vostro conto, dei campionati e dei prodotti a cui avete accesso.',
    passwordConfirmation: 'Conferma password',
    forgotPasswordMessage: 'Scrivi il tuo indirizzo di posta elettronica. Se esiste un account valido associato, riceverai alla tua e-mail i prossimi passi per recuperare la tua password',
    resetPassword: 'Reset password',
    resetPasswordLinkInvalid: 'Questo link non è valido o è scaduto. Richiedi un nuovo reset della password dalla pagina di accesso.',
    skipSettings: 'Saltare le impostazioni',
    contact: 'Contatto',
    cookiesText: 'Questo sito utilizza i cookie di Google per fornire i suoi servizi e analizzare il tuo traffico al fine di garantire la qualità del servizio, generare statistiche di utilizzo e rilevare e affrontare abusi.',
    contactUs: 'Contattaci',
    newsTitle: 'Novità: punteggi fisici!',
    newsText: 'Abbiamo aggiunto due nuovi punteggi di rendimento fisico al nostro punteggio originale basato sui dati evento: <b>Punteggio di Resistenza</b> e <b>Punteggio di Velocità e Potenza</b>.<br> Resistenza evidenzia i giocatori che coprono campo con costanza e sostengono carichi di lavoro elevati, mentre Velocità e Potenza si concentra su velocità massima, sprint e accelerazioni esplosive.'
  },
  settings: {
    pageSubtitle: 'Configurare l\'esperienza nell\'applicazione',
    language: 'Lingue',
    availableLeagues: 'Campionati Disponibili',
    availableSeasons: 'Stagioni Disponibili',
    availableProducts: 'Prodotti Disponibili',
    organization: 'Organizzazione',
    changePassword: 'Cambia password',
    seasonTemplates: 'Ricerca stagione',
    seasonTemplatesSubtitle: 'Crea i tuoi modelli di stagione che saranno poi disponibili per la selezione nel Ranking Giocatore e Ricerca Giocatore',
    templateName: 'Nome',
    selectTemplate: 'Selezionare un modello da modificare',
    radarDefault: 'Radar predefinito ',
    default: 'Predefinito',
    tabs: {
      options: 'Opzioni',
      templates: 'Modelli',
      availableLeagues: 'Campionati disponibili',
      contactData: 'Dati di contatto GBE'
    },
    contactData: {
      userDetails: 'Dati utente',
      firstName: 'Nome',
      lastName: 'Cognome',
      contactDetails: 'Dati di contatto',
      name: 'Nome',
      phone: 'Telefono',
      mobile: 'Cellulare',
      email: 'E-mail',
      representativeDetails: 'Dati del Rappresentante'
    },
    currency: 'Divisa',
    fieldPreferences: 'Impostazioni Campo',
    visualizationsPreferences: 'Impostazioni di visualizzazione',
    fieldColor: 'Colore del campo',
    fieldColors: {
      green: 'Verde',
      blue: 'Blu',
      white: 'Bianco',
      black: 'Nero',
      grey: 'Grey'
    },
    defaultPlayerVisualization: 'Visualizzazione del giocatore per difetto',
    appPreferences: 'Preferiti app',
    darkMode: 'Modalità notte',
    showTour: 'Mostra la visita guidata',
    customStats: 'Statistiche Personalizzato',
    radarTemplates: 'Modelli Radar',
    radarTemplatesSubtitle: 'Crea i tuoi modelli di radar che saranno successivamente disponibili per la selezione nelle Prestazioni Giocatore e Ranking Giocatore',
    radarCategories: {
      Custom1: 'Personalizzato 1',
      Custom2: 'Personalizzato 2',
      Custom3: 'Personalizzato 3',
      Custom4: 'Personalizzato 4',
      Custom5: 'Personalizzato 5',
      Custom6: 'Personalizzato 6',
      Physical: 'Fisico',
      CustomPhysical1: 'Personalizzato Fisico 1',
      CustomPhysical2: 'Personalizzato Fisico 2',
      CustomPhysical3: 'Personalizzato Fisico 3',
      CustomPhysical4: 'Personalizzato Fisico 4',
      CustomPhysical5: 'Personalizzato Fisico 5',
      CustomPhysical6: 'Personalizzato Fisico 6'
    },
    templateRemoveTitle: 'Elimina Modello',
    templateRemoveMsg: 'Vuoi eliminare questo modello?',
    templateEditTitle: 'Salva modello',
    templateEditMsg: 'C\'è un modello non salvato; si desidera salvarlo prima di caricare un altro modello?',
    category: 'Categoria',
    playerRadar: 'Radar giocatore',
    teamRadar: 'Radar Squadra',
    statsAlert: 'inserisci almeno una metrica per salvare',
    recommended: 'Consigliato',
    warning: 'Ci sono posizioni che hanno raggiunto il numero massimo di radar consentito. Si prega di cancellare o modificare qualsiasi modello',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'Spagnolo',
      numeric: 'Numerico'
    },
    showMediaMode: 'Mostra modalità multimediale',
    statTemplates: 'Modelli di Statistiche di Gioco',
    statTemplatesSubtitle: 'Create i vostri modelli personalizzati scegliendo tra una moltitudine di metriche',
    ratingFormat: {
      ratingFormat: 'Formato di valutazione',
      numbers: 'Numeri',
      letters: 'Lettere AF'
    }
  },
  playerDetail: {
    passport: 'Passaporto ',
    secondPassport: 'Secondo Passaporto',
    age: 'Età',
    dateOfBirth: 'Data di nascita',
    height: 'Altezza',
    weight: 'Peso',
    wage: 'Stipendio',
    history: 'Cronologia',
    positions: 'Posizioni',
    injuries: 'Infortuni',
    transfers: 'Trasferimenti',
    nationalTeam: 'Nazionale',
    addFavorite: 'Aggiungi a preferiti',
    removeFavorite: 'Rimuovi da preferiti',
    contractEnd: 'Scadenza contratto',
    yearsOld: 'anni',
    playerAvailability: 'Disponibilità',
    playerUsage: 'Minuti giocati',
    usage: 'Uso',
    addToCollection: 'Aggiungi a collezione',
    performance: 'Rendimento',
    info: 'Info',
    career: 'Carriera',
    playerStyle: 'Stile',
    radar: 'Radar',
    finishingMap: 'Finalizzazione',
    threatMap: 'Pericolo',
    keyPassMap: 'Passaggi Chiave',
    beeswarm: 'Ranking',
    allGames: 'Partite',
    eventsMap: 'Eventi',
    lbpMap: 'Passaggi di interruzione della linea',
    obpMap: 'Sulla pressione della palla',
    pupMap: 'Passa sotto pressione',
    obrMap: 'Ricevute della palla',
    fullName: 'Nome completo',
    academy: 'Settore giovanile',
    name: 'Nome',
    lastName: 'Cognome',
    playerAvailabilityLong: '% della stagione senza infortuni né squalifiche',
    playerUsageLong: 'Minuti Giocati',
    playerAvailability1: 'partite senza infortuni né squalifiche',
    playerAvailability2: 'partite in questa stagione',
    playerUsage1: 'minuti giocati',
    playerUsage2: 'minuti totali della squadra',
    notMinutesThisSeason: 'Non ha giocato minuti in questa stagione',
    seasonPlaceholder: 'Nessuna stagione attiva',
    inactivePlayer: 'Giocatore inattivo',
    inactivePlayerMessage: 'Se hai bisogno di maggiori informazioni, richiedi un report',
    goRequest: 'Richiedi',
    warningMinutes: 'Attenzione! Meno di 450 minuti giocati, l\'analisi potrebbe non essere rappresentativa',
    scoreWarningMinutes: 'Giocatori con almeno 450 minuti totali giocati',
    pdScoreWarningMinutes: 'Giocatori con almeno 450 minuti totali giocati (minimo 60 minuti a partita)',
    warningSeasonGames: 'Stagione con meno di 5 partite giocate, Min & Max dei Top 5 Campionati',
    warningStatsRemoved: 'Alcune statistiche non sono mostrate perché non sono disponibili per la stagione selezionata',
    warningBeeswarm: 'Giocatore non mostrato perché non ci sono dati disponibili per la stagione selezionata',
    warningPlayersZeroValue: 'Non mostrare {x} giocatori con 0 ',
    onlyPlayersThatFit: 'Solo giocatori che si adattano alla rosa',
    gamesPlayedNotEnough: 'Opzioni disabilitate a causa di un numero insufficiente di partite giocate',
    gbe: 'GBE',
    analysis: 'Analisi',
    documents: 'Documenti',
    rankDefensive: 'Difensivo',
    rankBallHandling: 'Movimento della palla',
    rankGoal: 'Contribuzione gol',
    rankXt: 'Pericolo',
    rankIndex: 'Indice',
    visitHistory: 'Guarda cronologia',
    placer: 'Campo',
    touchesMap: 'Mappa Tocchi',
    heatMap: 'Mappa di calore',
    ageProfile: 'Età',
    strongFoot: 'Piede forte',
    player: 'Giocatore',
    outOf: 'su',
    in: 'della',
    radius: 'Raggio',
    blur: 'Sfocatura',
    careerTable: {
      nationalTeamCareer: 'Carriera in Nazionale',
      nationalTeamCompetitions: 'Competizioni Nazionali'
    },
    physicalProgression: 'Physical Progression',
    gpi: 'Indice Globale dei Giocatori',
    warningGPI: 'Disponibile solo per i giocatori attivi nelle leghe ELO negli ultimi 30 giorni',
    diffGPI: 'Variazione dall\'ultima partita',
    rankingInTheWorld: '#{0} nel mondo',
    rankingInTheLeague: '#{0} in {1}',
    max: 'Max',
    gpiChart: 'Grafico basato sul valore dell\'Indice Globale dei Giocatori delle ultime {0} partite',
    percentileRange: 'Percentili da {0} a {1}',
    months: 'mesi',
    month: 'mese',
    contractExpOver4Years: 'Il contratto scade tra',
    contractExpSoon: 'Il contratto scadrà a breve',
    contractFinalYear: 'Ultimo anno di contratto',
    freeAgent: 'Agente libero',
    gpiDescription: 'Il Global Player Index (GPI) è un sistema di valutazione dei giocatori standardizzato che valuta i calciatori in base alla forza della squadra, alla forza dell\'avversario, alle prestazioni in partita e alla disponibilità. Ispirato al sistema di classificazione Elo, garantisce che le valutazioni dei giocatori riflettano gli ambienti competitivi reali piuttosto che linee di base arbitrarie.',
    turnoversMap: 'Mappa fatturati e recuperi',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    },
    sucessfulTouch: 'Tocchi di successo',
    unsuccessfulTouch: 'Tocchi infruttuosi',
    showLegend: 'Mostra legenda'
  },
  finishingMap: {
    typesOfShot: 'Tipo di tiro',
    shotStrategy: 'Strategia',
    strategiesCount: '{count} strategie',
    areas: 'Aree',
    bodyPart: 'Parte del Corpo',
    more: 'più',
    selectAll: 'Seleziona tutti',
    minutes: 'Minuti',
    circles: 'Cerchi',
    boxes: 'Mappa termica dell’area',
    lines: 'Linee',
    games: 'Partite',
    perShot: 'per tiro',
    goal: 'Gol',
    missedShot: 'Tiro fuori',
    savedShot: 'Tiri Parati',
    shotOnPost: 'Tiri sul palo',
    missedChance: 'Occasioni perse',
    openPlay: 'Su azione',
    regularPlay: 'su azione',
    fastBreak: 'Contropiede',
    individualPlay: 'Giocata individuale',
    setPiece: 'Da calcio piazzato',
    fromCorner: 'Da calcio d\'angolo',
    freeKick: 'Da Punizione diretta',
    indirectFreeKick: 'Da punizione indiretta',
    throwInSetPiece: 'Da Calcio d\'angolo',
    inBox: 'Dentro l´area',
    goalArea: 'Area piccola',
    boxLeft: 'Dentro l´Area - Sinistra',
    boxCenter: 'Dentro l´Area - Centro',
    boxRight: 'Dentro l´Area - Destra',
    outOfBox: 'Fuori Area',
    outBoxDeepLeft: 'Fuori Area - In basso a Sinistra',
    outBoxDeepRight: 'Fuori Area - In basso a destra',
    outBoxLeft: 'Fuori Area - Sinistra',
    outBoxCentreLeft: 'Fuori Area - Centro Sinistra',
    outBoxCentre: 'Fuori Area - Centro',
    outBoxCentreRight: 'Fuori Area - Centro Destra',
    outBoxRight: 'Fuori Area - Destra',
    left35: 'Sinistra +35',
    centreLeft35: 'Centro Sinistra +35',
    centre35: 'Centro +35',
    centreRight35: 'Centro Destra +35',
    right35: 'Destra +35',
    head: 'Di Testa',
    rightFooted: 'Piede destro',
    leftFooted: 'Piede Sinistro',
    otherBodyPart: 'Altro',
    chart: {
      shots: 'Tiri',
      xGPerShot: 'xG per Tiro',
      exceptionTextPenaltyGoals: '* Rigori = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* Rigori = 0.765 xGOT',
      exceptionTextOwnGoals: '* Gol nella propria porta esclusi',
      og: 'PP',
      penaltiesExcluded: 'Gol su rigore esclusi',
      ownGoalsExcluded: 'Autogol esclusi',
      sumOfxG: 'Somma xG',
      exceptionShotsOutOfRange: '* Non mostra i tiri fuori portata'
    },
    inGoal: 'In porta',
    outOfGoal: 'Fuori',
    highLeft: 'Alto a sinistra',
    highCenter: 'Alto al centro',
    highRight: 'Alto a destra',
    lowLeft: 'In basso a sinistra ',
    lowCenter: 'In basso al centro',
    lowRight: 'In basso a destra',
    outHighLeft: 'Fuori in alto a sinistra',
    high: 'Fuori in alto al centro',
    outHighRight: 'Fuori in alto a destra',
    closeHighLeft: 'Vicino alto a sinistra',
    closeHigh: 'Vicino alto al centro',
    closeHighRight: 'Vicino alto a destra',
    closeLeft: 'Vicino basso a sinistra',
    closeRight: 'Vicino basso a destra',
    finishingTable: 'Finalizzazione Table',
    onGoal: 'In porta',
    distributionFilters: 'Filtri di distribuzione',
    penalty: 'Rigore',
    penaltyShootout: 'Calci di rigore',
    onlyPercentage: 'Mostra percentuale',
    showAll: 'Mostra tutto',
    chanceMissed: 'Occasione persa'
  },
  keyPassMap: {
    chart: {
      keyPasses: 'Passaggi Chiave',
      xAPerPass: 'xA per Passaggio',
      xAOpenPlay: 'xA Su Azione',
      xASetPiece: 'xA da Palla Ferma'
    }
  },
  beeswarm: {
    template: 'Rosa',
    templates: {
      Goalkeeper: 'Portieri',
      Defender: 'Difensori',
      'Full-Back': 'Terzini',
      FullBack: 'Terzini',
      'Wing-Back': 'Terzino fluidificante',
      WingBack: 'Terzino fluidificante',
      Midfielder: 'Centrocampisti',
      AttackingMidfielder: 'Trequartista',
      Winger: 'Ala',
      Forward: 'Attaccante',
      Physical: 'Fisico'
    },
    compareWith: 'Confronta con ',
    highlightPlayersOf: 'I giocatori in evidenza di',
    highlightPlayers: 'Giocatori in evidenza',
    per90: 'Dati per 90 minuti di gioco',
    highlightTeams: 'Evidenziare le Squadre',
    filterTeams: 'Filtra Squadre',
    warningZeros: 'Solo per statistiche non invertite'
  },
  collections: {
    newCollection: 'Nuova Collezione',
    editCollection: 'Modifica collezione',
    name: 'Nome',
    visibility: 'Visibilità',
    privacity: {
      publicTitle: 'Pubblica',
      publicDescription: 'Visibile a te e a tutto il tuo club',
      privateTitle: 'Privata',
      privateDescription: 'Solo visible a te',
      supervisedTitle: 'Supervisionato',
      supervisedDescription: 'Visibile solo all\'utente e al suo supervisore'
    },
    addSuccess: 'Aggiunto con successo',
    createAddSuccess: 'Creata e aggiunta correttamente',
    editSuccess: 'Aggiornata correttamente',
    deleteSuccess: 'Eliminata correttamente',
    title: 'Collezioni giocatori',
    publics: 'Pubbliche',
    privates: 'Private',
    supervised: 'Supervisionato',
    totalMarketValue: 'Valore di mercato totale',
    avgMarketValue: 'Valore di mercato medio',
    avgAge: 'Età media',
    searchBarPlaceholder: 'Cerca e seleziona un giocatore per aggiungerlo alla collezione',
    deleteCollection: 'Elimina collezione',
    deleteCollectionMessage: 'La collezione verrà eliminata. Sei sicuro?',
    removePlayer: 'Elimina giocatore',
    removePlayerMessage: 'Il giocatore verrà eliminato dalla collezione. Sei sicuro?',
    subtitle: 'Organizza la tue ricerche',
    notExitingTemplate: 'Non ci sono ancora modelli'
  },
  searchbar: {
    placeholder: 'Digita per cercare (Es: `Federico Chiesa´)',
    players: 'Giocatori',
    teams: 'Squadre',
    games: 'Partite',
    leagues: 'Campionati',
    explore: 'Cerca più risultati',
    placeholderNoResults: 'Non esistono risultati per la rosa',
    teamPlaceholder: 'Per confrontare una squadra, cercarla e selezionarla'
  },
  favorites: {
    showOnly: 'Mostra solo',
    selfFavorites: 'I miei Favoriti',
    clubFavorites: 'Favoriti del club',
    contractExpiration: 'Scadenza contratto',
    groupBy: 'Raggruppa per',
    noGrouped: 'Non raggruppare',
    maxSelection: 'Massimo',
    selectAtleastOne: 'Seleziona almeno uno',
    comparePlayers: 'Confronta giocatori',
    selectedPlayers: 'selezionati',
    subtitle: 'Gestisci i tuoi favoriti',
    generateXlsx: 'Crea XLSX',
    generating: 'Creando...',
    subscribed: 'Subscribed',
    subscribedTooltip: 'Subscribe to recieve a mail when a game have been played',
    deleteSelected: 'Elimina selezionato'
  },
  expiration: {
    summer: 'Estate',
    winter: 'Inverno'
  },
  positions: {
    noposition: 'Nessuna Posizione',
    goalkeeper: 'Portiere',
    goalkeepers: 'Portieri',
    defender: 'Difensore',
    defenders: 'Difensori',
    defenses: 'Difensori',
    fullback: 'Terzino',
    fullbacks: 'Terzini',
    midfielder: 'Centrocampista',
    midfielders: 'Centrocampisti',
    winger: 'Ala',
    wingers: 'Ali',
    forward: 'Attaccante',
    forwards: 'Attaccanti',
    wingback: 'Terizino fluidificante',
    wingbacks: 'Terizini fluidificanti'
  },
  dPos: {
    1: {
      name: 'Goalkeeper',
      alias: ''
    },
    2: {
      name: 'Right Full Back',
      alias: 'RFB'
    },
    3: {
      name: 'Right Center Back',
      alias: 'RCB'
    },
    4: {
      name: 'Left Center Back',
      alias: 'LCB'
    },
    5: {
      name: 'Left Full Back',
      alias: 'LFB'
    },
    6: {
      name: 'Defensive Midfielder',
      alias: 'DM'
    },
    7: {
      name: 'Right Winger',
      alias: 'RW'
    },
    8: {
      name: 'Center Midfielder',
      alias: 'CM'
    },
    9: {
      name: 'Striker',
      alias: 'ST'
    },
    10: {
      name: 'Attacking Midfielder',
      alias: 'AM'
    },
    11: {
      name: 'Left Winger',
      alias: 'LW'
    }
  },
  charts: {
    seasonsCompareSelectLabel: 'Confronta con',
    lastSeasonSelectText: 'Stagione Precedente',
    lastAndCurrentSeasonSelectText: 'Stagione attuale + Precedente',
    currentSeasonSelectText: 'Stagione in corso',
    lastNgamesSelectText: 'Ultime {x} partite',
    npgVsXGTitle: 'Non Penalty Goals VS xG',
    totalXGLabel: 'Totale xG',
    xGLabel: 'xG',
    totalNPGLabel: 'Non Penalty Goals Totali',
    xGAgainstvsNPGAgainstTitle: 'xG subiti VS Non Penalty Goals subiti',
    totalXGAgainstLabel: 'xG subiti Totali',
    xGAgainstLabel: 'xG subiti',
    totalNPGAgainstLabel: 'Totale Non Penalty Goals subiti',
    xGvsxGAgainstTitle: 'xG VS xG subiti',
    pointsVsXPointsTitle: 'Punti Ottenuti VS Punti Previsti',
    xTTitle: 'Controllo della Partita',
    totalXPoints: 'Punti Previsti Totali',
    totalPoints: 'Punti Totali',
    requestedReports: 'Report Richiesti',
    playersScouted: 'Giocatori osservati',
    performanceVSAverageChart: 'Rendimento VS Media',
    perPositions: 'Per Posizione',
    perLeagues: 'Per Campionato',
    perMonths: 'Al Mese',
    perClients: 'Per Cliente',
    ofPreposition: 'di',
    idJChartTitle: 'Iniziativa di Gioco',
    idJChartLabel: 'Indice IdJ',
    vJOChartTitle: 'Volume Gioco Offensivo',
    vJOChartLabel: 'Indice VJO',
    preJOChartTitle: 'Precisione Gioco Offensivo',
    preJOChartLabel: 'Indice PreJO',
    proJOChartTitle: 'Progressione Gioco Offensivo',
    proJOChartLabel: 'Indice ProJO',
    chart: 'Grafico',
    table: 'Tabella',
    showLeaguesWithAtLeast: 'Mostra le ligue con almeno',
    playersScoutedSuffix: 'giocatori osservati'
  },
  table: {
    history: {
      season: 'Stagione',
      team: 'Squadra',
      position: 'Posizione',
      side: 'Lato',
      games: 'Partite',
      minutes: 'Min',
      goals: 'NPG (G)',
      assists: 'A',
      yellowCards: 'YC',
      redCards: 'RC',
      gameLost: 'GM',
      gamesMissed: 'Partite Assente',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: 'Stagione',
      team: 'Squadra',
      injury: 'Infortunio',
      dateFrom: 'Data Inizio',
      dateTo: 'Data Fine',
      daysLost: 'Giorni Persi',
      gamesLost: 'Partite Perse',
      allInjuries: 'Tutti gli Infortuni'
    },
    transfers: {
      season: 'Stagione',
      date: 'Data',
      teamFrom: 'Squadra Precedente',
      teamTo: 'Squadra di Destinazione',
      marketValue: 'Valore di Mercato',
      fee: 'Costo',
      type: 'Tipo'
    },
    caps: {
      team: 'Squadra',
      debut: 'Debutto',
      games: 'Partite',
      goals: 'Gol',
      coachDuringDebut: 'Debutto Allenatore',
      debutAge: 'Età di Debutto'
    },
    roster: {
      country: 'Paese',
      player: 'Giocatore',
      positions: 'Posizione',
      minutes: 'Minuti',
      games: 'Partite',
      goals: 'Gol',
      assists: 'Assist',
      cards: 'Cartellini',
      gamesExplicit: 'Partite'
    },
    league: {
      title: 'Scheda del campionato',
      subtitle: 'Approfondisci la classifica e le statistiche del campionato',
      team: 'Squadra',
      games: 'PJ',
      gamesExplicit: 'Partite',
      gamesRanking: 'P',
      gamesRankingExplicit: 'Partite',
      points: 'PT',
      pointsExplicit: 'Punti',
      expectedPoints: 'PP',
      expectedPointsExplicit: 'Punti previsti',
      goalsScored: 'GS',
      goalsScoredExplicit: 'Gol segnati',
      xG: 'EG',
      xGExplicit: 'Expected Goals',
      goalsAgainst: 'GS',
      goalsAgainstExplicit: 'Gol subiti',
      xGAgainst: 'GSP',
      xGAgainstExplicit: 'Gol subiti previsti',
      xGAgainstDiff: 'GAS Dif.',
      xGAgainstDiffExplicit: 'Differenza di gol subiti previsti',
      form: 'Forma',
      sos: 'SoS',
      sosExplicit: 'Strength of Schedule',
      sosHfa: 'SoS HFA',
      sosHfaExplicit: 'Home Field Advantage',
      difficultyAboveAvg: 'Difficulty above average',
      differentGames: '* Diverso numero di partite giocate',
      berth: 'Valutazione'
    },
    usersOfClient: {
      userName: 'Nome',
      userRole: 'Utente',
      devRole: 'Sviluppato',
      adminRole: 'Amministratore',
      servicesRole: 'Servizi',
      xgRole: 'XG',
      radarRole: 'Radar',
      beeswarmRole: 'Ranking',
      elevenRole: 'Elevens',
      similarityRole: 'Similarity',
      gameAnalysisRole: 'Analisi partita',
      clientStatsRole: 'Statistiche Cliente',
      created: 'Data Creazione',
      type: 'Tipo',
      logins: 'Accessi',
      lastLogin: 'Ultimo Accesso',
      trialDate: 'Scadenza'
    },
    clientLeagues: {
      league: 'Campionato',
      area: 'Area',
      tier: 'Livello',
      seasons: 'Stagioni',
      currentMatchDay: 'Giornata',
      regular: 'Regolare',
      youthLeague: 'Primavera',
      clientActive: 'Attiva',
      visibleLeagues: 'Campionati visibili',
      male: 'Lega maschile',
      female: 'Lega femminile'
    },
    connections: {
      title: 'Combinazioni più comuni',
      playerFrom: 'Passatore',
      playerTo: 'Ricevitore',
      passes: 'Passaggi',
      passesTooltip: 'Passaggi completati',
      passesFinalThird: 'PUT',
      passesFinalThirdTooltip: 'Passaggi Ultimo ⅓ '
    },
    playerPassMapData: {
      title: 'Statistiche di passaggio',
      player: 'Giocatore',
      passes: 'Passaggi',
      passesPct: '% Passaggi',
      xA: 'xA',
      xG: 'xG',
      xT: 'xT',
      playerTooltip: 'Nome del Giocatore',
      passesTooltip: 'Numero Totale di Passaggi Completati',
      passesPctTooltip: 'Percentuale di passaggi riusciti',
      xATooltip: 'Expected Assists',
      xGTooltip: 'Expected Goals',
      xTTooltip: 'Pericolo Previsto'
    },
    playerAllGames: {
      gameDate: 'Data',
      game: 'Partite',
      team: 'Squadra',
      positionsPlayed: 'Posizioni',
      minsPlayed: 'Minuti',
      gameActions: 'Azioni',
      gameDateTooltip: 'Data Partita',
      gameTooltip: 'Partita',
      positionsPlayedTooltip: 'Posizioni in cui ha giocato',
      minsPlayedTooltip: 'Minuti Giocati',
      gameActionsTooltip: 'Gol, Assist, Cartellini',
      from: 'Inizio',
      to: 'Fine',
      goalText: 'Gol al',
      assistText: 'Assist al',
      penaltyText: 'Rigore al',
      ownGoalText: 'Autogol al',
      yellowCardText: 'Cartellino Giallo al',
      secondYellowCardText: 'Secondo Giallo al',
      redCardText: 'Rosso al',
      substitutionIN: 'Entra al',
      substitutionOUT: 'Esce al',
      suspendedText: 'Squalificato',
      Team: 'Attrezzatura'
    },
    gameFlow: {
      phase: 'Fase',
      mins: 'Minuti',
      team: 'Squadra',
      period: 'Periodo',
      possession: 'Poss',
      possessionTooltip: 'Possesso',
      xT: 'xT',
      xTTooltip: 'Pericolo Previsto',
      pft: 'PU⅓',
      pftTooltip: 'Passaggi Ultimo ⅓',
      xG: 'xG',
      xGTooltip: 'Expected Goals'
    }
  },
  game: {
    title: 'Scheda del gioco',
    subtitle: 'Approfondisci le caratteristiche e le statistiche del gioco',
    header: {
      gameDetails: 'Dettagli della Partita',
      gameStats: 'Stats',
      gameFinishingMap: 'Mappa Finalizzazione',
      gameKeyPassMap: 'Mappa Passaggi Chiave',
      gamePassMap: 'Mappa Passaggi',
      gameThreat: 'Mappa Pericolo',
      gameFlow: 'Controllo della partita',
      gameAnalysis: 'Analisi',
      gamePhysicalStats: 'Statistiche fisiche',
      possessions: 'Possesso',
      bench: 'Panchina',
      video: 'Video highlights',
      preGame: 'Pre-partita',
      postGame: 'Post partita',
      areaCoverage: 'Copertura dell\'area'
    },
    passMap: {
      typeOfPlay: 'Tipo di gioco:',
      passes: 'Passaggi:',
      team: 'Squadra',
      minutes: 'Minuti:',
      select: 'Seleziona',
      all: 'Tutti',
      attacking: 'Attacco',
      defending: 'Difesa',
      forwards: 'Avanti',
      backwards: 'Indietro',
      sideways: 'Sui lati',
      longBall: 'Passaggio lungo',
      successfullPasses: 'Passaggi completati',
      homeTeam: 'Locale',
      awayTeam: 'Ospite',
      passingMatrix: 'Matrice di Passaggio',
      passer: 'Passatore',
      receiver: 'Ricevitore',
      passOutcome: 'Risultato del Passaggio',
      passDirection: 'Direzione del Passaggio',
      half: 'Metà',
      offensive: 'Offensiva',
      defensive: 'Difensiva',
      passingConnections: 'Connessioni di passaggio',
      pitchView: 'Campo',
      passSingular: 'Passaggio',
      passPlural: 'Passaggi',
      playerLocation: 'Posizione del giocatore',
      passLegend: 'Posizione di tocco media',
      minuteRange: 'Intervallo di minuti'
    },
    stats: {
      summary: 'Summary',
      attacking: 'Attacking',
      defending: 'Defending',
      contribution: 'Contribution',
      possession: 'Possesso',
      expectedPoints: 'Punti previsti',
      directness: 'Verticalità',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG da Palla Ferma',
      xA: 'xA',
      xASetPiece: 'xG da Palla Ferma',
      xT: 'xT',
      xTSetPiece: 'xxT da Palla Ferma',
      touchesInOppBox: 'Tocchi in Area Avversaria',
      passesFinalThird: 'Passaggi Ultimo Terzo',
      interceptions: 'Intercetti',
      recoveries: 'Recuperi',
      recoveriesOppHalf: 'Recuperi Metà Campo Avversaria',
      tackles: 'Contrasti',
      tacklesWasDribbled: 'Duelli difensivi 1vs1 vinti',
      fouls: 'Falli',
      yellowCards: 'Cartellini Gialli',
      redCards: 'Cartellini Rossi',
      passes: 'Passaggi',
      passing: 'Passaggi %',
      crosses: 'Cross',
      crossing: 'Cross %',
      shots: 'Tiri',
      shotsOnTarget: 'Tiri in Porta',
      ppdaExplicit: 'Passaggi per Azioni Difensive',
      xgExplicit: 'Expected Goals',
      xp: 'xP',
      ExpectedPassing: 'xP%',
      seasonAvg: 'Media della competizione',
      winChanceTooltip: 'Probabilità vittoria basato su xG creati e concessi',
      drawChance: 'Pareggio',
      xgAgainst: 'xG subiti',
      averagePossession: 'Possesso Palla',
      averageShots: 'Tiri',
      averagexG: 'Expected Goals',
      fieldTilt: 'Field Tilt',
      fieldTiltExplicit: 'Field Tilt',
      recoveriesRate: 'Tasso di recupero',
      turnoversRate: 'Tasso di fatturato'
    },
    detail: {
      halfTime: 'Intervallo',
      overTime: 'Tempi Supplementari',
      showStats: 'Mostra Statistiche',
      hideStats: 'Nascondi Statistiche',
      bench: 'Panchina',
      showShotOptions: 'Mostra opzioni di tiro',
      hideShotOptions: 'Nascondi opzioni di tiro',
      showPassOptions: 'Mostra opzioni di passaggio',
      hidePassOptions: 'Nascondi opzioni di passaggio',
      endGame: 'Fine partita',
      penalties: 'Rigori'
    },
    timeline: {
      events: {
        goal: 'Gol',
        goal_ownGoal: 'Autogol',
        goal_penalty: 'Gol su Rigore',
        card: 'Cartellino',
        card_yellowCard: 'Cartellino Giallo',
        card_secondYellowCard: 'Secondo Giallo',
        card_redCard: 'Cartellino Rosso',
        formationChange: 'Cambio formazione',
        substitution: 'Sostituzione',
        saveShot: 'Tiro parato',
        saveShot_penalty: 'Rigore Parato',
        missedShot: 'Tiro Sbagliato',
        missedShot_penalty: 'Rigore Sbagliato',
        shotOnPost: 'Tiro sul Palo',
        shotOnPost_penalty: 'Rigore sul Palo',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: 'Game Timeline'
    },
    gameFlow: {
      goalOf: 'Gol di',
      redCardTo: 'Rosso a',
      missedPenalty: 'Rigore mancato'
    },
    gameThreat: {
      typeOfPlay: 'Tipo di Azione',
      regularPlay: 'Su Azione',
      setPiece: 'Palla Ferma',
      setPiecePlay: 'Palla Ferma',
      throwInSetPiecePlay: 'Azione da Calcio d\'Angolo',
      throwInPlay: 'Azione da Fallo Laterale',
      gkThrow: 'Tiro del portiere',
      gkKick: 'Calcio di rinvio',
      kickOff: 'Calcio d\'inizio',
      actionEnding: 'Tipo di Finalizzazione',
      pass: 'Passaggio',
      shot: 'Tiro',
      foul: 'Punizione',
      other: 'Altro',
      threat: 'Pericolo',
      legendSumOfXT: 'Somma di xT',
      legendPass: 'Passaggio',
      legendShot: 'Tiro',
      legendCarryAndAction: 'Conduzione e Azione',
      legendCarryAndPass: 'Conduzione e Passaggio',
      legendOnlyShowing: '· Mostra solo azioni individuali con xT > ',
      legendOnlyShowingPart1: 'Mostra solo azioni',
      legendOnlyShowingPart2: 'individuali con xT > ',
      legendOnlyShowingSetPiece: '· Mostra solo azioni da palla ferma con xT > ',
      legendOnlyShowingOpenPlay: '· Mostra solo azioni su azione con xT > ',
      legendPlays: 'Azioni',
      legendPerPlay: 'Per Azione',
      legendCarry: 'Conduzione',
      penaltyPlay: 'Rigore',
      freeKickTakenPlay: 'Azione su Punizione',
      cornerTakenPlay: 'Azione su Calcio d\'Angolo',
      fromCornerPlay: 'Azione da Calcio d\'Angolo',
      keeperThrowPlay: 'Rilancio del portiere',
      fastBreakPlay: 'Contropiede',
      indirectPlay: 'Punizione indiretta',
      minutes: 'Minuti',
      games: 'Partite',
      xT: 'xT',
      xTPer90: 'xT per 90\''
    },
    gameAnalysis: {
      next: 'Successiva',
      previous: 'Precedente',
      phaseLabel: 'Fase',
      phasesLabel: 'Fasi',
      dot: '.',
      comma: ', ',
      from: 'Dal',
      to: 'Al',
      and: ' e ',
      steps: {
        finishingMapFullGame: 'Mappa Finalizzazione',
        keyPassMapFullGame: 'Mappa Passaggi Chiave',
        gameFlow: 'Controllo Partita',
        finishingMapPerPhases: 'Finalizzazioni Fasi',
        keyPassMapPerPhases: 'Passaggi Chiave Fasi',
        passMapPerPhases: 'Mappa Passaggi Fasi'
      },
      step1: {
        table: {
          draw: 'Pareggio',
          win: 'Vittoria',
          lose: 'Sconfitta',
          possession: 'Possesso',
          xP: 'Punti Previsti',
          directness: 'Verticalità',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG su Azione',
          xGSetPiece: 'xG da Palla Ferma',
          xA: 'xA',
          xAOpenPlay: 'xA su Azione'
        },
        text: {
          firstParagraph: {
            1: 'La mappa di destra mostra gli Expected Goals creati da home_team_name e dal away_team_name. I cerchi pieni sono tiri che si sono trasformati in gol. La dimensione dei cerchi dipende dal valore xG di ogni tiro.'
          },
          lastParagraph: {
            1: 'Dai tiri vengono calcolate la probabilità di vittoria e il numero di punti attesi (100.000 simulazioni di ogni tiro prendendo in considerazione la sua probabilità di gol).'
          },
          targetHighTeamXG: {
            1: 'target_team_name, così come rival_team_name, hanno creato un alto volume di Expected Goals'
          },
          targetHighTeamOpenPlayXG: {
            1: 'In questa partita, la maggior parte delle occasioni del target_team_name vengono su azione'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: 'In questo incontro, la maggior parte delle occasioni del target_team_name vengono su azione (a differenza del rival_team_name)'
          },
          targetHighTeamSetPieceXG: {
            1: 'in questa partita, la maggior parte delle occasioni del target_team_name sono state create da palla ferma'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: 'In questo incontro, la maggior parte delle occasioni del target_team_name sono state create da palla ferma (a differenza del rival_team_name)'
          },
          targetHighTeamCornerXG: {
            1: 'In questo incontro, la maggior parte delle occasioni del target_team_name sono state create da calcio d\'angolo'
          },
          targetLowTeamGoalConversion: {
            1: ' ma la trasforamazione in gol fu bassa'
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name ha creato un alto volume di Expected Goals, sia su azione che da palla ferma'
          },
          targetHighTeamGoalConversion: {
            1: ' ottenendo, inoltre, un\'alta capacità di trasformare queste occasioni in gol. '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', essendo incapace di segnare nessuna delle occasioni create'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' ma creò pericoli per segnare più gol'
          },
          targetHighTeamXGvsGameRival: {
            1: 'In questo incontro, target_team_name creò più pericoli che rival_team_name'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' e avrebbe potuto segnare più gol. '
          },
          targetHighTeamXGZeroGoals: {
            1: ' ma non fu in grado di approfittare delle occasioni create per fare gol. '
          },
          targetHighTeamXGGoalDiff: {
            1: ' con una opportunità di vincere del team_winning_chance secondo la nostra simulazione post-partita. '
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' La maggioranza delle opportunità del target_team_name vengono su azione. '
          },
          startTargetHighTeamSetPieceXG: {
            1: ' La maggioranza delle occasioni create dal target_team_name nascono da palla ferma. '
          },
          startTargetHighTeamCornerXG: {
            1: ' La maggioranza delle occasioni create provengono da calcio d\'angolo. '
          },
          targetSimilarTeamXG: {
            1: 'Durante questa partita, per quanto riguarda gli Expected Goals, entrambe le squadre provocarono all\'avversario un xG simile, '
          },
          targetSimilarTeamXGGoalDiff: {
            1: 'ma target_team_name fece meglio finalizzando queste occasioni. '
          },
          targetLowTeamXGGoalDiff: {
            1: 'Senza prendere in considerazione il risultato, target_team_name non provocò molti pericoli alla squadra avversaria per quanto riguarda gli Expected Goals.'
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name non creò sufficienti pericoli alla squadra avversaria per quanto riguarda gli Expected Goals per vincere l\'incontro'
          },
          rivalHighTeamXG: {
            1: 'e ha permesso a rival_team_name di provocargli molto pericolo. '
          },
          rivalHighTeamXGGoalDiff: {
            1: ' Questa è una partita che target_team_name vincerebbe solamente un team_winning_chance delle volte secondo la nostra simulazione post-partita. '
          },
          targetHighTeamGoalConversion2: {
            1: ' ottenendo un alto coefficiente di trasformazione in gol'
          },
          winningChance: {
            1: ' Dato il numero dei tiri e gli xG di entrambe le squadre, target_team_name avvrebbe dovuto vincere questa partita team_winning_chance delle volte. '
          },
          highPlayerXGManyShots: {
            1: ' È interessante osservare che player_name creò xg_value xG nel shots_value dei tiri'
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' avendo bisogno xg_value xG per segnare un gol. '
          },
          highPlayerXGOneGoal: {
            1: ' per segnare un gol. '
          },
          highPlayerXGAnyGoal: {
            1: ', anche se non ha potuto segnare nessun gol. '
          },
          highPlayerXGNotManyShots: {
            1: 'È interessante osservare che player_name creò xg_value xG in pochi tiri'
          },
          highManyPlayerXG: {
            1: 'È interessante osservare che el player_name e il player_name2 crearono xg_value e xg_value2 <b>xG</b> rispettivamente. '
          },
          highTeamXGPerShot: {
            1: 'Per quanto riguarda la scelta dei tiri realizzati del target_team_name, furono molto buone in termine di probabilità di trasformarsi in gol, con una media di xG ogni tiro de xg_per_shot_value. '
          },
          highTeamXGPerShotVSGameRival: {
            1: 'La scelta dei tiri del target_team_name fu migliore di quella del rival_team_name, avendo una media di xg_per_shot_value xG ogni tiro. '
          },
          xGTimesNotAfter70xG: {
            1: 'Nonostante l\'alto XG creato, target_team_name ha avuto problemi per creare pericoli alla fine della partita. '
          },
          xGTimesBefore25xG: {
            1: 'target_team_name creò molti pericoli soprattutto all\'inizio dei due tempi. '
          },
          xGTimesAfter25xG: {
            1: 'target_team_name creò molti pericoli soprattutto alla fine dei due tempi. '
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name creò la maggior parte dei pericoli all\'inizio del primo tempo. '
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name creò la maggior parte dei pericoli alla fine del primo tempo. '
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name creò la maggior parte dei pericoli all\'inizio del secondo tempo. '
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name creò la maggior parte dei pericoli alla fine del secondo tempo. '
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name iniziò bene la partita con occasioni che crearono xg_value <b>gol previsiti</b>. '
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name terminò il primo tempo con occasioni che crearono xg_value gol previsiti. '
          },
          xGTimesBefore70xG: {
            1: 'target_team_name uscì dagli spogliatoi con occasioni che crearono xg_value gol previsiti. '
          },
          xGTimesAfter70xG: {
            1: 'target_team_name terminò il secondo tempo con occasioni che crearono xg_value gol previsiti. '
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name creò molti pericoli alla fine del secondo tempo. '
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name creò molti pericoli all\'inizio del secondo tempo. '
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name creò molti pericoli alla fine del primo tempo. '
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name creò molti pericoli alla fine del primo tempo. '
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name creò la maggior parte dei pericoli nel primo tempo, mentre rival_team_name fu pericoloso nel secondo tempo. '
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name creó la maggior parte dei suoi pericoli nel secondo tempo, mentre rival_team_name fu pericoloso nel secondo tempo. '
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: 'È una partita nella quale la maggior parte del pericolo in termini di esxpected gol si creò durante il primo tempo. '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: 'È una partita nella quale la maggiora parte dei pericoli in termini di Expected Goals si creò durante il secondo tempo. '
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name riuscì a creare la maggior parte dei pericoli nel primo tempo. '
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name riuscì a creare la maggior parte dei pericoli nel secondo tempo. '
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name ha permesso la maggior parte dei pericoli in termini di Expected Goals nel primo tempo. '
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name ha permesso a maggior parte dei pericoli in termini di Expected Goals nel secondo tempo. '
          },
          highInBoxXG: {
            1: ' Possiamo vedere nella mappa dei tiri come la maggior parte del pericolo arrivino da tiri da dentro l\'area. '
          },
          highOutOfBoxXG: {
            1: 'Possiamo vedere nella mappa dei tiri che, in questa partita, target_team_name creò molti pericoli da fuori area. '
          },
          highInBoxXGRival: {
            1: 'Vogliamo segnalare che la maggior parte dei pericoli concessi da target_team_name provengano da tiri da dentro l\'area. '
          },
          highInBoxXGRival2: {
            1: ' Inoltre è interessante segnale che la maggior parte dei pericoli concessi da target_team_name provengano da tiri da dentro l\'area. '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name si difese bene evitando il pericolo dentro l\'area. '
          },
          highTeamChancesHighPPDARival: {
            1: 'La mancata pressione del target_team_name, permettendo ppda_value passaggi per azione difensiva, fu una delle chiavi di lettura del rival_team_name per creare un alto numero di occasioni. '
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name ha permesso solo ppda_value passaggi per azione difensiva, rappresentando una delle chiavi per la vittoria.'
          },
          lowPPDA: {
            1: 'target_team_name ha fatto un gran lavoro fermando le giocate del rival_team_name permettendo solo una media di ppda_value passaggi per azione difensiva. '
          },
          highPossession: {
            1: 'target_team_name ha tenuto il controllo della palla con un possession_value di possesso'
          },
          highPPDARival: {
            1: ' così come una distribuzione fluida del pallone'
          },
          chancesCreated: {
            1: ', permettendogli di avere un alto numero di opportunità su azione (chances_value). '
          },
          chancesCreatedRival: {
            1: ', anche se il rival_team_name fu capace di creare un gran numero di occasioni su azione (chances_value). '
          },
          xGPerShotRival: {
            1: ', anche se il rival_team_name fu capace di creare più occasioni pericolose con un valore xg_per_shot_value <b>xG ogni tiro</b>. '
          },
          winGame: {
            1: ' essendo una delle chiavi per vincere la partita. '
          },
          notEnoughWinGame: {
            1: ' essendo insufficiente per vincere la partita. '
          },
          goalsFromErrorsFirstGoal: {
            1: 'Il primo gol è arrivato da un errore del player_error_name sfruttato da player_name'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: 'Il primo e unico gol è arrivato da un errore del player_error_name sfruttato da player_name'
          },
          lastPhaseOfGame: {
            1: ' nell\'ultima parte dell\'incontro. '
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: 'Il gol final per vincere la partita è arrivato da un errore del player_error_name portando al gol di player_name. '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: 'Il gol final per pareggiare la partita è arrivato da un errore del player_error_name portando al gol di player_name. '
          },
          goalsFromErrorsGoalToTie: {
            1: 'Un errore del player_error_name portò all\'opportinutà di pareggiare la partita per target_team_name'
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name si portò in vantaggio approfittando di un errore di player_error_name'
          },
          xGChance: {
            1: ' con una possaibilità di xg_value <b>xG</b>. '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'Il gol finale di rival_team_name per vincere la partita è arrivato da un errore di player_error_name portando al gol di player_name. '
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'Un errore del player_error_name portó all\'opportunità di pareggiare la partita per rival_team_name'
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name si portó in vantaggio approfittando di un errore di player_error_name'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name segnò la unica grande occasione creata durante la partita, cioè, il gol di player_name che vediamo nella mappa Expected Goals con un <b>xG</b> di xg_value. '
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name segnò tutte le grandi occasioni create durante la partita'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name ha avuto la unica grande occasione da gol del target_team_name con un <b>xG</b> di xg_value. '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name non fu capace di segnare nessuna delle chances_value occasioni al di spora del 40% di probabilità di trasformarsi in gol. '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name ha avuto una grande opportunità di xg_value <b>xG</b> per portarsi in vantaggio. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name ha avuto chances_value occasioni con <b>xG</b> superiore al 40% per portarsi in vantaggio. '
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name ha avuto chances_value occasioni con alto <b>xG</b> per portarsi in vantaggio. '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name ha avuto un\'opportunità di xg_value <b>xG</b> per portare in vantaggio la propria squadra, ma prese il palo. '
          },
          beforeEndOfGame: {
            1: 'Prima di finire la partita, '
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name ha avuto un\'opportunità di xg_value <b>xG</b> per vincere la partita. '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name ha avuto chances_value occasioni con una probabilità di gol superiore al 40% per raggiungere i 3 punti. '
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name ha avuto chances_value occasioni con un alto <b>xG</b> per vincere la partita. '
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name apporfittò di una grande occasione di xg_value <b>xG</b> per portare in vantaggio la sua squadra. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name ha avuto chances_value opportunità con un <b>xG</b> al di sopra del <b>40%</b> per potersi portare in vantaggio nella partita. '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name approfittò chances_value occasioni con un alto xG per portarsi in vantaggio. '
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name approfittò di una occasione con un xg_value <b>xG</b> per portare in vantaggio la squadra ma il tiro finì sul palo. '
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name ha avuto una opportunità di xg_value <b>xG</b> per pareggiare la partita ma non ebbe fortuna. '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name ha avuto chances_value opportunità per pareggiare la partita con un probabilità di segnare un gol al di sopra del 30%. '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name ha avuto una occasione di xg_value <b>xG</b> per pareggiare la partita ma il tiro finì sul palo. '
          }
        }
      },
      step2: {
        table: {
          draw: 'Pareggio',
          win: 'Vittoria',
          possession: 'Possesso',
          xP: 'Punti Previsti',
          directness: 'Verticalità',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA su Azione',
          xASetPiece: 'xA da Palla Ferma',
          chancesCreated: 'Occasioni Create',
          shotsOnTarget: 'Tiri in Porta'
        },
        text: {
          firstParagraph: {
            1: 'La immagine mostra gli <b>Expected Assist</b> di <b>home_team_name</b> e <b>away_team_name</b>.'
          },
          xAPerKeyPass: {
            1: ' xA per ogni Passaggio chiave. '
          },
          keyPassesGeneratedFrom: {
            1: ', specialmente passaggi chiave creati da '
          },
          highTeamXAvsXG: {
            1: 'Come possiamo vedere nella mappa degli xA, la maggior parte dei pericoli creati da target_team_name proviene da combinazioni più che da azioni individuali'
          },
          openPlay: {
            1: 'su azione'
          },
          setPiece: {
            1: 'da palla ferma'
          },
          cornerKicks: {
            1: 'da calcio d\'angolo'
          },
          combinationPlays: {
            1: 'combinazioni'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: 'In questa partita, target_team_name creò pericoli con combinazioni'
          },
          individualActions: {
            1: ' ma anche con azioni individuali.'
          },
          dangerFromIndividualActions: {
            1: 'In questa partita, la maggior parte dei pericoli creati da target_team_name sono nati da azioni individuali.'
          },
          highTeamXAvsXGRival: {
            1: ' Le opportunità che target_team_name ha concesso durante la partita provengono da combinazioni come possiamo vedere nella mappa di xA.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name si mise in evidenza nei passaggi chiave creati'
          },
          manyPlayerKeyPasses: {
            1: 'È interessante segnalare che <b>player_name</b> creò <b>xa_value xA</b> in <b>key_passes passaggi chiave</b>'
          },
          playerAssists: {
            1: ' avendo bisogno di <b>xa_per_assist xA per assist</b>.'
          },
          giveAssist: {
            1: ' per fare l\'assist.'
          },
          noAssists: {
            1: ', anche se nessuno dei suoi passaggi si trasformò in assist.'
          },
          highXANotManyShots: {
            1: 'È interessante segnalare che <b>player_name</b> creò <b>xa_value xA</b> in pochi passaggi'
          },
          manyPlayersHighXA: {
            1: 'È interessante segnalare che <b>player_name</b> e <b>player_name2</b> crearono <b>xa_value</b> e <b>xa_value2 xA</b> rispettivamente.'
          },
          xATimes: {
            1: 'target_team_name creò la maggior parte dei pericoli nella prima parte, mentre rival_team_name nel '
          },
          firstHalf: {
            1: ' Primo Tempo.'
          },
          secondHalf: {
            1: ' Secondo Tempo.'
          },
          left: {
            1: 'lato sinistro '
          },
          center: {
            1: 'centro '
          },
          right: {
            1: 'lato destro '
          },
          xAFirstHalfFirstHalfRival: {
            1: 'È una partita dove la gran parte dei pericoli, per quanto riguardo gli Expected Goals, furono creati durante il '
          },
          xAFirstHalf: {
            1: 'target_team_name causò la maggior parte dei pericoli '
          },
          xATimesXARival: {
            1: 'target_team_name ha concesso troppi pericoli in termini di Expected Goals nel '
          },
          xASides: {
            1: ' La maggior parte dei pericoli creati da target_team_name è stato prodotto da side_name (<b>xa_value xA</b>)'
          },
          xASidesRival: {
            1: 'mentre rival_team_name creò la maggior parte da side_name (<b>xa_value xA</b>)'
          },
          dangerCreationRival: {
            1: 'I pericoli di rival_team_name viene, specialmente, da side_name (<b>xa_value xA</b>).'
          },
          speciallyEffective: {
            1: 'target_team_name fu particolarmente efficace in '
          },
          xAPerChanceCreated: {
            1: ' con una media di <b>xa_value xA</b>'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name fu particolarmente efficace in '
          }
        }
      },
      step3: {
        text: {
          chance: ' occasione',
          chances: ' occasioni',
          goal: ' gol',
          goals: ' gol',
          home: 'locale',
          away: 'ospite',
          last: 'ultima',
          first: 'priima',
          goalScorer: 'il marcatore',
          goalScorers: 'i marcatori',
          lastPhase: 'Nella fase finale della partita, ',
          phase: {
            1: 'In questa phase_position fase della partita, '
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b> ha creato più pericoli (<b style=\'color:more_color\'>more_xt_team_value xT</b>) di <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>)'
          },
          sameTeamMoreMinutes: {
            1: 'e lo ha fatto per più minuti di gioco (<b style=\'color:more_color\'>more_time_xt_minutes mins.</b> rispetto a <b style=\'color:less_color\'>less_time_xt_minutes mins.</b> dell\'avversario)'
          },
          rivalTeamMoreMinutes: {
            1: 'tuttavia, è stato l\'avversario a creare pericoli più a lungo (<b style=\'color:more_color\'>more_time_xt_minutes mins.</b> vs <b style=\'color:less_color\'>less_time_xt_minutes mins.</b> del rival) in questo periodo della partita'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b> fu la squadra che creò più pericoli (<b style=\'color:max_color\'>max_xt_team_value xT</b>) al <b style=\'color:max_color\'>max_xt_team_minute\'</b>'
          },
          maxXTValueRival: {
            1: ', mentre <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b> creò il maggior pericolo (<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>) al <b style=\'color:max_rival_color\'>max_xt_rival_team_minute\'</b>'
          },
          bothTeamsScoreButDraw: {
            1: 'Entrambe le squadre riuscirono a battere il portiere della squadra avversaria con <b>number_of_goals_each_team</b> ognuno. La squadra locale attraverso <b style=\'color:#3366FF\'>home_player_name_goals</b> e la squadra ospite attraverso <b>away_player_name_goals</b>'
          },
          oneTeamTakesTheLead: {
            1: 'in termini di gol, <b style=\'color:replace_color\'>goal_scored_team_name</b> ha sconfitto l\'avversario per <b style=\'color:replace_color\'>difference_number_of_goals</b> di differenza, essendo <b style=\'color:replace_color\'>home_player_name_goals</b> goal_scorer_word della squadra'
          }
        }
      },
      step4: {
        table: {
          team: 'Squadra',
          period: 'Periodo',
          possession: 'Poss.',
          ppda: 'PPDA',
          xGOpenPlay: 'xG Azione',
          tooltip: {
            team: 'squadra',
            period: 'periodo',
            possession: 'possesso',
            ppda: 'passaggi per azione difensiva',
            xGOpenPlay: 'xG Azione'
          }
        },
        text: {
          clearly: 'chiaramente',
          very: 'molto ',
          haveGotText1: 'raggiunse solamente',
          haveGotText2: 'avrebbe dovuto raggiungere più di',
          gaveUpPoss: 'rinunciò al possesso della palla',
          lostPoss: 'perse il possesso della palla',
          too: 'anche ',
          possession: {
            1: 'Durante questa fase della partita, <b style=\'color:team_color\'>team_name</b> clearly_text ha avuto il possesso della palla'
          },
          equalPossession: {
            1: 'In questa parte della partita nessuna delle due squadre ha dominato l\'altra in quanto la gestione della palla è stata abbastanza equilibrata, anche se guardando i numeri, <b style=\'color:team_color\'>team_name</b> ha superato leggermente l\'avversario con un <b style=\'color:team_color\'>possession_value%</b> di possesso'
          },
          lowPossessionHighPPDA: {
            1: '. <b style=\'color:target_team_color\'>target_team_name</b> con una cattiva pressione consentita <b style=\'color:rival_team_color\'>rival_team_name</b> dare <b style=\'color:target_team_color\'>ppda_value passaggi per azione difensiva</b>'
          },
          lowPossessionLowPPDA: {
            1: ', ma <b style=\'color:target_team_color\'>target_team_name</b> fece un buon pressing quando rival_team_name aveva il possesso, con un <b>PPDA</b> di <b>ppda_value</b>'
          },
          highPossessionLowPPDA: {
            1: ' e fu capace di giocare grazie a very_textbassa intensità nel pressing del rival_team_name'
          },
          highPossessionHighPPDA: {
            1: ' anche se l\'intensità nel pressing del rival_team_name fu very_text alta'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> ebbe un grande possesso palla effettuando <b>pft_value</b> <b>Passaggi negli Ultimi 35 metri</b> di campo. '
          },
          highPossessionMidLowPFT: {
            1: 'Indipendentemente dell\'alto possesso, <b style=\'color:target_team_color\'>target_team_name</b> have_got_text <b>pft_value</b> <b>Passaggi negli Ultimi 35 metri</b>. '
          },
          lowPossessionHighPFT: {
            1: 'Anche se <b style=\'color:target_team_color\'>target_team_name</b> possession_text durante questa fase, fu capace di effettuare <b>pft_value</b> <b>Passaggi negli Ultimi 35 metri</b>. '
          },
          midPossessionHighPFT: {
            1: 'Un possesso palla abbastanza uniforme durante questa fase non ha impedito <b style=\'color:target_team_color\'>target_team_name</b> effettuasse <b>pft_value</b> <b>Passaggi negli Ultimi 30 metri</b>. '
          },
          highPFTHighTouchesIOB: {
            1: 'Oltre a controllare il gioco nell\'ultimi 30 metri, <b style=\'color:target_team_color\'>target_team_name</b> Ha avuto molta presenza anche nell\'area avversaria'
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> ha avuto il possesso negli ultimi 30 metri, ma non ha potuto far arrivare molti palloni nell\'area avversaria'
          },
          highPFTMidTouchesIOB: {
            1: 'Visto il numero di <b>Passaggi negli Ultimi 30 metri</b>, <b style=\'color:target_team_color\'>target_team_name</b> avrebbe dovuto creare più pericoli nell\'area avversaria'
          },
          lowPFTHighTouchesIOB: {
            1: 'Anche se <b style=\'color:target_team_color\'>target_team_name</b> non completò molti passaggi negli ultimi 35 metri, fu in grado di arrivare nell\'area avversaria in molte occasioni. '
          },
          midPFTHighTouchesIOB: {
            1: 'Visto il numero di passaggi completati negli ultimi 30 metri, <b style=\'color:target_team_color\'>target_team_name</b> fu in grado di arrivare nell\'area avversaria in molte occasioni. '
          },
          maxDirectness: {
            1: 'Va notato che questa è la fase del gioco in cui <b style=\'color:max_dir_color\'>target_team_name</b> giocava in maniera più offensiva con una <b>Verticalità</b> di <b>directness_value</b>. '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> fu in grado di creare più xG di ogni altra fase della partita. '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> riuscì a creare un alto numero di Expected Goals'
          },
          highXG: {
            1: 'creò un buon numero di Expected Goals'
          },
          highXGLowPossession: {
            1: ' pur non avendo il possesso della palla'
          },
          highXGLowShots: {
            1: ' solo in pochi tiri, avendo un <b>xG por Tiro</b> di <b>xg_per_shot_value</b>'
          },
          highXGLowXGPerShot: {
            1: ' anche se gli xG per Tiro fu too_textbajo. '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> non fu in grado di creare pericoli all\'avversario'
          },
          lowXGMinXG: {
            1: 'In termini di costruzione di Expected Goals, fu un momento povero per <b style=\'color:target_team_color\'>target_team_name</b>'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> creò un volume basso di Expected Goals'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> non fu in grado di creare un buon numero di Expected Goals'
          },
          lowXGHighPossession: {
            1: ' anche se ebbero il controllo della palla. '
          },
          lowXGHighShots: {
            1: ' nonostante aver effettuato diversi tiri'
          },
          lowXGHighPFT: {
            1: ' nonostante aver completato <b>pft_value</b> <b>Pases negli Ultimi 30 metri di Campo</b>. '
          },
          midXGQuintileMinXG: {
            1: 'Anche se la costruzione di xG fu buona, questa fu la fase più scarsa della partita per <b style=\'color:target_team_color\'>target_team_name</b> in questa sezione'
          },
          midXGQuintileMaxXG: {
            1: 'Questa fu la fase nella quale <b style=\'color:target_team_color\'>target_team_name</b> fu in grado di creare il migliore <b>xG (xg_value)</b>'
          }
        }
      },
      step5: {
        table: {
          team: 'Squadra',
          period: 'Periodo',
          possession: 'Poss.',
          directness: 'Vert.',
          passesFinalThird: 'PUT',
          tooltip: {
            team: 'Squadra',
            period: 'Periodo',
            possession: 'Possesso',
            directness: 'Verticalità',
            passesFinalThird: 'Passaggi ultimo ⅓'
          }
        },
        text: {
          last: 'ultima',
          goal: 'gol',
          goals: 'gol',
          chance: 'occasione',
          chances: 'occasioni',
          first: 'prima',
          homeTeam: 'Locali',
          awayTeam: 'Ospiti',
          home: 'locale',
          away: 'ospite',
          clearly: 'chiaramente',
          slightly: 'leggermente',
          firstOrLastPhase: {
            1: 'In questa phase_position fase della partita, ',
            2: 'Per quanto riguarda la phase_position fase della partita, '
          },
          phase: {
            1: 'Durante questa fase della partita, '
          },
          bothZeroGoalsScored: {
            1: 'senza poter cambiare il punteggio nessuna delle due squadre.'
          },
          equalGoalsScored: {
            1: 'riuscendo a segnare <b>number_goals</b>'
          },
          differentGoalsScored: {
            1: 'riuscendo a segnare'
          },
          equalPossesion: {
            1: 'entrambe le squadre hanno tenuto il pallone esattamente un <b>poss_value%</b> del tempo'
          },
          morePossesion: {
            1: '<b>more_poss_team_name</b> ha tenuto il possesso per più minuti (<b>more_poss_team_value%</b> del tiempo) rispetto all\'avversario (<b>less_poss_team_value%</b> del tempo)'
          },
          equalDirectness: {
            1: 'le due squadre hanno sviluppato un gioco con la stessa verticalità (<b>directness_value</b> ognuno)'
          },
          moreDirectnessSameTeam: {
            1: 'Inoltre, sono stati anche più verticali del loro avversario, sviluppando un gioco con una verticalità di <b>more_dir_team_value</b> rispetto a <b>less_dir_team_value</b>.'
          },
          moreDirectnessDifferentTeam: {
            1: 'tuttavia, è stata la squadra ospite che ha giocato in maniera più verticale (<b>more_dir_team_value</b>) rispetto a <b>less_dir_team_value</b>.'
          },
          equalChancesCreated: {
            1: 'Sia i locali che gli ospiti hanno creato lo stesso numero di occasioni, in particolare <b>chances_created_value</b> occasioni.'
          },
          moreChancesCreated: {
            1: '<b>less_cc_team_name</b> ha creato solo <b>less_cc_team_value occasioni</b> per questo che è stato superato adverb_text dal suo avversario (<b>more_cc_team_value occasioni create</b>). '
          },
          equalXA: {
            1: 'Sia i locali che gli Ospiti hanno avuto le stesse occasioni, come indica il <b>xa_value di Expected Assist</b>, '
          },
          moreXA: {
            1: 'La squadra ospite ha creato <b>diff_xa_team_value Expected Assist</b> (<b>more_xa_team_value</b> rispetto a <b>less_xa_team_value</b>) più dell\'avversario, '
          },
          xAOpenPlay: {
            1: 'creando, rispettivamente, <b>more_xa_op_value</b> e <b>less_xa_op_value</b> con il pallone in gioco.'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' ognuno',
          respectively: ', rispettivamente',
          with: ' (insieme a <b style=\'color:replace_color\'>other_player_name</b>)',
          playerWas: 'giocatore è stato',
          playerWere: 'giocatori sono stati',
          firstPhase: {
            1: 'In questa parte della partita, notiamo',
            2: 'Rispetto alla prima parte dell\'incontro, notiamo'
          },
          otherPhase: {
            1: 'Tra il <b style=\'color:replace_color\'>min_from\'</b> e il <b style=\'color:replace_color\'>min_to\'</b> notiamo'
          },
          lastPhase: {
            1: 'Nell\'ultima parte dell\'incontro, notiamo ',
            2: 'Per quanto riguarda l\'ultima fase della partita, notiamo '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>player_name</b> con il maggior numero di passaggi completati della sua squadra, in particolare <b style=\'color:replace_color\'>successfull_passes_value passaggi</b> '
          },
          playerMaxTotalPasses: {
            1: 'questo assume ancora di più valore vedendo che è stato anche'
          },
          playerMaxTotalPasses2: {
            1: 'with_text il giocatore con più passaggi tentati (<b style=\'color:replace_color\'>total_passes_value passaggi</b>). '
          },
          playerNotMaxTotalPasses: {
            1: 'anche se non è stato colui che ha tentato più passaggi (<b style=\'color:replace_color\'>player_name</b> con <b style=\'color:replace_color\'>total_passes_value pases</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: 'cercando in questa fase <b style=\'color:replace_color\'>total_passes_value pases</b> ognuno. '
          },
          playerMaxPctPasses: {
            1: 'Per quanto riguarda <b style=\'color:replace_color\'>% di Passaggi Completati</b> si evidenzia <b style=\'color:replace_color\'>player_name</b> con un alto <b style=\'color:replace_color\'>max_pct_passes_value%</b>. ',
            2: 'Per quanto riguarda la percentuale riuscita dei passaggi, si deve menzionare <b style=\'color:replace_color\'>player_name</b> con un <b style=\'color:replace_color\'>max_pct_passes_value%</b> di efficacia dei suoi passaggi. '
          },
          playerSumTotalXG: {
            1: 'In questa parte, la squadra ha creato un totale di <b style=\'color:replace_color\'>sum_xg_value xG</b>, ',
            2: 'Durante questa parte, il <b style=\'color:replace_color\'>team_name</b> ha creato un <b style=\'color:replace_color\'>xG</b> di <b style=\'color:replace_color\'>sum_xg_value</b>, '
          },
          ZeroSumXG: {
            1: 'Nonostante faccia un totale di <b style=\'color:replace_color\'>all_team_total_passes pases</b> tra tutta è stato inutile visto che non è riuscito a crear neanche una occasione. ',
            2: 'Gli <b style=\'color:replace_color\'>all_team_total_passes pases</b> realizzati in questo periodo non sono serviti a nulla visto che non hanno creato neanche una opportunità di segnare '
          },
          playerMaxXGMaxXADiffPlayer: {
            1: 'essendo <b style=\'color:replace_color\'>player_xg_name</b> con <b style=\'color:replace_color\'>xg_value xG</b> e <b style=\'color:replace_color\'>player_xa_name</b> con <b style=\'color:replace_color\'>xa_value xA</b>  i giocatori più rilevanti nel creare occasioni. '
          },
          playerMaxXGMaxXASamePlayer: {
            1: 'essendo <b style=\'color:replace_color\'>player_name</b> con <b style=\'color:replace_color\'>xg_value xG</b> e <b style=\'color:replace_color\'>xa_value xA</b> l\'artefice di gran parte delle occasioni create della sua squadra. '
          },
          playersMaxXGMaxXA: {
            1: 'grazie a <b style=\'color:replace_color\'>players_name</b> che hanno provocato <b style=\'color:replace_color\'>xa_value xA</b> ognuno con i suoi passaggi chiave. '
          },
          playerMaxXGZeroXA: {
            1: 'essendo <b style=\'color:replace_color\'>player_xg_name</b> con <b style=\'color:replace_color\'>xg_value xG</b> che ha dovuto tenere tutto il peso delle occasioni, dovendo crearsele da solo visto che ricevuto nessun passaggio chiave. '
          },
          playersMaxXGZeroXA: {
            1: 'essendo <b style=\'color:replace_color\'>player_xg_name</b> con <b style=\'color:replace_color\'>xg_value xG</b> che ha dovuto tenere tutto il peso delle occasioni, dovendo crearsele da solo visto che ricevuto nessun passaggio chiave. '
          },
          oneMaxConnections: {
            1: 'La coppia con più passaggi effettuati durante questa fase della partita è stata quella formata da <b style=\'color:replace_color\'>couple_name</b>, con un totale di <b style=\'color:replace_color\'>connections_value pases</b>. ',
            2: 'Il duo formato da <b style=\'color:replace_color\'>couple_name</b> si sono scambiati <b style=\'color:replace_color\'>connections_value</b> volte la palla. ',
            3: 'La coppia <b style=\'color:replace_color\'>couple_name</b> è stata quella che si è passata la palla più volte in questa fase della partita, facendolo fino a <b style=\'color:replace_color\'>connections_value</b> occasioni. '
          },
          twoMaxConnections: {
            1: 'Le due coppie formate da <b style=\'color:replace_color\'>couple_name</b> e <b style=\'color:replace_color\'>couple_name2</b> sono stati gli scambi più ripetutidi questo periodo, passandosi la palla fino a <b style=\'color:replace_color\'>connections_value</b> occasioni. '
          },
          moreThanTwoMaxConnections: {
            1: 'Varie coppie di giocatori, come per esempio <b style=\'color:replace_color\'>couple_name</b>, hanno realizzato fino a <b style=\'color:replace_color\'>connections_value pases</b> tra di loro. '
          },
          oneMinConnections: {
            1: 'Al contrario, sono stati <b style=\'color:replace_color\'>couple_name</b> coloro che si sono passati meno la palla, solamente <b style=\'color:replace_color\'>connections_value pases</b>. ',
            2: 'Nell\'altra estremità abbiamo il tandem composto da <b style=\'color:replace_color\'>couple_name</b> che si sono cercati <b style=\'color:replace_color\'>connections_value</b> volte. '
          },
          twoMinConnections: {
            1: 'Dall\'altra parte, dobbiamo segnalare <b style=\'color:replace_color\'>couple_name</b> e <b style=\'color:replace_color\'>couple_name2</b> appena si sono scambiati la palla (<b style=\'color:replace_color\'>connections_value pases</b>). '
          },
          moreThanTwoMinConnections: {
            1: 'Varie sono state le combinazioni in cui non hanno dialogato a sufficienza, come è anche il caso del duo <b style=\'color:replace_color\'>couple_name</b> che con <b style=\'color:replace_color\'>connections_value pases</b> sono le combinazione meno comuni.'
          }
        }
      },
      step7: {
        ballPossession: 'Possesso di palla',
        gamePossessionDist: 'Distribuzione del possesso palla'
      }
    },
    gamePossessionMap: {
      of: 'di',
      to: 'a',
      and: 'e',
      endsWith: 'Finisce con',
      time: 'Min.',
      touches: 'Tocchi',
      passes: 'Passaggi',
      threat: 'Pericolo',
      xG: 'xG',
      xT: 'xT',
      minutes: 'Minuti',
      duration: 'Durata',
      endsGoal: 'Finisce in Gol',
      endsInBox: 'Finisce nell’Area',
      withShot: 'Con un Tiro',
      withCross: 'Con un Cross',
      possession: 'Possesso',
      events: 'Eventi',
      filters: 'Filtri',
      filtersWarning: 'Il pericolo si applica solo ai possessi senza tiri',
      sumWarning: 'Il filtro si applica alla somma degli xG di tutti i tiri nella sequenza, per questo può essere superiore a 1',
      show: 'Mostrare',
      sequenceNumbers: 'Numero Sequenza',
      jerseyNumbers: 'Numero Maglia',
      pass: 'Passaggio',
      carryAndPass: 'Conduzione e Passaggio',
      carryAndAction: 'Conduzione e Azione',
      carryAndShot: 'Conduzione e Tiro',
      shotFailed: 'Tiro Sbagliato',
      goal: 'Gol',
      savedShot: 'Tiro Parato',
      missedShot: 'Tiro Sbagliato',
      shotOnPost: 'Tiro sul Palo',
      headerGoal: 'Gol di Testa',
      headerFailed: 'Colpo di Testa Sbagliato',
      failed: 'sbagliato',
      with: 'con'
    },
    report: {
      title: 'Game Report',
      maps: 'Maps',
      xGRace: 'xG Race',
      lineups: 'Lineups',
      button: 'Generare un rapporto completo in PDF della partita',
      mobileButton: 'Rapporto PDF',
      most: 'Più',
      topXPlayers: 'I migliori {x} giocatori',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: 'Rapporto sui dati fisici del gioco'
    },
    avgScoreTooltip: 'Punteggio medio al minuto',
    status: {
      scheduled: 'Programmato',
      postponed: 'Rinviato',
      cancelled: 'Annullato',
      inPlay: 'Vivere',
      finished: 'Finito',
      awarded: 'Premiato',
      dataAvailable: 'I dati saranno disponibili nelle prossime ore'
    },
    preGameAnalysis: {
      showExpectations: 'Mostra aspettative',
      hideExpectations: 'Nascondi le aspettative',
      goalsPeriods: 'Periodi di obiettivi',
      synergyIndex: 'Indice di sinergia',
      synergyIndexSubtitle: 'Resistenza complessiva della connessione passante-finitrice'
    }
  },
  general: {
    1: 'Uno',
    2: 'Due',
    3: 'Tre',
    4: 'Quattro',
    5: 'Cinque',
    8: 'Sinistra',
    9: 'Entrambi',
    10: 'Destra',
    create: 'Crea',
    save: 'Salva',
    cancel: 'Cancella',
    delete: 'Elimina',
    edit: 'Modifica',
    reset: 'Reset',
    go: 'Vai',
    formErrors: {
      required: 'Il campo è obbligatorio',
      passwordMatch: 'La password non corrisponde',
      minLength: 'Non raggiunge il numero minimo di caratteri',
      maxLength: 'Lunghezza massima',
      emailValid: 'Deve essere un indirizzo email valido',
      youthAge: 'L\'età deve essere tra 10 e 23 anni',
      seasonYear: 'L\'anno deve essere tra il 2016 e il 2050',
      integer: 'I numeri decimali non sono ammessi'
    },
    confirmationTitle: 'Sei Sicuro?',
    confirmationMessage: 'Conferma se vuoi continuare',
    yes: 'Si',
    no: 'No',
    search: 'Cerca',
    clearFilters: 'Elimina Filtri',
    minimum: 'Minimo',
    maximum: 'Massimo',
    minimumPercent: 'Percentuale(%) minima',
    period: 'Periodo',
    exclude: 'Escludi',
    team: 'Squadra',
    clear: 'Elimina',
    all: 'Tutto',
    ground1: 'Tutte',
    ground2: 'Casa',
    ground3: 'Fuori',
    filter: 'Filtra',
    noData: 'Nessun risultato trovato',
    noDataGivenFilters: 'Nessun risultato trovato secondo i filtri',
    similarityMinutesWarning: 'Nessun dato a causa di meno di 450 minuti giocati',
    templateOnlyEditable: 'Modello modificabile solo da ',
    close: 'Chiudi',
    load: 'Carica',
    filters: 'Filtri',
    players: 'Giocatori',
    teams: 'Squadre',
    compare: 'Confronta',
    seeMore: 'Vedi altro',
    seeLess: 'Nascondi',
    request: 'Richiedi',
    notes: 'Note',
    closeSession: 'Chiudi sessione',
    settings: 'Impostazioni',
    player: 'Giocatore',
    state: 'Stato',
    updated: 'Aggiornato',
    file: 'File',
    uploadFile: 'Carica file',
    reports: 'Report',
    download: 'Scarica',
    new: 'Nuovo',
    comparison: 'Confronta',
    scout: 'Cerca',
    favorites: 'Favoriti',
    moreOptions: 'Più opzioni',
    lessOptions: 'Meno opzioni',
    today: 'Oggi',
    home: 'Casa',
    away: 'Fuori',
    until: 'fino a',
    firstHalf: '1º tempo',
    secondHalf: '2º tempo',
    firstPeriodOT: '1º Tempo Supplementare',
    secondPeriodOT: '2º Tempo Supplementare',
    postponed: 'Rinviato',
    stats: 'Statistiche',
    yesterday: 'Ieri',
    last: 'Ultimo',
    startDate: 'Data inizio',
    active: 'Attivo',
    playerLimit: 'Limite dei Giocatori',
    type: 'Tipo',
    successMessage: 'Operazione realizzata con successo',
    failMessage: 'L\'operazione è fallita',
    by: 'Da',
    checkYourInbox: 'Controlla la tua mail',
    faq: 'FAQ',
    globalSearch: 'Ricerca globale',
    gamesLost: 'Partite Perse',
    outOf: 'su',
    avgSeason: 'Media stagionale',
    leftDays: 'Giorni rimanenti',
    notifyError: 'Segnala errore',
    notify: 'Segnala',
    comments: 'Commenti',
    searches: 'Ricerche',
    now: 'Ora',
    twoHoursAgo: 'Due ore fa',
    incomings: 'Acquisti',
    departures: 'Cessioni',
    transferLoans: 'Prestiti',
    transfers: 'Trasferimenti',
    movements: 'Movimenti',
    incomes: 'Guadagni',
    expenditures: 'Spese',
    action: 'Azione',
    target: 'Obiettivo',
    uses: 'Usi',
    users: 'Utenti',
    since: 'da',
    mediaMode: 'Modalità media',
    white: 'Bianco',
    enabled: 'Attivato',
    disabled: 'Disattivato',
    left: 'Sinistra',
    right: 'Destra',
    both: 'Entrambi',
    'left-both': 'Sinistra Entrambi',
    'right-both': 'Destra Entrambi',
    'left foot': 'Sinistra',
    'right foot': 'Destra',
    files: 'File',
    confirm: 'Conferma',
    currentStep: 'Attuale',
    phases: 'Fasi',
    entries: 'Voci',
    none: 'Nessuna',
    times: 'volte',
    darkMode: 'Modalità notte',
    client: 'Cliente',
    visits: 'Visite',
    lastVisit: 'Ultima Visita',
    strong: 'Forte',
    medium: 'Medio',
    weak: 'Debole',
    goal: 'Gol',
    list: 'Lista',
    map: 'Mappa',
    copiedToClipboard: 'Copiato negli appunti',
    division: 'Divisione',
    many: 'Di più',
    few: 'Meno',
    median: 'Centro',
    topRight: 'Alto a destra',
    topLeft: 'Alto a sinistra',
    bottomRight: 'In basso a destra',
    bottomLeft: 'In basso a sinistra',
    library: 'Libreria',
    mediaLibrary: 'Mediateca',
    for: 'Per',
    stat: 'Statistica',
    position: 'Posizione',
    order: 'Ordine',
    add: 'Aggiungi',
    visualization: 'Visualizzazione',
    basic: 'Basico',
    selectAll: 'Seleziona tutti',
    unselectAll: 'Deseleziona tutti',
    distribution: 'Distribuzione',
    end: 'Fine',
    accuracy: 'precisione',
    opponent: 'Avversario',
    ownTeam: 'Squadra Propria',
    center: 'Centro',
    line: 'Linea',
    live: 'Live',
    unavailable: 'non disponibile',
    calendar: 'Calendario',
    activeLeague: 'Campionato attivo',
    similarity: 'Similarity',
    emptyForSelectAll: 'Empty select all',
    size: 'Misura',
    selectPlayersRestriction: 'Seleziona tra 1 e {x} giocatori',
    group: 'Group',
    alerts: 'Alerts',
    shortcuts: 'Shortcuts',
    share: 'Share',
    dataAvailable: 'I dati saranno presto disponibili',
    someStatsAvailableSoon: 'Alcune statistiche saranno presto disponibili',
    monthGamesWarning: 'I giochi del mese selezionati saranno presto disponibili',
    metrics: 'Metriche',
    competition: 'Competition',
    code: 'Code',
    alias: 'Alias',
    never: 'Mai',
    unlimited: 'Illimitato',
    user: 'Utente',
    warning: 'Avviso',
    requests: 'Richieste',
    contactSales: 'Contatto vendite',
    comingSoon: 'Prossimamente!',
    firstPost: '1° messaggio',
    secondPost: '2° messaggio',
    dZone: 'Zona D',
    penaltySpot: 'Punto di rigore',
    secondPlay: '2a riproduzione',
    otherZone: 'Altra Zona',
    baseline: 'Linea di base',
    youth: 'Youth',
    male: 'Male',
    direct: 'Diretto',
    indirect: 'Indiretto',
    processing: 'Processing',
    addNew: 'Aggiungi Nuovo',
    createdBy: 'Creato da',
    downloading: 'Downloading',
    displayType: 'Tipo di presentazione',
    alreadyExists: 'esiste già',
    aggregation: 'Aggregation',
    unavailableLeagues: 'Non si ha accesso a nessuno dei campionati in cui il giocatore ha giocato',
    meters: 'Meters',
    quantity: 'Quantity',
    allTime: 'All Times',
    games: 'Games',
    unit: 'Unità',
    categories: 'Categorie',
    maintenanceWarning: 'Manutenzione in corso',
    maintenanceMessage: 'Stiamo effettuando degli aggiornamenti. Le modifiche che fai ora non verranno salvate. Grazie per la tua pazienza!',
    seeAll: 'Vedi tutto',
    from: 'Da',
    to: 'a',
    showFilters: 'Mostra filtri',
    hideFilters: 'Nascondi filtri',
    horizontal: 'Orizzontale',
    vertical: 'Verticale',
    drop: 'Gocciolare',
    orientation: 'Orientamento',
    goalProbability: 'Probabilità di gol',
    assistProbability: 'Assistere la probabilità',
    attackingDirection: 'Direzione d\'attacco',
    currentTeam: 'Squadra attuale',
    expectations: 'Aspettative',
    sideBySide: 'Fianco a fianco',
    teamValue: 'Valore della squadra',
    fieldLayout: 'Disposizione del campo',
    searchPlaceholder: 'Type {x} letters at least to search',
    crests: 'Creste',
    pcts: 'PCT'
  },
  playerScout: {
    dlabDatabase: 'Database Driblab',
    league: 'campionato',
    top5: 'Top 5',
    topCountries: 'Paesi',
    tier: 'Livello',
    division1: 'Prima divisione',
    division2: 'Seconda divisione',
    division3: 'Terza divisione',
    division4: 'Quarta divisione',
    division5: 'Quinta divisione',
    division6: 'Sesta Divisione',
    summary: 'Riassunto',
    offensive: 'Off',
    defensive: 'Dif',
    gk: 'PT',
    all: 'Tutto',
    physical: 'Fisico',
    arrigo: 'Arrigo',
    yearTooltip: 'Solo un anno consentito',
    expectedThreat: 'Pericolo previsto',
    expectedThreatTooltip: 'Pericolo aggiunto a tutti i possessi',
    expectedThreatOP: 'xThreat AVV',
    expectedThreatOPTooltip: 'Pericolo aggiunto a tutti i possessi su azione',
    expectedThreatInTeam: 'Pericolo Previsto % Squadra',
    expectedThreatInTeamTooltip: '% Pericolo aggiunto dal calciatore alla squadra',
    ballProgression: 'Progressione della palla',
    ballProgressionTooltip: 'Progressioni di +10 meteri',
    deepProgression: 'Profondità',
    deepProgressionTooltip: 'Progressioni Palla ultimo 1/5',
    ballRetention: '% Mantenimento possesso',
    ballRetentionTooltip: '% di azioni dove la palla fu mantenuta con successo',
    ballRetentionOppHalf: '% Mantenimento possesso MCA',
    ballRetentionOppHalfExplicit: '% Mantenimento possesso Metà Campo Avversaria',
    finishing: 'Finalizzazione',
    finishingTooltip: '% di Tiri che terminano in Gol',
    scoringContribution: 'Contributo in zona Gol',
    scoringContributionTooltip: 'Assists + Goals',
    xgPerShot: 'xG per Tiro',
    xgPerGoal: 'xG per Gol',
    headerPerCross: 'Colpi di Testa per Cross',
    completedCrosses: 'Cross Completati',
    crossingPct: '% Cross',
    crossingEfficiency: 'Efficacia Cross',
    crossingEfficiencyTooltip: 'Efficacia Cross (Misura quantità e qualità)',
    longBalls: 'Passaggi lunghi',
    longPassing: '% Passaggi lunghi',
    dribblingPct: '% Dribbling',
    throughBalls: 'Passaggi filtranti',
    oppBoxTouches: 'Tocchi in Area Avversaria',
    oppBoxTouchesTooltip: 'Tocchi in Area Avversaria',
    openPlayKeyPasses: 'Passaggi Chiave su Azione',
    openPlayKeyPassesTooltip: 'Passaggi su Azione che terminano in un tiro',
    xGBuildup: 'Costruzione xG',
    xGBuildupTooltip: 'xG delle sequenze che terminano con un tiro in cui il giocatore è stato coinvolto (esclusi xG di tiro e passaggi chiave)',
    Assists: 'Assist',
    passPercentage: '% Passaggi',
    passPerLongBall: 'Pass. per Palla Lunga',
    passPerLongBallExplicit: 'Passaggi per Palla Lunga',
    nonPenaltyGoals: 'Non Penalty Goals',
    xG: 'xG',
    xGExplicit: 'Expected Goals',
    shots: 'Tiri',
    xGShot: 'xG per Tiro',
    xGChain: 'Partecipazione xG',
    xGChainTooltip: 'xG delle sequenze che terminano con un tiro in cui il giocatore è stato coinvolto (ultimo passatore e tiratore)',
    chancesCreated: 'Occasione Create',
    chances: 'Occasioni',
    dribbles: 'Dribbling',
    dribblesSuccessfull: 'Dribbling completati',
    touches: 'Tocchi in Area Avversaria',
    xA: 'xA',
    xAExplicit: 'Expected Assist',
    xAOpenPlay: 'xA AZ',
    xAOpenPlayExplicit: 'Expected Assists su Azione',
    passesOpponentBox: 'Passaggi in Area Avversaria',
    passesOB: 'Passaggi in AA',
    passesFinalThirdTooltip: 'Passaggi Ultimo Terzo',
    passesSuccessful: 'Pass. Riusciti',
    passesSuccessfulTooltip: 'Passaggi riusciti',
    ballProgressionPassing: 'PP con Passaggio',
    ballProgressionPassingTooltip: 'Progressione Palla con passaggio',
    ballProgressionDribbling: 'PP in Conduzione',
    ballProgressionDribblingTooltip: 'Progressione Palla in conduzione',
    passesTotal: 'Passaggi',
    passesTotalTooltip: 'Totale passaggi tentati',
    shortPassesSuccessful: 'Pass. Corti Completati',
    shortPassesSuccessfulTooltip: 'Passaggi corti completati',
    shortPassesTotal: 'Passaggi Corti',
    shortPassesTotalTooltip: 'Totale passaggi corti tentati',
    tackles: 'Contrasti *',
    adjustedTackles: 'Contrasti regolati',
    interceptions: 'Intercetti *',
    adjustedInterceptions: 'Intercetti regolati',
    aerials: 'Duelli Aerei',
    aerialsPercent: '% Aerea',
    aerialEfficiency: 'Ef. Aerea.',
    aerialEfficiencyTooltip: 'Efficacia Aerea (Misura quantità e qualità)',
    twd: 'CDS',
    tacklesWasDribbled: 'Duelli difensivi 1vs1 vinti',
    fouls: 'Falli',
    indPressure: 'Pressing individuale',
    pressure: 'Pressing',
    dispossessed: 'Palle perse',
    recoveries: 'Recuperi',
    primary: 'Primaria',
    secondary: 'Secondaria',
    position: 'Posizione',
    nationality: 'Nazionalità',
    height: 'Altezza(cm)',
    minHeight: 'Altezza min.',
    maxHeight: 'Altezza max.',
    age: 'Età',
    minAge: 'Età min.',
    maxAge: 'Età max.',
    games: 'Partite',
    minGames: 'Partite min.',
    maxGames: 'Partite max.',
    minutes: 'Minuti',
    minMinutes: 'Minuti min.',
    maxMinutes: 'Minuti max.',
    minPercentMinutes: 'Percentuale di minuti min.',
    dates: 'Date',
    marketValue: 'Valore (€)',
    teams: 'Squadre',
    contractEnd: 'Scadenza contratto',
    minValue: 'valore min.',
    maxValue: 'Valore max.',
    excludeTeams: 'Escludi squadre',
    recentSearches: 'Ultime ricerche',
    saveSearch: 'Salva ricerca',
    loadSearch: 'Carica ricerca',
    loadCollection: 'Carica collezione',
    collection: 'Collezione',
    search: 'Ricerca',
    searchesList: 'Lista delle ricerche',
    mySearches: 'Le mie ricerche',
    mySearchesDescription: 'Quelle che ho salvato precedentemente',
    recentSearchesDescription: 'Le ultime 10 ricerche che ho realizzato',
    searchToLoad: 'Ricerca da caricare',
    recentSearch: 'Ricerca recente',
    saveSearchSuccess: 'Ricerca salvata correttamente',
    removeSearch: 'Elimina ricerca',
    removeSearchMessage: 'Sei sicuro di eliminare la ricerca?',
    updateSearch: 'Aggiorna ricerca',
    updateSearchMessage: 'Sei sicuro di voler aggiornare la ricerca?',
    deleteSearchSuccess: 'Ricerca eliminata con successo',
    playersFound: 'Giocatori trovati',
    addToCollection: 'Aggiungi alla raccolta',
    npg: 'NPG',
    goals: 'Gol',
    value: 'Valore',
    nationalTeams: 'Nazionale',
    gbeScore: 'GBE',
    dlIndex: 'Punteggio',
    minGbe: 'GBE min.',
    goalsConceded: 'Gol Subiti',
    npgConceded: 'NPG Subiti',
    npgConcededTooltip: 'Non penalty Goals Subiti',
    xGOTConceded: 'xG Subiti in Porta',
    xGOTConcededTooltip: 'xG di Tiri Ricevuti in Porta',
    goalsPrevented: 'Gol Evitati',
    xGFacedPerShotOnTarget: 'xG in Porta per Tiro',
    xGFacedPerShotOnTargetTooltip: 'xG in Porta per Tiro subito',
    xGSavedPerxGFacedOnTarget: 'xG Parati',
    xGSavedPerxGFacedOnTargetTooltip: 'Percentuale di Parate considerando xG',
    savesPct: '% Parate',
    savesOutOfBoxPct: '% Parate Fuori Area',
    savesInBoxPct: '% Parate Dentro Area',
    xGFacedPerGoal: 'xG Subiti per Gol',
    xGFacedPerGoalTooltip: 'xG Necessari per Segnare un Gol',
    catchingPct: '% Bloccate',
    catchingTooltip: 'Percentuale Parate Bloccate',
    passingOwnHalfPct: '% Passaggi Propria Metà Campo',
    passingOwnHalfPctTooltip: 'Percentuale di Passaggi completati nella Propria Metà Campo',
    passingOppHalfPct: '% Passaggi Metà Campo Avversaria',
    passingOppHalfPctTooltip: 'Percentuale di Passaggi completati nella Metà Campo Avversaria',
    passingContribution: '% Contribuzione Passaggio',
    passingContributionTooltip: 'Percentuale di Contribuzione Passaggio',
    shotsPerGoal: 'Tiri per Gol',
    passesFinalThird: 'Passaggi Ultimo ⅓',
    passingFinalThird: '% Passaggi Ultimo ⅓',
    claimAccuracy: 'Precisione Uscite',
    claimAccuracyTooltip: 'Precisione Uscite sopra la media',
    highTurnovers: 'Palle perse alte',
    highTurnoversTooltip: 'Palle Perse a più di 40 metri della porta',
    shotEndingHighTurnovers: 'Tiro + palla persa alta',
    shotEndingHighTurnoversTooltip: 'Tiro che termina con palla persa alta',
    goalEndingHighTurnovers: 'Gol + palla persa alta',
    goalEndingHighTurnoversTooltip: 'Gol che termina con palla persa alta',
    avgCarriesProgress: 'Conduzione media',
    avgCarriesProgressTooltip: 'Distanza media che un giocatore muove verticalmente la palla per conduzione (metri)',
    carriesChance: 'Che terminano con un\'occasione',
    carriesChanceTooltip: 'Conduzione seguita da un Passaggio Chiave',
    carriesAssist: 'Che terminano con un Assist',
    carriesAssistTooltip: 'Conduzione seguita da un Assist',
    carriesShot: 'Che terminano con un Tiro',
    carriesShotTooltip: 'Conduzione seguita da un Tiro',
    carriesGoal: 'Che terminano con un Gol',
    carriesGoalTooltip: 'Conduzione seguita da un Gol',
    shotEndingSequence: 'Possesso che termina con un Tiro',
    shotEndingSequenceTooltip: 'Sequenze che terminano in Tiro in cui il giocatore è stato coinvolto',
    goalEndingSequence: 'Possesso che terminano in Gol',
    goalEndingSequenceTooltip: 'Sequenze che terminano in Gol in cui il giocatore è stato coinvolto',
    gbeScoreTooltip: 'Approvazione dell\'organo direttivo della FA Football',
    goalsPreventedTooltip: 'Non-Penalty Goals parati dal Portiere (xG Ricevuto - NPG Subito)',
    freePlayers: 'Svincolato',
    index: 'Indice',
    playerName: 'Nome',
    teamName: 'Squadra',
    secondPos: 'Seconda Posizione',
    side: 'Lato',
    onlyOnLoan: 'Solo in prestito',
    dob: 'Data di nascita',
    countryName: 'Nazionalità',
    secondCountryName: 'Seconda nazionalità',
    seasonYear: 'Stagione',
    assists: 'Assist',
    placeholder: 'Puoi iniziare ad aggiungere qualche filtro',
    placeholder2: 'Fare clic sul pulsante di ricerca per visualizzare i risultati',
    passesPct: '% Passaggi',
    passingPct: '% Passaggi %',
    oppBoxPasses: 'Passaggi Area Avversaria',
    adjustedClearances: 'Disimpegni regolati',
    aerialsPct: '% Duelli aerei',
    leagueCountryCode: 'Codice Campionato',
    shooting: '% Tiri in porta',
    xtPassing: 'xT Passaggio',
    xtPassingTooltip: 'Pericolo proveniente dal passaggio',
    xtDribbling: 'xT Dribbling',
    xtDribblingTooltip: 'Pericolo proveniente dal dribbling',
    foot: 'Piede forte',
    aggressiveActions: 'Azioni Aggressive',
    aggressiveActionsTooltip: 'Numero di contrasti tentati nei primi due secondi dopo aver perso il possesso',
    tacklesAttempted: 'Contrasti tentati',
    highDefensiveActionPct: '% Azioni difensive',
    highDefensiveActionPctTooltip: 'Percentuale di azioni difensive effettuate a 40 metri dalla porta avversaria',
    individualPressureOppHalf: 'Pressing Metà Campo Avversaria',
    individualPressureOppHalfTooltip: 'Metrica che misura il numero di tentativi riusciti (possessi recuperati) effettuati da un giocatore quando pressa l\'avversario nella metà campo avversaria.',
    xGBuildUp5Pass: 'xG Buildup 5P',
    xGBuildUp5PassTooltip: 'Quantità di xG a cui ha partecipato un giocatore, solo gli ultimi 5 passaggi (esclusi i tiri e i passaggi che portano a un tiro)',
    chancesCreatedOpenPlay: 'Occasioni Create su Azione',
    chancesCreatedOpenPlayTooltip: 'Numero di passaggi che portano ad un tiro su azione',
    fmf: {
      Defender: 'Difensore',
      aerial: 'Duello aereo',
      goodDefender: 'Buon Difensore',
      goodPresence: 'Buona Presenza',
      playmaking: 'Playmaking',
      Fullback: 'Terzino',
      defensiveness: 'Difesa',
      offensiveness: 'Attacco',
      fast: 'Veloce',
      Forward: 'Attaccante',
      goalChances: 'Occasioni da gol',
      goodDecissions: 'Buone decisioni',
      individualTechnique: 'Tecnica individuale',
      Goalkeeper: 'Portiere',
      footWork: 'Lavoro con in piedi',
      leadership: 'Leadership',
      Midfielder: 'Centrocampista',
      balance: 'Equilibrio',
      ballRetention: '% Mantenimento Palla',
      offensivePasses: 'Passaggi offensivi',
      recoveries: 'Recuperi',
      shotToGoal: 'Tiri in Porta',
      'Attacking-Midfielder': 'Centrocampista offensivo',
      defensiveGame: 'Gioco difensivo',
      offensiveGame: 'Gioco offensivo',
      Winger: 'Ala',
      crossing: 'Cross',
      deepProgressions: 'Profendità',
      defendingEffort: 'Sforzo difensivo',
      facing: 'duello',
      goodDecisions: 'Buone decisioni'
    },
    yellowCards: 'Cartellini Gialli',
    redCards: 'Cartellini Rossi',
    alert: 'Alert',
    yearOfBirth: 'Anno di nascita',
    minYearOfBirth: 'Anno di nascita minimo',
    maxYearOfBirth: 'Anno di nascita massimo',
    women: 'Femminile',
    continental: 'Continental',
    countryCup: 'Coppa Nazionale',
    statsName: 'Nome',
    abbreviation: 'Abbreviazione',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: 'Viene mostrata solo l\'ultima stagione regolare giocata',
    gamesWith60PlusMinsTooltip: 'Numero minimo di partite giocate con più di 60 minuti',
    starts: 'Inizia',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: 'Confronta fino a 5 giocatori',
    requestReport: 'Richiedi report',
    searchBarPlaceholder: 'Cerca giocatore o squadra',
    allStats: 'Tutte le statistiche',
    placeholder: 'Puoi cominciare ad aggiungere qualche giocatore'
  },
  reports: {
    detailedInsights: 'Ottieni informazioni dettagliate',
    features: 'Contenuto del report',
    performance: 'Rendimento',
    evolution: 'Evoluzione',
    compareWithMyTeam: 'Confronta con la mia squadra',
    similarPlayers: 'Giocatori simili',
    potentialTeams: 'Squadre potenziali',
    requestSuccess: 'Richiesta inviata con successo',
    requestAt: 'Richiesto',
    reportConversation: 'Conversazione del report',
    writeYourMessage: 'Scrivi messaggio...',
    you: 'Tu'
  },
  state: {
    requested: 'Richiesto',
    inProgress: 'In corso',
    delivered: 'Consegnato'
  },
  langs: {
    es: 'Spagnolo',
    en: 'Inglese',
    fr: 'Francese',
    de: 'Tedesco',
    it: 'Italiano',
    pt: 'Portoghese',
    tr: 'Turco',
    jp: 'Giapponese',
    cn: 'Cinese',
    sa: 'Arabo',
    nl: 'Olandese',
    pl: 'Polacco',
    sv: 'Svedese',
    cs: 'Czech',
    ko: 'Coreano',
    hu: 'Ungherese',
    ru: 'Russo'
  },
  langsArea: {
    europe: 'Europa',
    asia: 'Asia',
    arabic: 'Arabo'
  },
  inbox: {
    subtitle: 'Tieni aggiornato',
    new_injury_alert: 'Allerta Nuovo Infortunio',
    new_contract_alert: 'Allerta Nuovo Contratto',
    new_team_alert: 'Nuovo avviso di firma.',
    new_marketValue_alert: 'Allerta Nuovo Valore di Mercato',
    new_game_alert: 'Allerta di nuova partita giocata',
    receive_mail: 'Email Ricevute',
    receive_mail_subtitle: 'Ricevi e-mail giornaliere con i giocatori che soddisfano i filtri',
    receive_notifications: 'Notifiche',
    receive_notifications_subtitle: 'Ricevere notifiche nell\'applicazione con i giocatori che superano il filtro',
    changedTo: 'Cambiato a',
    alerts: 'Allerte',
    includedIn: 'Incluso in',
    noContract: 'Nessun Contratto',
    newMessages: 'Nuovi Messaggi',
    reply: {
      reply: 'Reply',
      replyTitle: 'Give feedback to the client:',
      replyPlaceholder: 'The user will receive the reply along with the status update'
    }
  },
  gameAnalysis: {
    subtitle: 'Approfondisci le ultime partite',
    subtitle2: 'Mostra le partite dei prossimi 7 giorni',
    subtitle3: 'Ottenere informazioni sulle ultime partite ed esplorare le prossime',
    seeDetail: 'Vedi dettagli'
  },
  statsNaming: {
    Possession: 'Possesso',
    TimePossession: 'Tempo di Possesso',
    PassesPerShots: 'Passaggi per Tiro',
    PPDA: 'PPAD',
    ExpectedPoints: 'Punti Previsti',
    Points: 'Punti',
    Directness: 'Verticalità',
    PassesPerLongBall: 'Passaggi per Passaggio Lungo',
    CrossingPerXG: 'Cross per xG',
    PenaltySavedPenaltyFaced: 'Rigore Parato / Rigore a sfavore',
    Goals: 'Goals',
    PenaltyShots: 'Rigori tirati',
    PenaltyGoals: 'Gol su rigore',
    NonPenaltyGoals: 'Non Penalty Goals',
    NPGOpenPlay: 'NPG Open Play',
    NPGSetPiece: 'NPG Set Piece',
    Shooting: '% Tiri in Porta',
    Finishing: 'Finalizzazione',
    xGEfficiency: 'Efficacia xG',
    HeaderPerShot: 'Colpi di Testa per Tiro',
    HeaderPerCross: 'Colpi di Testa per Cross',
    HeadedGoals: 'Gol di testa',
    GoalsConceded: 'Gol subiti',
    SavesInBox: 'Salva nella casella',
    SavesOutBox: 'Salva fuori dalla scatola',
    Assists: 'Assist',
    ThroughBalls: 'Passaggi tra le linee',
    CrossEfficiency: 'Efficacia Cross',
    ScoringContribution: 'Contributo in zona Gol',
    xAssistsOpenPlay: 'xA su Azione',
    xAssistsSetPiece: 'xA da Palla Ferma',
    xAssistsOpenPlayInTeam: 'xA su Azione in Squadra',
    xAssistsSetPieceInTeam: 'xA da Palla Ferma in Squadra',
    xGBuildupFinalThird: 'Costruzione xG ultimo ⅓',
    xGChainFinalThird: 'Partecipazione xG ultimo ⅓',
    BallProgressionPassing: 'Progressione Palla con passaggio',
    BallProgressionDribbling: 'Progressione Palla in conduzione',
    TacklesWasDribbled: 'Duelli difensivi 1vs1 vinti',
    TacklesSuccessful: 'Contrasti Riusciti',
    Interceptions: 'Intercetti',
    Clearances: 'Disimpegno',
    Fouls: 'Falli',
    Recoveries: 'Recuperi',
    Shots: 'Tiri',
    ShotsPerGoal: 'Tiri per Gol',
    ShortPassesSuccessful: 'Passaggi Corti Completati',
    PassingSuccessForwardPct: '% Passaggi in avanti Completati',
    PassingSuccessBackwardPct: '% Passaggi indietro Completati',
    PassingForwardBackwardPct: '% Passaggi in avanti per Passaggi Indietro',
    LongBallPerPassesPct: '% Passaggi Lunghi per Passaggi Completati',
    LongBallReceived: 'Passaggi Lunghi Ricevuti',
    LongBallReceivedOppHalf: 'Passaggi Lunghi Ric. Metà campo avversaria.',
    OffensiveActions: 'Azioni Offensive',
    DribblesAttempted: 'Dribbling tentati',
    SuccessfulDribblesPct: '% Dribbling Completati',
    OffensiveTouchesOutBoxPct: '% Tocchi Offensivi Fuori Area',
    BallRetention: '% Mantenimento Palla',
    PassingPct: '% Passaggi',
    PassingOwnHalfPct: '% Passaggi nella Propria Metà Campo',
    PassingOppHalfPct: '% Passaggi nella Metà Campo Avversaria',
    PassingFinalThird: 'Passaggi Ultimo ⅓',
    PassesFinalThirdTotal: 'Totale passaggi finali ⅓',
    PassingFinalThirdPct: '% Passaggi Ultimo ⅓',
    LongBallSuccessful: 'Passaggi Lunghi Completati',
    LongBallPct: '% Passaggi Lunghi',
    LongBallTotal: 'Palle lunghe totali',
    SavesPct: '% Parate',
    SavesInBoxPct: '% Parate Dentro l´Area',
    SavesOutOfBoxPct: '% Parate Fuori Area',
    xGSavedPerXGFacedOnTarget: 'xG Parate / xG Subiti',
    xGFacedOnTargetPerGoalReceived: 'xG Subiti per Gol',
    xGFacedOnTargetEfficiency: 'Gol Evitati',
    xGFacedOnTarget: 'xG Subiti',
    IndividualPressure: 'Pressing individuale',
    AerialEfficiency: 'Efficacia Aerea',
    AerialWins: 'Duelli Aerei Vinti',
    AerialWinsPct: '% Duelli Aerei Vinti',
    xG: 'Expected Goals',
    xGDiff: 'Differenza xG',
    xGOpenPlay: 'xG Gioco aperto',
    xGSetPiece: 'xG da Palla Ferma',
    xGPerShot: 'xG per Tiro',
    ChancesCreated: 'Occasioni Create',
    CompletedCrosses: 'Cross Completati',
    Crossing: '% Cross Completati',
    OpenPlayKeyPasses: 'Passaggi Chiave su Azione',
    OpenPlayKeyPassesInTeam: '% Passaggi Chiave su Azione in Squadra',
    OpenPlayPassesIntoOpponentBox: 'Passaggi Totale in Area Avversaria su Azione',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'Passaggi in Area Avversaria su Azione',
    xAssists: 'Expected Assist',
    xGChain: 'Partecipazione xG',
    xGBuildup: 'Costruzione xG',
    xGBuildupInTeam: 'Costruzione xG in Team',
    BallProgression: 'Progressione Palla',
    SuccessfulDribbles: 'Dribbling Completati',
    Dispossessed: 'Palle Perse',
    TouchesInOpponentBox: 'Tocchi in Area Avversaria',
    xGSavedPerShot: 'xG Parate per Tiro',
    BallRetentionOppHalf: '% Mantenimento Possesso Palla Metà Campo Avversaria',
    DeepProgression: 'Profondità',
    DeepProgressionFinalThird: 'Profondità Ultimo ⅓',
    FoulsTaken: 'Falli subiti',
    PenaltiesTaken: 'Rigori provocati',
    BlockedCrosses: 'Cross Intercettati',
    BlockedShots: 'Tiri Intercettati',
    Blocks: 'Parate',
    NonPenaltyGoalsAgainst: 'Non Penalty Goals subiti',
    Headers: 'Colpi di Testa',
    AveragePassDistance: 'Distanza Media di Passaggio',
    ProgressiveRuns: 'Conduzioni Progressive',
    xT: 'Pericolo Previsto (xT)',
    xTOpenPlay: 'xT su Azione',
    xTSetPiece: 'xT da Palla Ferma',
    xGOT: 'Expected Goals in Porta',
    BadActions: 'Azioni Fallite',
    BadActionsOwnHalf: 'Azioni fallite nella propria metà campo',
    AerialsWonOwnBox: 'Duelli Aerei Vinti nella propria area',
    AerialsWonOppBox: 'Aerials Won Opp Box',
    AerialsTotalOppBox: 'Aerials Total Opp Box',
    AerialsTotalOwnBox: 'Aerials Total Own Box',
    FoulsOwnHalfPct: '% Falli nella propria metà Campo',
    RecoveriesOppHalf: 'Recuperi nella metà Campo Avversaria',
    DuelsPct: '% Duelli Vinti',
    TacklesUnsuccessful: 'Contrasti Infruttuosi',
    TacklesWasDribbledFirstThird: 'Duelli difensivi 1vs1 vinti ⅓',
    TacklesWasDribbledSecondThird: 'Duelli difensivi 1vs1 vinti ⅔',
    TacklesWasDribbledFinalThird: 'Duelli difensivi 1vs1 vinti Finale ⅓',
    BallProgressionFinalThird: 'Progressione Palla Ultimo ⅓',
    DuelsTotal: 'Duelli',
    QuickRecoveries: 'Recuperi rapidi',
    ShotsPerNPG: 'Tiri per Non Penalty Goals',
    ShotsOutBox: 'Tiri Fuori Area',
    GoalsOutBox: 'Gol Fuori Area',
    ShootingOutBox: '% Tiri in Porta Fuori Area',
    HandPassing: '% Passaggi con le mani',
    Catching: '% Parate Bloccate',
    Caught: 'Preso salva',
    ClaimAccuracy: 'Precisione Uscita Alta',
    HighTurnovers: 'Palle perse Alte',
    ShotEndingHighTurnovers: 'Tiro + palla persa alta',
    GoalEndingHighTurnovers: 'Gol + palla persa alta',
    AverageCarriesProgress: 'Media progressione in conduzione',
    ChanceEndingCarries: 'Che terminano con un\'occasione',
    AssistEndingCarries: 'Che terminano con un Assist',
    ShotEndingCarries: 'Che terminano con un Tiro',
    GoalEndingCarries: 'Che terminano con un Gol',
    ShotEndingSequence: 'Sequenze che terminano in Tiro',
    GoalEndingSequence: 'Sequenze che terminano in Gol',
    xGPerNPG: 'xG per Non Penalty Goals',
    AerialWonOffensive: 'Duelli Aerei Offensivi Vinti',
    AerialWonDefensive: 'Duelli Aerei Defensivi Vinti',
    xGAgainst: 'xG Subiti',
    xGDiffAgainst: 'xG Diff Subiti',
    xGPerNPGAgainst: 'xG per Non Penalty Goals Subiti',
    xGSetPieceAgainst: 'xG da Calci Piazzati Subiti',
    xGOpenPlayAgainst: 'xG su Azione Subiti',
    xGPerShotAgainst: 'xG per Tiro subito',
    ShotsAgainst: 'Tiri Subiti',
    ShotsOnTargetAgainst: 'Tiri in porta subiti',
    ShotsOnTargetInBoxAgainst: 'Tiri in porta subiti in area',
    ShotsOnTargetOutBoxAgainst: 'Tiri in porta fuori area subiti',
    RivalPossession: 'Possesso palla avversario',
    AerialDefensivePct: '% Duelli Aerei Difensivi',
    HighRecoveries: 'Recuperi Pericolosi',
    HighDefensiveActions: 'Azioni Difensive Pericolose',
    HighDefensiveActionPct: '% Azioni Difensive Pericolose',
    HighDefensiveDistance: 'Distanza Difensiva Alta',
    PassesPerPossession: 'Passaggi per Possesso',
    LengthPerPossession: 'Distanza per Possesso',
    xTNet: 'Net xT',
    AvgCarriesDistance: 'Distanza Media Conduzioni',
    PassesForwardPct: '% Passaggi in avanti',
    PassesForwardSuccessful: 'Passaggi in avanti riusciti',
    PassesForwardTotal: 'Passaggi in avanti totali',
    TacklesAttempted: 'Contrasti Tentati',
    DuelsLost: 'Duelli Persi',
    Carries: 'Conduzioni',
    CarriesPct: '% Conduzioni',
    Aerials: 'Duelli Aerei',
    ProgressivePassesReceivedIntoBox: 'Passaggi Progressivi Ricevuti in area',
    PassesOppHalf: 'Passaggi Metà Campo Avversaria',
    ShotsOnTarget: 'Tiri in Porta',
    AggressiveActions: 'Azioni Aggressive',
    Crosses: 'Cross',
    xGBuildup5pass: 'xG Costruzione 5 passaggi',
    SpeedSequence: 'Velocità Sequenza',
    Touches: 'Tocchi',
    AerialsTotalOppHalf: 'Duelli Totali Aerei Metà Campo Avv.',
    AerialsWonOppHalf: 'Le antenne hanno vinto oppo. Metà',
    AerialsWonOppHalfPct: '% Duelli Aerei Vinti Metà Campo Avv.',
    AerialsPctOppBox: '% Duelli Arei vinti Metà Campo Avv.',
    AerialsPctOwnBox: '% Duelli Arei vinti Propria Area',
    AerialDefensive: 'Duelli Arei Difensive',
    AerialOffensive: 'Duelli Arei Offensivi',
    AerialOffensivePct: '% Duelli Arei Offensivi',
    IndividualPressureOppHalf: 'Pressione Individuale Metà Campo Avv.',
    ChancesCreatedOP: 'Occasioni Create su Azione',
    TouchesPerShot: 'Tocchi per Tiro',
    PassesFinalThirdTotalPct: '% Passaggi Ultimo ⅓',
    xACrosses: 'xA da Cross',
    Passes: 'Passaggi',
    PassesSuccessful: 'Passaggi con Successo',
    TacklesWasDribbledFouls: '% Ground Duels',
    OffsidesCaught: 'Fuorigioco',
    ProgressivePassesReceivedFinalThird: 'Passaggi Progressivi Ricevuti Ultimo ⅓',
    ProgressivePassesReceived: 'Passaggi Progressivi Ricevuti',
    Breadth: 'Ampiezza',
    DuelsDefTotal: 'Duelli difensivi',
    DefensiveActions: 'Azioni difensive',
    ProgressivePassesReceivedOppHalf: 'Passaggi progressivi ricevuti Metà Campo Avv.',
    CompletedCrossesOP: 'Cross Completati su Azione',
    CrossingOP: '% Cross su Azione ',
    CrossesOP: 'Cross totali Gioco aperto',
    PassingContribution: '% Contribuzione Passaggio',
    BallProgressionOppHalfInTeam: '% Progressione Palla Metà Campo Avv. in Squadra',
    PassesOPIntoBoxInTeam: '% Passaggi su Azione Area Avversaria',
    TouchesOppBoxInTeam: '% Tocchi in Area Avversaria in Squadra',
    xGOPInTeam: '% xG su Azione in Squadra',
    DeepPasses: 'Passaggi profondi',
    DeepPassesTotal: 'Passaggi profondi',
    DefensiveDuelsPct: '% Duelli difensivi',
    DefensiveDistance: 'Distanza difensiva',
    QuickRecoveriesPct: '% Recuperi rapidi',
    DiffDefensiveDistanceTeam: 'Diff. Distanza difensiva Squadra',
    xTPassing: 'xT Passaggio',
    xTPassing100Passes: 'xT Passaggio 100 Passaggi',
    ProgressivePassesAccurate: 'Passaggi Progressivi',
    PassAbility: 'Abilità Passaggio',
    OPPassesIntoOppBoxPct: '% Passaggi su Azione Area Avversaria',
    EntriesOppBox: 'Incursioni Metà Campo Avversaria',
    Crosses6yardBox: 'Cross Area Piccola',
    Cutbacks: 'Cross Arretrati',
    xTDribbling: 'xT Dribbling',
    AvgShotDistance: 'Distanza Media di Tiro',
    xGOnTarget: 'xG in Porta',
    FinishingxGOT: 'xG in Porta Finalizzazione',
    DribblesWonOwnHalf: 'Driobbling Completati Propria Metà Campo ',
    DribblesOwnHalf: 'Dribbling Propria Metà Campo',
    DribblesOwnHalfPct: '% Dribbling Propria Metà Campo',
    DribblesWonOppHalf: 'Dribbling Completati Metà Campo Avversaria',
    DribblesOppHalf: 'Dribbling Metà Campo Avversaria',
    DribblesOppHalfPct: '% Dribbling Metà Campo Avversaria',
    DribblesWonFinalThird: 'Dribbling Completati Ultimo ⅓',
    DribblesFinalThird: 'Dribbling Ultimo ⅓',
    DribblesFinalThirdPct: '% Dribbling Ultimo ⅓',
    ShotEndingHighRecoveries: 'Recuperi Alti con Conclusione',
    PassingFinalThirdAgainst: 'Passaggi Concessi nell’ultimo terzo',
    OpenPlayPassesIntoOpponentBoxAgainst: 'Passaggi Concessi in area su Azione',
    EntriesOppBoxAgainst: 'Ingressi Concessi nell’area Avversaria',
    DeepProgressionAgainst: 'Progressioni Profonde Concesse',
    TouchesInOpponentBoxAgainst: 'Tocchi Concessi nell’area Avversaria',
    Score: 'Punteggio',
    PDScore: 'Punteggio Fisico',
    OrlegiScore: 'Score Orlegi',
    SirScore: 'Sirius Score',
    ExcScore: 'Excelsior Score',
    xTOPInTeam: 'xT su Azione in Squadra',
    YellowCards: 'Cartellini Gialli',
    RedCards: 'Cartellini Rossi',
    xTOpenPlayAgainst: 'xT su Azione Subiti',
    xTSetPieceAgainst: 'xT da Palla Ferma Subiti',
    NPGOpenPlayAgainst: 'NPG su Azione Subiti',
    NPGSetPieceAgainst: 'NPG da Palla Ferma Subiti',
    PassesOppHalfPerPossession: 'Passaggi Metà Campo Avversaria per Possesso',
    AverageTimeRecovery: 'Tempo Medio di Recupero',
    ExpectedPassing: '% Passaggio Previsto',
    NumPossession10Passes: 'Possessi 10 Passaggi',
    PassesReceived: 'Passaggi Ricevuti',
    PassesReceivedFinalThird: 'Passes Received Final ⅓',
    ProgressivePassesTotalPct: '% Passaggi progressivi',
    ShortPassesPct: '% Passaggi Corti',
    TouchesOppBoxOppTeam: 'Tocchi in Area Propria Concessi con Lui in Campo',
    ShotsOnTargetOppTeam: 'Tiri in Porta Subiti con Lui in Campo',
    NPGOppTeam: 'xG Non Rigori Avversari con Lui in Campo',
    ShotsOpenPlay: 'Tiri su azione',
    xGSetPiecePerxG: 'xG da palla inattiva per xG',
    ShotsOpenPlayAgainst: 'Tiri subiti su azione',
    ShotsFromDribble: 'Tiri dopo Dribbling',
    GoalsFromDribble: 'Gol dopo Dribbling',
    PassesIntoFinalThird: 'Passaggi nell’Ultimo Terzo',
    PassesIntoFinalThirdTotal: 'Il totale passa al terzo finale',
    PassesInsideFinalThird: 'Passaggi dentro l’Ultimo Terzo',
    PassesInsideFinalThirdTotal: 'Passaggi totali nella finale ⅓',
    PassesFinalThirdNoArea: 'Passa il terzo finale (SENZA casella)',
    PassesIntoOppBox: 'Passaggi nell’Area Avversaria',
    CarriesFinalThird: 'Conduzioni nell’Ultimo Terzo',
    CarriesInsideFinalThird: 'Conduzioni dentro l’Ultimo Terzo',
    CarriesFinalThirdNoBox: 'Trasporta il terzo finale (SENZA scatola)',
    CarriesIntoOppBox: 'Conduzioni nell’Area Avversaria',
    TimePossessionAgainst: 'Possesso Palla Avversario',
    TimePossessionTotal: 'Possesso Palla Totale',
    PassesInBox: 'Passaggi nella Propria Area',
    LongThrowInSuccessful: 'Rimessa Lunga Riuscita',
    LongThrowInTotal: 'Totale Rimesse Lunghe',
    LongThrowInPct: '% Rimesse Lunghe Riuscite',
    Games: 'Giochi giocati',
    PointsPerGame: 'Punti per partita',
    ExpectedPointsDiff: 'Differenza di punti prevista',
    PassesTotalOwnHalf: 'Totale passaggi per la propria metà campo',
    PassesOwnHalf: 'Passa la propria metà campo',
    PassesTotalOppHalf: 'Passa la metà totale degli avversari',
    ProgressivePassesTotal: 'Passaggi progressivi totali',
    DuelsWon: 'Duelli vinti',
    NonPenaltySaves: 'Parate senza penalità',
    BadActionsOppHalf: 'Cattive azioni Opp metà',
    CarriesSuccessful: 'Porta con successo',
    ShotsOnTargetOutBox: 'Tiri in porta fuori area',
    TotalDistance: 'Distanza Totale',
    DistanceIP: 'Distanza TIP',
    DistanceOOP: 'Distanza OTIP',
    SprintsNumber: 'Sprint Quantità',
    SprintsDistance: 'Sprint Distanza',
    WalkingDistance: 'Distanza a piedi',
    JoggingDistance: 'Distanza jogging',
    RunningDistance: 'Distanza di corsa',
    ExtremeAccelerations: 'Accelerazioni estreme',
    NumberOfRuns: 'Numero di corse',
    HsrNumber: 'HSR Quantità',
    HsrDistance: 'Distanza HSR',
    SprintNumberDeclinePct: '% Sprint Quantity Decline',
    SprintDistanceDeclinePct: '% Sprint Distance Decline',
    SprintNumberDecline: 'Sprint Quantity Decline',
    SprintDistanceDecline: 'Sprint Distance Decline',
    HsrDistancePct: '% HSR Distanza',
    SprintDistancePct: '% Distanza Sprint',
    Accelerations: 'Quantità Accelerazioni',
    ExplosiveDistance: 'Distanza Esplosiva',
    MaxSpeed: 'Velocità Max.',
    AvgMaxSpeed: 'Media Max. Velocità',
    MaxAccelerations: 'Max. Accelerazioni',
    BypassedPlayersByPasses: 'Giocatori Superati',
    BypassedDefendersByPasses: 'Difensori Superati',
    PassesBypassingPlayers: 'Passaggi che Superano Giocatori',
    PassesBypassingDefenders: 'Passaggi che Superano Difensori',
    BypassedPlayersPerPass: 'Giocatori Superati per Passaggio',
    BypassedDefendersPerPass: 'Difensori Superati per Passaggio',
    LineBreakingPasses: 'Passaggi che Rompono le Linee',
    LineBreakingPassesMD: 'Passaggi che Rompono le Linee MD',
    LineBreakingPassesM: '',
    LineBreakingThroughBalls: 'Passaggi in Profondità Rompi Linee',
    LineBreakingPassesPerPass: '% Passaggi tra le Linee per Passaggio',
    TotalPassesUnderStrongPressure: 'Totale Passaggi sotto Forte Pressione',
    TotalPassesUnderLightPressure: 'Totale Passaggi sotto Pressione',
    SuccessfulPassesUnderStrongPressure: 'Passaggi sotto Forte Pressione Completati',
    SuccessfulPassesUnderLightPressure: 'Passaggi sotto Pressione Completati',
    PassingUnderStrongPressure: '% Passaggi sotto Forte Pressione',
    PassingUnderLightPressure: '% Passaggi sotto Pressione',
    PassReceiptsInSpaceCompleted: 'Passaggi Ricevuti in Spazio Completate',
    PassReceiptsInSpace: 'Passaggi Ricevuti in Spazio',
    PassReceiptsInSpaceCompletedFirstThird: 'Ricezioni in Spazio Completate Primo Terzo',
    PassReceiptsInSpaceCompletedSecondThird: 'Ricezioni in Spazio Completate Secondo Terzo',
    PassReceiptsInSpaceCompletedFinalThird: 'Ricezioni in Spazio Completate Ultimo Terzo',
    PassReceiptsInSpaceCompletedOppHalfRight: 'Ricezioni in Spazio Completate Metà Avversaria Destra',
    PassReceiptsInSpaceCompletedOppHalfCenter: 'Ricezioni in Spazio Completate Metà Avversaria Centro',
    PassReceiptsInSpaceCompletedOppHalfLeft: 'Ricezioni in Spazio Completate Metà Avversaria Sinistra',
    PassReceiptsInSpaceFirstThird: 'Ricezioni in Spazio Primo Terzo',
    PassReceiptsInSpaceSecondThird: 'Ricezioni in Spazio Secondo Terzo',
    PassReceiptsInSpaceFinalThird: 'Ricezioni in Spazio Ultimo Terzo',
    PassReceiptsInSpaceOppHalfRight: 'Ricezioni in Spazio Metà Avversaria Destra',
    PassReceiptsInSpaceOppHalfCenter: 'Ricezioni in Spazio Metà Avversaria Centro',
    PassReceiptsInSpaceOppHalfLeft: 'Ricezioni in Spazio Metà Avversaria Sinistra',
    TotalStrongOnBallPressures: 'Totale Pressioni Forti sulla Palla',
    TotalLightOnBallPressures: 'Totale Pressioni sulla Palla',
    SuccessfulStrongOnBallPressures: 'Pressioni Forti sulla Palla Completati',
    SuccessfulLightOnBallPressures: 'Pressioni sulla Palla Completati',
    StrongOnBallPressuresPct: '% di Pressioni Forti sulla Palla',
    LightOnBallPressuresPct: '% di Pressioni sulla Palla',
    TimesBypassedByPasses: 'Superato dai Passaggi',
    TimesBypassedByCarries: 'Superato dalle Conduzioni',
    TimesBypassedByActions: 'Superato dalle Azioni',
    BypassedPlayersByCarries: 'Giocatori Superati dalle Conduzioni',
    BypassedDefendersByCarries: 'Difensori Superati dalle Conduzioni',
    BypassedPlayersByActions: 'Giocatori Superati dalle Azioni',
    BypassedDefendersByActions: 'Difensori Superati dalle Azioni',
    CarriesBypassingPlayers: 'Conduzioni che Superano i Giocatori',
    CarriesBypassingDefenders: 'Conduzioni che Superano i Difensori',
    BypassedPlayersPerCarry: 'Giocatori Superati per Conduzione',
    BypassedDefendersPerCarry: 'Difensori Superati per Conduzione',
    LineBreakingCarries: 'Conduzioni tra le Linee',
    LineBreakingCarriesMD: 'Conduzioni tra le Linee Difensori e Centrocampisti',
    LineBreakingCarriesM: 'Conduzioni tra la Linea dei Centrocampisti',
    LineBreakingCarriesD: 'Conduzioni tra la Linea dei Difensori',
    LineBreakingCarriesPerCarry: 'Conduzioni tra le Linee per Conduzione',
    LineBreakingActions: 'Azioni tra le Linee',
    LineBreakingActionsMD: 'Azioni tra la Linea Difensori e Centrocampisti',
    LineBreakingActionsM: 'Azioni tra la Linea dei Centrocampisti',
    LineBreakingActionsD: 'Azioni tra la Linea dei Difensori',
    PassesPerLineBreakingPass: 'Passaggi per Passaggio tra le Linee',
    CarriesPerLineBreakingCarry: 'Conduzioni per Conduzione tra le Linee',
    LinesBrokenByPasses: 'Linee Rotte con Passaggi',
    LinesBrokenByCarries: 'Linee Rotte con Conduzioni',
    LinesBrokenByActions: 'Linee Rotte con Azioni',
    LinesBrokenPerPass: 'Linee Rotte per Passaggio',
    LinesBrokenPerCarry: 'Linee Rotte per Conduzione',
    AvgLastDefenderDistanceIP: 'Distanza Ultimo Difensore IP',
    AvgLastDefenderDistanceOOP: 'Distanza Ultimo Difensore OOP',
    AvgDefensiveLineDistanceIP: 'Distanza Linea Difensiva IP',
    AvgDefensiveLineDistanceOOP: 'Distanza Linea Difensiva OOP',
    AvgRBDistanceIP: 'Distanza Terzino Destro IP',
    AvgRBDistanceOOP: 'Distanza Terzino Destro OOP',
    AvgLBDistanceIP: 'Distanza Terzino Sinistro IP',
    AvgLBDistanceOOP: 'Distanza Terzino Sinistro OOP',
    AvgBlockDistanceIP: 'Distanza del Blocco IP',
    AvgBlockDistanceOOP: 'Distanza del Blocco OOP',
    AvgBlockAreaIP: 'Area del Blocco IP',
    AvgBlockAreaOOP: 'Area del Blocco OOP',
    AvgDefensiveLineWidthOOP: 'Ampiezza Linea Difensiva OOP',
    AvgOffensiveLineLastThirdWidthIP: 'Ampiezza Linea Offensiva Ultimo Terzo IP',
    AvgLByIP: 'Posizione Terzino Sinistro IP',
    AvgRByIP: 'Posizione Terzino Destro IP',
    AvgOffensiveLineDistanceIP: 'Distanza Linea Offensiva IP',
    AvgOffensiveLineLastThirdDistanceIP: 'Distanza Linea Offensiva Ultimo Terzo IP',
    AvgOffensiveLineWidthIP: 'Ampiezza Linea Offensiva IP',
    OffBallRuns: 'Totale Movimenti Senza Palla',
    OffBallRunsOverlap: 'Sovrapposizioni',
    OffBallRunsUnderlap: 'Sotto-Posizioni',
    OffBallRunsRunAhead: 'Movimenti in Avanti',
    OffBallRunsRunBehind: 'Movimenti alle Spalle',
    OffBallRunsCrossReceiver: 'Movimento per Cross',
    OffBallRunsSupport: 'Movimento di Supporto',
    OffBallRunsComingShort: 'Movimento di Appoggio Corto',
    description: {
      Possession: 'Percentuale di Possesso della squadra',
      TimePossession: 'Tempo di possesso palla della squadra',
      PassesPerShots: 'Numero di passaggi realizzati per ogni tiro',
      PPDA: 'Passaggi per Azione Difensiva. Misura il numero dei passaggi che sono stati realizzati dalla squadra avversaria fino a che l\'azione è stata interrotta da un\'azione difensiva. A maggior PPDA, minore è il pressing esercitato sull\'avversario.',
      Directness: 'Misura quanto è verticale una squadra con i suoi passaggi,premiando i passaggi verso la porta avversaria',
      ExpectedPoints: 'Numero di punti previsti di una squadra, calculato a partire degli Expected Goals creati e ricevuti in ogni partita. Questo calcolo permette conoscere il rendimento di una squadra rispetto a una partita (o insieme di partite) confrontandolo con i punti che realmente si ha ottenuto.',
      PassesPerLongBall: 'Numero di passaggi realizzati per ogni passaggio lungo',
      CrossingPerXG: 'Percentuale di Expected Goals che vengono dal centro dell\'area',
      PenaltySavedPenaltyFaced: 'Percentuale di rigori parati per rigori ricevuti',
      Goals: 'Number of goals scored',
      PenaltyShots: 'Numero totale di tiri dal dischetto',
      PenaltyGoals: 'Numero totale di gol su rigore',
      NonPenaltyGoals: 'Gol segnati, escludendo gol su rigore,',
      NPGOpenPlay: 'Number of goals scored by open play actions excluding penalty goals',
      NPGSetPiece: 'Number of goals scored by set piece actions excluding penalty goals',
      Shooting: 'Percentuale di tiri in porta',
      Finishing: 'Percentuale di tiri che terminano in rete',
      xGEfficiency: 'Quantità di Expected Goals necessari ad un giocatore per segnare un gol',
      HeaderPerShot: 'Numero di colpi di testa',
      HeaderPerCross: 'Percentuale di cross colpiti di testa dal giocatore sul totale dei cross completati dalla squadra',
      Assists: 'Numero di assist',
      ThroughBalls: 'Passaggi filtranti',
      CrossEfficiency: 'Numero di cross completati sul totale dei cross tentati',
      ScoringContribution: 'Numero di assist e gol',
      xAssistsOpenPlay: 'Numero di Expected Assist su azione e non da palla ferma',
      xAssistsSetPiece: 'Numero di Expected Assist da palla ferma',
      xAssistsOpenPlayInTeam: 'Numero di Expected Assist su azione e non da palla ferma in Squadra',
      xAssistsSetPieceInTeam: 'Numero di Expected Assist da palla ferma in Squadra',
      xGChainFinalThird: 'Quantità di Expected Goals in cui il giocatore ha partecipato negli ultimi 35 metri',
      xGBuildupFinalThird: 'Quantità di Expected Goals Cantidad in cui il giocatore ha partecipato negli ultimi 35 metri (escludendo tiri e passaggi precedenti)',
      BallProgressionPassing: 'Progresioni del pallone tramite passaggi',
      BallProgressionDribbling: 'Progressione della palla in conduzione',
      TacklesWasDribbled: 'Parametro che prende in considerazione la percentuale delle volte in cui il giocatore recupera il pallone con contrasto vs. le volte che fu superato/dribblato. Più alto è l\'indicatore, meglio è',
      TacklesSuccessful: 'Numero di contrasti riusciti effettuati dal giocatore',
      Interceptions: 'Numero di volte in cui il giocatore intercetta un passaggio',
      Clearances: 'Numero di volte in cui il giocatore rilancia',
      Fouls: 'Numero di falli realizzati dal giocatore',
      Recoveries: 'Numero di palloni recuperati dal giocatore',
      Shots: 'Numero totale di tiri',
      ShotsPerGoal: 'Numero di tiri necessari al giocatore per segnare un gol',
      ShortPassesSuccessful: 'Numero di passaggi corti (meno di 12 metri) completati',
      PassingSuccessForwardPct: 'Percentuale di passaggi in avanti con successo',
      PassingSuccessBackwardPct: 'Percentuale di passaggi indietro con successo',
      PassingForwardBackwardPct: 'Rapporto passaggi in avanti rispetto a quelli indietro',
      LongBallPerPassesPct: 'Percentuale di passaggi lunghi rispetto al totale dei passaggi',
      LongBallReceived: 'Passaggi Lunghi ricevuti',
      LongBallReceivedOppHalf: 'Numeri di passaggi lunghi ricevuti nella metà campo avversaria',
      OffensiveActions: 'Azioni offensive',
      DribblesAttempted: 'Numero di dribbling tentati',
      SuccessfulDribblesPct: 'Dribbling con successo/totale di tiri tentati',
      OffensiveTouchesOutBoxPct: '% Tocchi offensivi fuori area',
      BallRetention: 'Percentuale di volte in cui si ha il possesso della palla e non si finisce per perderla',
      PassingPct: 'Percentuale di passaggi completati sul totale dei passaggi realizzati dal giocatore',
      PassingOwnHalfPct: 'Percentuale di passaggi con successo che arrivano nella propria metà campo',
      PassingOppHalfPct: 'Percentuale di passaggi con successo che arrivano nella metà campo avversaria',
      PassingFinalThird: 'Passaggi riusciti, esclusi cross, calci piazzati, calci d\'angolo e rimesse laterali, che iniziano nell\'ultimo terzo',
      PassesFinalThirdTotal: 'Totale dei passaggi tentati, esclusi cross, calci piazzati, calci d\'angolo e rimesse laterali, che terminano nel terzo finale',
      PassingFinalThirdPct: 'Percentuale di passaggi completati su tutti i passaggi del giocatore (solo quelli che iniziano nell\'ultimo terzo)',
      LongBallSuccessful: 'Numero di passaggi completati di più di 32 metri',
      LongBallPct: 'Percentuale di passaggi lunghi completati (più di 32 metri) con successo',
      LongBallTotal: 'Numero totale di passaggi superiori a 32 metri',
      SavesPct: 'Percentuale di parate rispetto al totale dei tiri ricevuti',
      SavesInBoxPct: 'Percentuale di parate su tiri realizzati dentro l\'area',
      SavesOutOfBoxPct: 'Percentuale di parate su tiri realizzati fuori area',
      xGSavedPerXGFacedOnTarget: 'Coefficiente che indica la percentuale degli Expected Goals bloccati dal portiere. Più è vicino a 1, più difficile è segnare',
      xGFacedOnTargetPerGoalReceived: 'Parametro che indica quanti Expected Goals sono necessari per segnare al portiere. Un punteggio alto in questo parametro significa che per segnare un gol un gol a questo Portiere è necessario avere un alto xG',
      xGFacedOnTargetEfficiency: 'Numero di gol salvati dal Portiere. Numero di Expected Goals (solo tiri in porta) meno i gol ricevuto dal portiere. Indica il numero di gol evitati grazie al portiere.',
      xGFacedOnTarget: 'Totale xG (salvati e segnati) affrontati dal portiere',
      IndividualPressure: 'Modello che quantifica il pressing del giocatore senza palla esercita sull\'avversario. Il modello misura il numero di sforzi del giocatore della squadra in difesa negli 60 metri, sia se recupera il pallone o no. Più è grande il numero del pressing, meno sarà facile creare occasioni per la squadra avversaria.',
      AerialEfficiency: 'Modello che combina la percentuale di successo dei duelli con il volume dei duelli aerei vinti',
      AerialWins: 'Numeri di duelli aerei vinti dal giocatore',
      AerialWinsPct: 'Numero di duelli aerei vinti che il giocatore vince sul totale dei duelli aerei realizzati',
      xG: 'Expected Goals creati. Questo parametro misura la percentuale di probabilità di un tiro di terminare in rete in base alle differenti variabili del sudetto tiro.',
      xGDiff: 'Differenza tra xG e obiettivi',
      xGOpenPlay: 'Gol attesi generati da Open Play',
      xGSetPiece: 'xG da Palla Ferma',
      xGPerShot: 'Expected Goals per tiro. Questo parametro misura la pericolosità media del tiro ricevuto. Più è grande, più probabilità ci sono che il tiro finisca in Rete. Un alto vslore implica che il giocatore sceglie bene i suoi tiri se vengono da dentro l\'area e vanno in porta',
      ChancesCreated: 'Numero di passaggi pases che terminano con un tiro in porta',
      CompletedCrosses: 'Cross completati',
      Crossing: 'Percentuale di cross completati con successo',
      OpenPlayKeyPasses: 'Numero di passaggi completati su azione che terminano con un tiro (assist esclusi)',
      OpenPlayKeyPassesInTeam: 'Percentuale di passaggi completati su azione che terminano con un tiro (assist esclusi) in squadra',
      OpenPlayPassesIntoOpponentBox: 'Passaggi totale nell\'area avversaria su azione',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Passaggi completati nell\'area avversaria su azione',
      xAssists: 'Usiamo xA, per dare un valore all\'assist offerto da un compagno. Se un giocatore dà un passaggio per tirare ad un suo compagno a un metro dalla porta, il\'xA sarà molto alto quindi la pericolosotià del passaggio molto alta. Usiamo la differenza (xA creati meno xA realizzati dalla squadra rivale per analizzare quanti degli xG sono creati dalle squadre attraverso azioni di squadra o indivuduali. Expected assist (xA)',
      xGChain: 'Quantità di Expected Assist in cui ha partecipato il giocatore. Se il giocatore ha partecipato ad una giocata che termina con un tiro, il xG della giocata si sommerà a questa metrica',
      xGBuildup: 'Simile alla partecipazione xG, ma senza tener conto degli ultimi due giocatori della sequenza (ultimo passatore e tiratore)',
      xGBuildupInTeam: 'Costruzione xG in Team',
      BallProgression: 'Numero di volte in cui il giocatore avanza 10 metri o più, sia con passaggi sia in conduzione della palla, o entrambe',
      SuccessfulDribbles: 'Numero di Dribbling realizzati correttamente',
      Dispossessed: 'Numero di palloni persi da parte del giocatore',
      TouchesInOpponentBox: 'Numero di azioni da parte del giocatore nell\'area avversaria',
      xGSavedPerShot: 'Pericilosità media dei tiri ricevuti in porta',
      BallRetentionOppHalf: 'Percentuale di volte in cui si ha il possesso del pallone e non si finisce per perderlo nella metà campo avversaria',
      DeepProgression: 'Numero di volte che il giocatore raggiunge gli ultimi 16 metri più il numero delle volte che il giocatore ha il controllo della palla negli ultimi 16 metri.',
      DeepProgressionFinalThird: 'Numero di volte che il giocatore raggiunge l\'Ultimo ⅓ di campo più il numero delle volte che il giocatore ha il controllo della palla nell\'Ultimo ⅓',
      FoulsTaken: 'Falli subiti',
      PenaltiesTaken: 'Rigori provocati',
      BlockedCrosses: 'Cross Intercettati',
      BlockedShots: 'Tiri intercettati',
      NonPenaltyGoalsAgainst: 'Gol subiti (rigori esclusi)',
      GoalsConceded: 'Numero di gol subiti',
      Headers: 'Colpi di Testa',
      HeadedGoals: 'Numero di gol segnati di testa',
      Points: 'Numero di punti ottenuti dalla squadra',
      SavesInBox: 'Numero di parate da tiri dentro l\'area',
      SavesOutBox: 'Numero di parate da tiri fuori area',
      ShotsOnTargetInBoxAgainst: 'Numero di tiri in porta da dentro l\'area subiti',
      ShotsOnTargetOutBoxAgainst: 'Numero di tiri in porta da fuori area subiti',
      AveragePassDistance: 'Distanza Media Passaggio',
      ProgressiveRuns: 'Conduzioni palla completate che portano il possesso un 20% in più vicino alla porta avversaria',
      xT: 'Pericolo Previsto (xT). È un parametro che misura il pericolo che un giocatore crea alla squadra avversaria portando la palla, sia in conduzione sia con passaggi, nell\'area dove la probabilità che il possesso termini con un gol è maggiore',
      xTOpenPlay: 'Pericolo Previsto su azione',
      xTSetPiece: 'Pericolo Previsto da Palla Ferma',
      xGOT: 'Expected Goals in Porta. Numero di Expected Goals subiti dal portiere. Questo parametro solo prende in considerazione i tiri in porta (Tiri fuori e sul palo sono esclusi).',
      BadActions: 'Azioni Fallite',
      BadActionsOwnHalf: 'Azioni fallite Propria Metà Campo',
      AerialsWonOwnBox: 'Duelli aerei vinti Propria Area',
      AerialsWonOppBox: 'Aerials Won Opp Box',
      AerialsTotalOppBox: 'Aerials Total Opp Box',
      AerialsTotalOwnBox: 'Aerials Total Own Box',
      FoulsOwnHalfPct: '% Falli Propria Metà Campo',
      RecoveriesOppHalf: 'Numero di palloni recuperati dal giocatore nella metà campo avversaria',
      DuelsPct: '% Duelli vincenti',
      TacklesUnsuccessful: 'Numero di volte in cui un giocatore non riesce a conquistare la palla perché un avversario lo supera con successo',
      TacklesWasDribbledFirstThird: 'Contrasti/dribbliing subito nell\'Ultimo ⅓',
      TacklesWasDribbledSecondThird: 'Duelli difensivi 1vs1 vinti ⅔',
      TacklesWasDribbledFinalThird: 'Duelli difensivi 1vs1 vinti Finale ⅓',
      BallProgressionFinalThird: 'Progressioni palla nell\'ultimo ⅓',
      DuelsTotal: 'Numero totale di Tackle, Aerials, Tocchi di Palla, Dribbling e Falli commessi',
      QuickRecoveries: 'Recuperi a 40 metri o più dalla propria porta nei seguenti 8 secondi dopo una perdita del possesso',
      ShotsPerNPG: 'Numero di tiri per Non Penalty Goials',
      ShotsOutBox: 'Tiri fuori dall\'Area',
      GoalsOutBox: 'Gol da fuori area',
      ShootingOutBox: 'Percentuale di tiri in porta dei tiri da fuori area',
      HandPassing: 'Percentuale di Passaggi completati con le mani',
      Catching: 'Percentuale di Parate bloccate',
      Caught: 'Parata dove il portiere prende e trattiene la palla, impedendo qualsiasi secondo gioco',
      ClaimAccuracy: 'Misura quanto il Portiere sia bravo a catturare/bloccare le palle aeree. Un numero alto indica che il Portiere cattura più palle aeree di quelle previste',
      HighTurnovers: 'Palle perse alte a meno di 40 metri dalla propria porta',
      ShotEndingHighTurnovers: 'Palle Perse alte (palle perse a meno di 40 metri dalla propria porta) che terminano in un tiro della squadra avversaria',
      GoalEndingHighTurnovers: 'Palle perse alte (palle perse a meno di 40 metri dalla propria porta) che terminano con un gol della squadra avversaria',
      AverageCarriesProgress: 'Distanza Media che un giocatore conduce in conduzione (metri)',
      ChanceEndingCarries: 'Conduzione di almeno 7 metri che terminano con un passaggio seguito da un tiro',
      AssistEndingCarries: 'Conduzione di almeno 7 metri che terminano con un passaggio seguito da un gol',
      ShotEndingCarries: 'Conduzione di almeno 7 metri che terminano con un tiro',
      GoalEndingCarries: 'Conduzione di almeno 7 metri che terminano con un gol',
      ShotEndingSequence: 'Sequenze che terminano in Tiro in cui il giocatore è stato coinvolto',
      GoalEndingSequence: 'Sequenze che terminano in Gol in cui il giocatore è stato coinvolto',
      xGPerNPG: 'xG per Non Penalty Goals',
      AerialWonOffensive: 'Duelli Aerei Offensivi Vinti',
      AerialWonDefensive: 'Duelli Aerei Defensivi Vinti',
      xGAgainst: 'xG Subiti',
      xGDiffAgainst: 'xG Diff Subiti',
      xGPerNPGAgainst: 'xG per Non Penalty Goals subiti',
      xGSetPieceAgainst: 'xG da Calci Piazzati subiti',
      xGOpenPlayAgainst: 'xG su azione subiti',
      xGPerShotAgainst: 'xG per Tiri subiti',
      ShotsAgainst: 'Tiri Subiti',
      ShotsOnTargetAgainst: 'Numero di tiri in porta subiti',
      RivalPossession: 'Possesso dell\'avversario',
      AerialDefensivePct: '% Duelli Aerei Difensivi',
      HighRecoveries: 'Recuperi Pericolosi',
      HighDefensiveActions: 'Azioni Difensive (contrasti, intercetti,recuperi, falli e duelli) effettuate a 40 metri dalla propria porta',
      HighDefensiveActionPct: 'Percentuale di azioni difensive (contrasti, intercetti,recuperi, falli e duelli) effettuate a 40 metri dalla propria porta',
      HighDefensiveDistance: 'Distanza media dalla propria porta di tutte le Azioni Difensive',
      PassesPerPossession: 'Passaggi per Possesso',
      LengthPerPossession: 'Distanza per Possesso',
      xTNet: 'Pericolo Previsto Netto',
      AvgCarriesDistance: 'Distanza Media Conduzioni',
      PassesForwardPct: 'Percentuale di Passaggi in avanti sul totale dei passaggi completati',
      PassesForwardSuccessful: 'Passaggi in avanti riusciti',
      PassesForwardTotal: 'Passaggi in avanti totali',
      TacklesAttempted: 'Contrasti tentati',
      DuelsLost: 'Duelli persi',
      Carries: 'Conduzioni palla',
      CarriesPct: '% Conduzioni',
      Aerials: 'Duellli Aerei',
      ProgressivePassesReceivedIntoBox: 'Passaggi Progressivi ricevuti in Aerea',
      PassesOppHalf: 'Numero totale di passaggi Completati che finiscono nella Metà Campo Avversaria',
      ShotsOnTarget: 'Tiri in Porta',
      AggressiveActions: 'Azioni Aggressive',
      Crosses: 'Cross',
      xGBuildup5pass: 'xG Costruzione 5 passaggi',
      DefensiveDistance: 'Distanza media dalla propria porta dei duelli difensivi ingaggiati',
      SpeedSequence: 'Velocità sequenza',
      Touches: 'Tocchi',
      AerialsTotalOppHalf: 'Duelli Totali Aerei Metà Campo Avversaria.',
      AerialsWonOppHalf: 'Duelli aerei riusciti nella metà campo avversaria',
      AerialsWonOppHalfPct: '% Duelli aerei vinti metà campo avversaria',
      AerialsPctOppBox: 'Percentuale di duelli aerei vinti nell\'Area Avversaria',
      AerialsPctOwnBox: 'Percentuale di duelli aerei vinti nella Propria Area',
      AerialDefensive: 'Numero totale di duelli aerei quando la squadra avversaria ha il possesso palla',
      AerialOffensive: 'Numero totale di duelli aerei in fase di possesso della propria squadra',
      AerialOffensivePct: 'Percentuale di duelli aerei vinti quando la propria squadra ha il possesso',
      IndividualPressureOppHalf: 'Pressione individuale metà campo avversaria',
      ChancesCreatedOP: 'Occasioni create su azione',
      TouchesPerShot: 'Tocchi per tiro',
      PassesFinalThirdTotalPct: '% Passaggi ultimo ⅓',
      xACrosses: 'xA da cross',
      Passes: 'Passaggi',
      PassesSuccessful: 'Passaggi completati',
      TacklesWasDribbledFouls: 'Percentuale di tackle vinti rispetto al totale dei tackle e dei falli commessi',
      OffsidesCaught: 'Fuorigioco',
      ProgressivePassesReceivedFinalThird: 'Passaggi Progressivi Ricevuti Ultimo ⅓',
      ProgressivePassesReceived: 'Passaggi Progressivi Ricevuti',
      Breadth: 'Sum of Tackles, Challenges, Interceptions and Fouls Committed, on the sides of the field',
      DuelsDefTotal: 'Defensive Duels',
      DefensiveActions: 'Defensive Actions',
      ProgressivePassesReceivedOppHalf: 'Passaggi Progressivi ricevuti nella metà Campo avversaria',
      CompletedCrossesOP: 'Cross completati su azione',
      CrossingOP: '% Cross su Azione',
      CrossesOP: 'Numero totale di cross durante il gioco aperto',
      PassingContribution: '% Contribuzione Passaggio',
      BallProgressionOppHalfInTeam: '% progressione palla metà campo avversaria in squadra',
      PassesOPIntoBoxInTeam: '% Passaggi su azione Area Avversaria in Squadra',
      TouchesOppBoxInTeam: '% Tocchi in area avversaria in squadra',
      xGOPInTeam: '% xG su azione in Squadra',
      DeepPasses: 'Passaggi dall\'esterno di un raggio di 20 metri dalla porta avversaria che terminano all\'interno di tale area',
      DeepPassesTotal: 'Totale dei passaggi tentati dall\'esterno del raggio di 20 metri dalla porta avversaria che terminano all\'interno di quell\'area',
      DefensiveDuelsPct: 'Percentuale di duelli difensivi vinti sul totale dei duelli difensivi ingaggiati',
      QuickRecoveriesPct: 'Percentuale di recuperi rapidi rispetto a intercetti e Contrasti tentati',
      DiffDefensiveDistanceTeam: 'Differenza tra la distanza difensiva del giocatore e la distanza difensiva della sua squadra',
      xTPassing: 'Pericolo Previsto provocato solo dai passaggi',
      xTPassing100Passes: 'Pericolo Previsto provocato solo dai passaggi e per 100 passaggi',
      ProgressivePassesAccurate: 'Passaggi Completati di 10 o più metri nell’asse delle X',
      PassAbility: 'Rapporto tra passaggi completati e passaggi previsti (xP)',
      OPPassesIntoOppBoxPct: 'Percentuale di passaggi completati verso l’area di rigore avversaria e di passaggi tentati verso l’area di rigore avversaria',
      EntriesOppBox: 'Numero di passaggi e conduzioni verso l’area avversaria',
      Crosses6yardBox: 'Numero totale di cross che terminano nell’area piccola',
      Cutbacks: 'Cross o Passaggi arretrati dalla linea di fondo verso il centro dell’area dei rigore',
      xTDribbling: 'Pericolo Previsto provocato solo dai dribbling',
      AvgShotDistance: 'Distanza media del numero totale dei tiri effettuati',
      xGOnTarget: 'Expected Goals da tiri in porta. Questo modello misura la probabilità di un tiro che finisca nello specchio della porta, una volta che il giocatore ha effettuato il tiro e verso quale lato della porta è stato indirizzato',
      FinishingxGOT: 'Percentuale di tiri in porta che terminano in gol. Questa metrica misura il valore aggiunto dall’attaccante con la qualità dei suoi tiri',
      DribblesWonOwnHalf: 'Numero di dribbling completati nella propria metà campo',
      DribblesOwnHalf: 'Numero di dribbling tentati nella propria metà campo',
      DribblesOwnHalfPct: 'Percentuale di dribbling completati e di dribbling tentati effettuati nella propria metà campo',
      DribblesWonOppHalf: 'Numero di dribbling completati nella metà campo avversaria',
      DribblesOppHalf: 'Numero di dribbling tentati nella metà campo avversaria',
      DribblesOppHalfPct: 'Percentuale di dribbling completati e di dribbling tentati effettuati nella metà campo avversaria',
      DribblesWonFinalThird: 'Numero di dribbling completati  nell’ultimo ⅓ di campo',
      DribblesFinalThird: 'Numero di dribbling tentati nell’ultimo ⅓ di campo',
      DribblesFinalThirdPct: 'Percentuale di dribbling completati e di dribbling tentati effettuati nell’ultimo ⅓ di campo',
      ShotEndingHighRecoveries: 'Recuperi alti (entro 40 metri dalla porta avversaria) che terminano con un tiro',
      PassingFinalThirdAgainst: 'Passaggi riusciti dell’avversario nell’ultimo terzo',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Numero totale di passaggi tentati dall’avversario nella nostra area su azione',
      EntriesOppBoxAgainst: 'Numero di passaggi e conduzioni dell’avversario nella nostra area',
      DeepProgressionAgainst: 'Numero di volte in cui l’avversario raggiunge l’ultimo quinto del campo portando palla, più i momenti di possesso nel nostro primo quinto',
      TouchesInOpponentBoxAgainst: 'Numero di volte che l’avversario ha il possesso nella nostra area',
      Score: 'Prestazioni dei giocatori basate su diverse metriche',
      PDScore: 'Prestazioni fisiche dei giocatori basate su diverse metriche fisiche',
      OrlegiScore: 'Prestazioni dei giocatori basate su diverse metriche',
      SirScore: 'Prestazioni dei giocatori basate su diverse metriche',
      ExcScore: 'Prestazioni dei giocatori basate su diverse metriche',
      xTOPInTeam: 'Pericolo atteso (xT) generato in partita rispetto al totale della propria squadra',
      YellowCards: 'Cartellini Gialli',
      RedCards: 'Cartellini Rossi',
      xTOpenPlayAgainst: 'Pericolo previsto in campo aperto',
      xTSetPieceAgainst: 'Pericolo previsto concessa da calci piazzati',
      NPGOpenPlayAgainst: 'NPG su Azione Subiti',
      NPGSetPieceAgainst: 'NPG da Palla Ferma Subiti',
      PassesOppHalfPerPossession: 'Passaggi Metà Campo Avversaria per Possesso',
      AverageTimeRecovery: 'Tempo Medio di Recupero',
      ExpectedPassing: 'Percentuale di passaggi che avrebbero dovuto essere completati',
      NumPossession10Passes: 'Possessi 10 Passaggi',
      PassesReceived: 'Passaggi Ricevuti',
      PassesReceivedFinalThird: 'Passes Received Final ⅓',
      ProgressivePassesTotalPct: '% Passaggi progressivi',
      ShortPassesPct: '% Passaggi Corti',
      TouchesOppBoxOppTeam: 'Numero di azioni avversarie concesse nella propria area quando il giocatore è in campo',
      ShotsOnTargetOppTeam: 'Tiri in porta concessi quando il giocatore è in campo',
      NPGOppTeam: 'Gol subiti esclusi i rigori quando il giocatore è in campo',
      xGSetPiecePerxG: 'xG da palla inattiva necessari per generare un xG',
      ShotsOpenPlay: 'Numero di tiri generati su azione',
      ShotsOpenPlayAgainst: 'Numero di tiri subiti su azione',
      ShotsFromDribble: 'Tiri effettuati dopo aver dribblato un avversario',
      GoalsFromDribble: 'Gol segnati dopo aver dribblato un avversario',
      PassesIntoFinalThird: 'Passaggi riusciti dall’ultimo terzo',
      PassesIntoFinalThirdTotal: 'Passaggi totali tentati che iniziano all\'esterno e terminano all\'interno del terzo finale',
      PassesInsideFinalThird: 'Passaggi riusciti all’interno dell’ultimo terzo (inizio e fine nell’ultimo terzo)',
      PassesInsideFinalThirdTotal: 'Totale dei passaggi tentati nell\'ultimo terzo (inizio e fine nell\'ultimo terzo)',
      PassesFinalThirdNoArea: 'Passa il terzo finale (SENZA casella)',
      PassesIntoOppBox: 'Passaggi riusciti che terminano nell’area avversaria',
      CarriesFinalThird: 'Conduzioni di almeno 7 metri che terminano nell’ultimo terzo',
      CarriesInsideFinalThird: 'Conduzioni di almeno 7 metri all’interno dell’ultimo terzo (inizio e fine nell’ultimo terzo)',
      CarriesFinalThirdNoBox: 'Trasporta il terzo finale (SENZA scatola)',
      CarriesIntoOppBox: 'Conduzioni di almeno 7 metri che terminano nell’area avversaria',
      TimePossessionAgainst: 'Tempo di possesso palla della squadra avversaria',
      TimePossessionTotal: 'Tempo di possesso palla di entrambe le squadre',
      PassesInBox: 'Passaggi riusciti che iniziano all\'interno dell\'area avversaria',
      LongThrowInSuccessful: 'Rimessa laterale lunga riuscita dalla linea laterale, progettata per lanciare il pallone oltre i 20 metri',
      LongThrowInTotal: 'Totale delle rimesse laterali lunghe dalla linea laterale, progettate per lanciare il pallone oltre i 20 metri',
      LongThrowInPct: 'Percentuale di rimesse laterali lunghe (oltre 20 metri) riuscite',
      Games: 'Giochi giocati',
      PointsPerGame: 'Punti per partita',
      ExpectedPointsDiff: 'Differenza di punti prevista',
      PassesTotalOwnHalf: 'Numero totale di passaggi effettuati dalla propria metà campo',
      PassesOwnHalf: 'Numero di passaggi riusciti effettuati dalla propria metà campo',
      PassesTotalOppHalf: 'Numero totale di passaggi effettuati dalla metà campo avversaria',
      ProgressivePassesTotal: 'Numero totale di passaggi di 10 metri o più sull\'asse X',
      DuelsWon: 'Duelli riusciti (contrasti, antenne, tocchi di palla, dribbling e falli commessi)',
      NonPenaltySaves: 'Parate esclusi i tiri di rigore',
      BadActionsOppHalf: 'Somma di tutte le cattive azioni commesse (passaggio fallito, ricezione fallita, espropriazione, passaggio in fuorigioco, tocco di palla fallito) nella metà campo avversaria',
      CarriesSuccessful: 'Numero di carry di almeno 7 metri terminati con un evento riuscito',
      ShotsOnTargetOutBox: 'Tiri in porta da fuori area',
      TotalDistance: 'Distanza totale percorsa dal giocatore durante una partita',
      WalkingDistance: 'Distanza totale percorsa dal giocatore durante una partita a una velocità inferiore a 2 m/s (7,2 km/h)',
      JoggingDistance: 'Distanza totale percorsa dal giocatore durante una partita a una velocità tra 2 m/s (7,2 km/h) e 4 m/s (14,4 km/h)',
      RunningDistance: 'Distanza totale percorsa dal giocatore durante una partita a una velocità tra 4 m/s (14,4 km/h) e 5,5 m/s (19,8 km/h)',
      ExtremeAccelerations: 'Numero di volte che il giocatore accelera di più di 3 m/s²',
      NumberOfRuns: 'Numero di corse completate a una velocità tra 4 m/s (14,4 km/h) e 5,5 m/s (19,8 km/h)',
      DistanceIP: 'Distanza (Squadra in Possesso) percorsa dal giocatore durante una partita con possesso',
      DistanceOOP: 'Distanza OTIP (Squadra Avversaria in Possesso) percorsa dal giocatore durante una partita senza possesso',
      HsrNumber: 'Numero di volte che il giocatore si muove a una velocità che è maggiore o uguale a 5,5 m/s (19,8 km/h) ma inferiore a 7 m/s (25,2 km/h) per un periodo di almeno 1 secondo',
      HsrDistance: 'Distanza totale percorsa dal giocatore durante una partita a una velocità che è maggiore o uguale a 5,5 m/s (19,8 km/h) ma inferiore a 7 m/s (25,2 km/h)',
      HsrDistancePct: 'Percentuale della Distanza HSR (Corsa ad Alta Velocità) rispetto alla distanza totale percorsa',
      SprintsNumber: 'Numero di volte che il giocatore si muove a una velocità che è maggiore o uguale a 7 m/s (25,2 km/h) per un periodo di almeno 1 secondo',
      SprintsDistance: 'Distanza totale percorsa dal giocatore durante una partita a una velocità che è maggiore o uguale a 7 m/s (25,2 km/h)',
      SprintNumberDeclinePct: 'Percentuale di diminuzione nel numero di sprint effettuati rispetto al secondo tempo della partita',
      SprintDistanceDeclinePct: 'Percentuale di diminuzione della distanza percorsa durante gli sprint rispetto al secondo tempo della partita',
      SprintNumberDecline: 'Diminuzione nel numero di sprint effettuati rispetto al secondo tempo della partita',
      SprintDistanceDecline: 'Diminuzione della distanza percorsa durante gli sprint rispetto al secondo tempo della partita',
      SprintDistancePct: 'Percentuale della Distanza di Sprint rispetto alla distanza totale percorsa',
      Accelerations: 'Numero di volte che il giocatore accelera tra 1,5 m/s² e 3 m/s²',
      ExplosiveDistance: 'Distanza esplosiva',
      MaxSpeed: 'Velocità massima raggiunta dal giocatore',
      AvgMaxSpeed: 'Media della velocità massima raggiunta dal giocatore',
      MaxAccelerations: 'Massima accelerazione in metri/secondo² raggiunta dal giocatore',
      BypassedPlayersByPasses: 'Numero di giocatori dal lato del portiere del portatore di palla all\'inizio dell\'azione, meno il numero di giocatori dal lato del portiere alla fine dell\'azione',
      BypassedDefendersByPasses: 'Numero di difensori dal lato del portiere del portatore di palla all\'inizio dell\'azione, meno il numero di difensori dal lato del portiere alla fine dell\'azione',
      PassesBypassingPlayers: 'Numero di passaggi che hanno superato i giocatori',
      PassesBypassingDefenders: 'Numero di passaggi che hanno superato i difensori',
      BypassedPlayersPerPass: 'Numero totale di giocatori superati per passaggio',
      BypassedDefendersPerPass: 'Numero totale di difensori superati per passaggio',
      LineBreakingPasses: 'Passaggi completati che avanzano la palla almeno del 10% più vicino alla porta avversaria e attraversano una coppia di difensori vicini o passano dietro la linea difensiva',
      LineBreakingPassesMD: 'Passaggi completati che superano le linee di centrocampo e difesa',
      LineBreakingPassesM: 'Passaggi completati che superano la linea di centrocampo',
      LineBreakingThroughBalls: 'Passaggi completati che superano la linea difensiva',
      LineBreakingPassesPerPass: 'Numero di linee rotte per passaggio',
      TotalPassesUnderStrongPressure: 'Numero totale di passaggi effettuati sotto forte pressione (entro 0-2 metri dall\'avversario più vicino)',
      TotalPassesUnderLightPressure: 'Numero totale di passaggi effettuati sotto pressione (entro 2-4 metri dall\'avversario più vicino)',
      SuccessfulPassesUnderStrongPressure: 'Numero di passaggi riusciti effettuati sotto forte pressione (entro 0-2 metri dall\'avversario più vicino)',
      SuccessfulPassesUnderLightPressure: 'Numero di passaggi riusciti effettuati sotto pressione (entro 2-4 metri dall\'avversario più vicino)',
      PassingUnderStrongPressure: 'Percentuale di passaggi riusciti e totali sotto forte pressione (entro 0-2 metri dall\'avversario più vicino)',
      PassingUnderLightPressure: 'Percentuale di passaggi riusciti e totali sotto pressione (entro 2-4 metri dall\'avversario più vicino)',
      PassReceiptsInSpaceCompleted: 'Passaggi effettuati dove il ricevitore è nella metà offensiva senza difensori entro un raggio di 5 metri verso la porta',
      PassReceiptsInSpace: 'Passaggi ricevuti nella metà offensiva senza difensori entro un raggio di 5 metri verso la porta',
      PassReceiptsInSpaceCompletedFirstThird: 'Passaggi effettuati con ricezione nel primo terzo senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceCompletedSecondThird: 'Passaggi effettuati con ricezione nel secondo terzo senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceCompletedFinalThird: 'Passaggi effettuati con ricezione nell’ultimo terzo senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Passaggi effettuati con ricezione nella metà campo avversaria (lato destro) senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Passaggi effettuati con ricezione nella metà campo avversaria (zona centrale) senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Passaggi effettuati con ricezione nella metà campo avversaria (lato sinistro) senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceFirstThird: 'Passaggi ricevuti nel primo terzo senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceSecondThird: 'Passaggi ricevuti nel secondo terzo senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceFinalThird: 'Passaggi ricevuti nell’ultimo terzo senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceOppHalfRight: 'Passaggi ricevuti nella metà campo avversaria (lato destro) senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceOppHalfCenter: 'Passaggi ricevuti nella metà campo avversaria (zona centrale) senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceOppHalfLeft: 'Passaggi ricevuti nella metà campo avversaria (lato sinistro) senza difensori entro 5 metri nella direzione della porta',
      TotalStrongOnBallPressures: 'Numero di pressioni forti sul portatore di palla (entro 0-2 metri)',
      TotalLightOnBallPressures: 'Numero di pressioni sul portatore di palla (entro 2-4 metri)',
      SuccessfulStrongOnBallPressures: 'Numero di pressioni forti riuscite sul portatore di palla (entro 0-2 metri)',
      SuccessfulLightOnBallPressures: 'Numero di pressioni riuscite sul portatore di palla (entro 2-4 metri)',
      StrongOnBallPressuresPct: 'Percentuale di pressioni forti riuscite e totali sul portatore di palla (entro 0-2 metri dall\'avversario più vicino)',
      LightOnBallPressuresPct: 'Percentuale di pressioni riuscite e totali sul portatore di palla (entro 2-4 metri dall\'avversario più vicino)',
      TimesBypassedByPasses: 'Numero totale di volte superato da un passaggio',
      TimesBypassedByCarries: 'Numero totale di volte superato da una conduzione',
      TimesBypassedByActions: 'Numero totale di volte superato da passaggi e conduzioni combinati',
      BypassedPlayersByCarries: 'Numero totale di avversari (difensori e centrocampisti) superati tramite conduzioni',
      BypassedDefendersByCarries: 'Numero totale di avversari (difensori) superati tramite conduzioni',
      BypassedPlayersByActions: 'Numero totale di avversari (difensori e centrocampisti) superati tramite passaggi e conduzioni combinati',
      BypassedDefendersByActions: 'Numero totale di avversari (difensori) superati tramite passaggi e conduzioni combinati',
      CarriesBypassingPlayers: 'Numero di conduzioni che hanno superato giocatori',
      CarriesBypassingDefenders: 'Numero di conduzioni che hanno superato difensori',
      BypassedPlayersPerCarry: 'Media di avversari superati per conduzione',
      BypassedDefendersPerCarry: 'Media di difensori superati per conduzione',
      LineBreakingCarries: 'Numero di conduzioni che hanno superato una o più linee difensive',
      LineBreakingCarriesMD: 'Numero di conduzioni che hanno superato le linee di centrocampo e difesa',
      LineBreakingCarriesM: 'Numero di conduzioni che hanno superato la linea di centrocampo',
      LineBreakingCarriesD: 'Numero di conduzioni che hanno superato la linea difensiva',
      LineBreakingCarriesPerCarry: 'Percentuale di conduzioni tra le linee per conduzione',
      LineBreakingActions: 'Numero di passaggi e conduzioni combinati che hanno superato una o più linee difensive',
      LineBreakingActionsMD: 'Numero di passaggi e conduzioni combinati che hanno superato le linee di centrocampo e difesa',
      LineBreakingActionsM: 'Numero di passaggi e conduzioni combinati che hanno superato la linea di centrocampo',
      LineBreakingActionsD: 'Numero di passaggi e conduzioni combinati che hanno superato la linea difensiva',
      PassesPerLineBreakingPass: 'Rapporto tra il numero totale di passaggi per passaggio tra le linee',
      CarriesPerLineBreakingCarry: 'Rapporto tra il numero totale di conduzioni per conduzione tra le linee',
      LinesBrokenByPasses: 'Numero totale di linee superate tramite passaggi',
      LinesBrokenByCarries: 'Numero totale di linee superate tramite conduzioni',
      LinesBrokenByActions: 'Numero totale di linee superate tramite passaggi e conduzioni combinati',
      LinesBrokenPerPass: 'Rapporto tra il numero totale di linee superate per passaggio',
      LinesBrokenPerCarry: 'Rapporto tra il numero totale di linee superate per conduzione',
      AvgLastDefenderDistanceIP: 'Distanza tra l\'ultimo difensore (più vicino alla propria porta) e la linea di porta in possesso',
      AvgLastDefenderDistanceOOP: 'Distanza tra l\'ultimo difensore (più vicino alla propria porta) e la linea di porta senza possesso',
      AvgDefensiveLineDistanceIP: 'Distanza tra la linea difensiva più arretrata e la porta in possesso',
      AvgDefensiveLineDistanceOOP: 'Distanza tra la linea difensiva più arretrata e la porta senza possesso',
      AvgRBDistanceIP: 'Distanza tra il terzino destro e la propria porta in possesso',
      AvgRBDistanceOOP: 'Distanza tra il terzino destro e la propria porta senza possesso',
      AvgLBDistanceIP: 'Distanza tra il terzino sinistro e la propria porta in possesso',
      AvgLBDistanceOOP: 'Distanza tra il terzino sinistro e la propria porta senza possesso',
      AvgBlockDistanceIP: 'Distanza tra il giocatore più avanzato e quello più arretrato in possesso',
      AvgBlockDistanceOOP: 'Distanza tra il giocatore più avanzato e quello più arretrato senza possesso',
      AvgBlockAreaIP: 'Area del rettangolo che racchiude tutti i giocatori di movimento (misura dello spazio occupato) in possesso',
      AvgBlockAreaOOP: 'Area del rettangolo che racchiude tutti i giocatori di movimento (misura dello spazio occupato) senza possesso',
      AvgDefensiveLineWidthOOP: 'Larghezza della linea difensiva più arretrata senza possesso',
      AvgOffensiveLineLastThirdWidthIP: 'Larghezza orizzontale della linea offensiva nell’ultimo terzo in possesso',
      AvgLByIP: 'Posizione del terzino sinistro in possesso',
      AvgRByIP: 'Posizione del terzino destro in possesso',
      AvgOffensiveLineDistanceIP: 'Distanza tra la propria porta e la linea offensiva in possesso',
      AvgOffensiveLineLastThirdDistanceIP: 'Distanza tra la propria porta e la linea offensiva nell’ultimo terzo in possesso',
      AvgOffensiveLineWidthIP: 'Larghezza orizzontale della linea offensiva in possesso',
      OffBallRuns: 'Movimenti intenzionali senza palla per supportare la fase offensiva',
      OffBallRunsOverlap: 'Movimenti in cui il giocatore corre all\'esterno del compagno (verso la fascia) mentre quest\'ultimo ha il pallone',
      OffBallRunsUnderlap: 'Movimenti in cui il giocatore corre all’interno del compagno, verso il centro del campo',
      OffBallRunsRunAhead: 'Corsa in avanti che supera il portatore di palla ma resta davanti all’ultimo difensore',
      OffBallRunsRunBehind: 'Corsa in avanti che entra nell’ultima linea difensiva, tra difensori e portiere',
      OffBallRunsCrossReceiver: 'Un giocatore si inserisce in area per ricevere un cross da un compagno',
      OffBallRunsSupport: 'Il giocatore corre per affiancare il portatore di palla offrendo un’opzione di passaggio vicina',
      OffBallRunsComingShort: 'Il giocatore va incontro al portatore di palla per offrire supporto o una linea di passaggio lontano dalla porta',
      AerialsOppHalf: 'Duelli aerei metà campo avversaria',
      CarriesIntoFinalThird: 'Condotte di almeno 7 metri dall\'esterno all\'interno dell\'ultimo terzo',
      SpeedScore: 'Prestazioni fisiche del giocatore basate su diversi parametri di velocità',
      EnduranceScore: 'Prestazioni fisiche di resistenza del giocatore basate su diverse metriche',
      SwitchPlaySuccessful: 'Numero di passaggi completati su una distanza di 32 metri in cui lo spostamento laterale della palla è maggiore del suo spostamento verso la porta avversaria',
      SwitchPlayTotal: 'Numero totale di tentativi di passaggio oltre i 32 metri in cui lo spostamento laterale della palla è maggiore del suo spostamento verso la porta avversaria',
      PassesInsideOppHalf: 'Numero totale di passaggi che iniziano e finiscono nella metà campo avversaria',
      PassesInsideOppHalfSuccessful: 'Numero di passaggi completati che iniziano e finiscono nella metà campo avversaria',
      TacklesAttemptedFirstThird: 'Numero totale di contrasti tentati nel primo terzo del campo',
      TacklesAttemptedSecondThird: 'Numero totale di contrasti tentati nel secondo terzo del campo',
      TacklesFirstThird: 'Numero di contrasti riusciti effettuati nel primo terzo del campo',
      TacklesSecondThird: 'Numero di contrasti riusciti effettuati nel secondo terzo del campo',
      FoulsOwnHalf: 'Numero di falli commessi nella propria metà campo',
      TouchesOppHalf: 'Numero di tocchi di palla nella metà campo avversaria',
      TacklesAttemptedNotAdjusted: 'Numero totale di contrasti tentati, senza aggiustamento del possesso',
      TacklesSuccessfulNotAdjusted: 'Numero totale di contrasti riusciti, senza aggiustamento del possesso',
      AvgTop5MaxSpeed: 'Media delle cinque velocità massime più alte del giocatore',
      LBPReceived: 'Numero di passaggi di interruzione di riga ricevuti. Si tratta di passaggi completati che spostano la palla più vicino alla porta avversaria di almeno il 10% e intersecano una coppia di difensori nelle immediate vicinanze o viaggiano oltre la linea difensiva',
      LBPMReceived: 'Numero di passaggi ricevuti che sfondano la linea del centrocampo avversario',
      LBPMDReceived: 'Numero di passaggi ricevuti che sfondano sia il centrocampo avversario che le linee difensive',
      ThroughBallReceived: 'Numero di passaggi ricevuti che sfondano l\'ultima linea difensiva degli avversari',
      HsrDistanceIP: 'Distanza dello sprint >21 km/h in possesso di possesso',
      HsrDistanceOOP: 'Distanza dello sprint >21 km/h senza possesso palla',
      JoggingDistanceIP: 'Distanza di jogging in possesso di palla',
      JoggingDistanceOOP: 'Distanza di jogging senza possesso palla',
      RunningDistanceIP: 'Distanza di corsa in possesso di palla',
      RunningDistanceOOP: 'Correre a distanza senza possesso palla',
      SprintsDistanceIP: 'Distanza dello sprint >24 km/h in possesso di palla',
      SprintsDistanceOOP: 'Distanza dello sprint >24 km/h senza possesso palla',
      WalkingDistanceIP: 'Possesso a pochi passi',
      WalkingDistanceOOP: 'A pochi passi dal possesso',
      RunningNumberIP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second with possession',
      RunningNumberOOP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second without possession',
      RunningDistancePctIP: 'Percentage of Running Distance with respect to total distance travelled with possession',
      RunningDistancePctOOP: 'Percentage of Running Distance with respect to total distance travelled without possession',
      RunningDistancePct: 'Percentage of Running Distance with respect to total distance travelled',
      HsrNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      HsrNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      SprintsNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsDistancePctIP: 'Percentage of Sprint Distance with respect to total distance travelled with possession',
      SprintsDistancePctOOP: 'Percentage of Sprint Distance with respect to total distance travelled without possession',
      SprintsDistancePct: 'Percentage of Sprint Distance with respect to total distance travelled',
      PossessionRegain: 'Numero di volte in cui costringi l\'avversario a perdere il possesso',
      HandPassesSuccessful: 'Passaggi riusciti effettuati con le mani (portieri o rimesse su calcio piazzato)',
      HandPassesTotal: 'Numero totale di passaggi effettuati con le mani (portieri o rimesse su calcio piazzato)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player'
    },
    subtitles: {
      Possession: 'Percentuale di Possesso della squadra',
      TimePossession: 'Tempo di possesso palla della squadra',
      PassesPerShots: 'Numero di passaggi completati per ogni tiro',
      PPDA: 'Passaggi per Azione Difensiva',
      Directness: 'Misura quanto è verticale una squadra con i suoi passaggi, premiando i passaggi verso la porta avversaria',
      ExpectedPoints: 'Numero di punti attesi da una squadra, calcolato in base agli Obiettivi Attesi',
      PassesPerLongBall: 'Numero di passaggi completati per passaggio lungo',
      CrossingPerXG: 'Percentuale di Expected Goals che vengono da cross',
      PenaltySavedPenaltyFaced: 'Percentuale di rigori parati per rigori ricevuti',
      Goals: 'Number of goals scored',
      PenaltyShots: 'Numero totale di tiri dal dischetto',
      PenaltyGoals: 'Numero totale di gol su rigore',
      NonPenaltyGoals: 'Gol (escludendo Rigori)',
      AerialWins: 'Duelli aerei vinti',
      AerialEfficiency: 'Modello che combina i duelli aerei vinti con i duelli aerei totali',
      AerialWinsPct: 'Percentuale di Duelli Aerei Vinti',
      Assists: 'Assist',
      Catching: 'Percentuale Presa',
      Caught: 'Parata dove il portiere prende e trattiene la palla, impedendo qualsiasi secondo gioco',
      ChancesCreated: 'Numero di passaggi che si convertono in un tiro',
      ClaimAccuracy: 'Precisione Uscita Alta sopra la media',
      CompletedCrosses: 'Croci completate con successo',
      Crossing: 'Percentuale di Cross Completati',
      Dispossessed: 'Perdite del possesso',
      Finishing: 'Percentuale di Tiri che terminano in Gol',
      xGEfficiency: 'Quantità di Expected Goals necessari per un giocatore per segnare un gol',
      Fouls: 'Falli commessi',
      DeepProgression: 'Numero di volte in cui si raggiunge l\'ultimo quinto del campo portando la palla, più il numero di volte in cui il possesso della palla avviene nell\'ultimo quinto',
      DeepProgressionFinalThird: 'Volte in cui il giocatore ha il possesso nell\'Ultimo ⅓',
      FoulsTaken: 'Falli subiti',
      IndividualPressure: 'Numero di Pressing',
      Interceptions: 'Passaggi Intercettati',
      LongBallPct: 'Percentuale di Passaggi di almeno 32 metri completati',
      LongBallTotal: 'Numero totale di passaggi superiori a 32 metri',
      LongBallSuccessful: 'Passaggi di almeno 32 metri completati',
      NPGOpenPlay: 'Goals (excluding penalties) by open play actions',
      NPGSetPiece: 'Goals (excluding penalties) by set piece actions',
      OpenPlayKeyPasses: 'Passaggi che terminano con un tiro (escludendo assist)',
      OpenPlayKeyPassesInTeam: 'Percentuale di Passaggi che terminano con un tiro (escludendo assist) in squadra',
      PassingFinalThird: 'Passaggi riusciti, esclusi cross, calci piazzati, calci d\'angolo e rimesse laterali, che iniziano nell\'ultimo terzo',
      PassesFinalThirdTotal: 'Totale dei passaggi tentati, esclusi cross, calci piazzati, calci d\'angolo e rimesse laterali, che terminano nel terzo finale',
      PassingFinalThirdPct: 'Percentuale di passaggi completati su tutti i passaggi del giocatore (solo quelli che iniziano nell\'ultimo terzo)',
      PassingOppHalfPct: 'Percentuale di Passaggi completati nella metà campo avversaria',
      PassingOwnHalfPct: 'Percentuale di Passaggi completati nella propria metà campo',
      PassingPct: 'Percentuale di Passaggi Completati',
      Recoveries: 'Numero di palloni recuperati dal giocatore',
      SavesInBoxPct: 'Percentuale di Parate dentro l\'area',
      SavesOutOfBoxPct: 'Percentuale di Parate fuori area',
      SavesPct: 'Percentuale di Parate',
      ScoringContribution: 'Numero di Assist e Gol',
      xAssistsOpenPlay: 'Numero di Expected Assist su azione e non da palla ferma',
      xAssistsSetPiece: 'Numero di Expected Assist da palla ferma',
      xAssistsOpenPlayInTeam: 'Numero di Expected Assist su azione e non da palla ferma in Squadra',
      xAssistsSetPieceInTeam: 'Numero di Expected Assist da palla ferma in Squadra',
      xGChainFinalThird: 'Quantità di Expected Goals in cui il giocatore ha partecipato negli ultimi 35 metri',
      xGBuildupFinalThird: 'Quantità di Expected Goals Cantidad in cui il giocatore ha partecipato negli ultimi 35 metri (escludendo tiri e passaggi precedenti)',
      BallProgressionPassing: 'Progresioni del pallone tramite passaggi',
      BallProgressionDribbling: 'Progressione della palla in conduzione',
      Shooting: 'Percentuale di Tiri in porta (escludendo Rigori)',
      Shots: 'Numero Totale di Tiri (escludendo Rigori)',
      ShotsPerGoal: 'Numero medio di Tiri in porta per fare un Gol',
      SuccessfulDribbles: 'Dribbling Completati',
      TacklesSuccessful: 'Numero Totale di Contrasti',
      TacklesWasDribbled: 'Percentuale di duelli vinti con Tackle',
      ThroughBalls: 'Numero di Passaggi filtranti',
      TouchesInOpponentBox: 'Numero di tocchi del pallone nell\'area avversaria',
      xAssists: 'Expected Assist creati',
      xG: 'Expected Goals creati',
      xGDiff: 'Differenza tra xG e obiettivi',
      xGOpenPlay: 'Gol attesi generati da gioco aperto',
      xGSetPiece: 'xG da palla ferma',
      xGBuildup: 'Costruzione di xG',
      xGBuildupInTeam: 'Costruzione xG in Team',
      BallProgression: 'Progressioni con passaggio o in conduzione di più di 10 metri',
      xGChain: 'Partecipazione a xG',
      xGPerNPG: 'Media di xG per Gol (escludendo Rigori)',
      xGPerShot: 'Media di xG per Tiro',
      xGSavedPerShot: 'Media di xG Parati per tiro ricevuto',
      xGSavedPerXGFacedOnTarget: 'Media di xG Parati per xG Subito in porta',
      xGFacedOnTargetPerGoalReceived: 'Expected Goals sono necessari per fare un gol al portiere',
      xGFacedOnTargetEfficiency: 'Numero di gol evitati dal portiere',
      xGFacedOnTarget: 'Totale xG (salvati e segnati) affrontati dal portiere',
      HighTurnovers: 'Palle perse a meno di 40 metri dalla propria porta',
      OpenPlayPassesIntoOpponentBox: 'Passaggi totale su azione dal giocatore in Area Avversaria',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Passaggi completati su azione dal giocatore in Area Avversaria',
      ChancesCreatedOP: 'Occasioni create su azione',
      PenaltiesTaken: 'Rigori provocati',
      BlockedCrosses: 'Cross Intercettati',
      BlockedShots: 'Tiri intercettati',
      NonPenaltyGoalsAgainst: 'Gol subiti (rigori esclusi)',
      Headers: 'Colpi di Testa',
      AveragePassDistance: 'Distanza Media di Passaggio',
      ProgressiveRuns: 'Conduzioni palla riuscite che portano il possesso un 20% in più vicino alla porta avversaria',
      xT: 'Pericolo creato portando la palla in zone pericolose',
      xTOpenPlay: 'Pericolo Previsto su azione e non a palla ferma',
      xTSetPiece: 'Pericolo Previsto da palla ferma e non su azione',
      xGOT: 'Expected Goals in porta. Numero di Expected Goals subiti dal portiere',
      BadActions: 'Azioni Fallite',
      BadActionsOwnHalf: 'Azioni fallite propria metà campo',
      AerialsWonOwnBox: 'Duelli aerei vinti nella propria area',
      AerialsWonOppBox: 'Aerials Won Opp Box',
      AerialsTotalOppBox: 'Aerials Total Opp Box',
      AerialsTotalOwnBox: 'Aerials Total Own Box',
      FoulsOwnHalfPct: '% Falli campo proprio',
      RecoveriesOppHalf: 'Numero di palloni recuperati dal giocatore nella metà campo avversaria',
      DuelsPct: '% Duelli vincenti',
      TacklesUnsuccessful: 'Numero di volte in cui un giocatore non riesce a conquistare la palla perché un avversario lo supera con successo',
      TacklesWasDribbledFirstThird: 'Duelli difensivi 1vs1 vinti subito nell\'Ultimo ⅓',
      TacklesWasDribbledSecondThird: 'Duelli difensivi 1vs1 vinti ⅔',
      TacklesWasDribbledFinalThird: 'Duelli difensivi 1vs1 vinti Finale ⅓',
      BallProgressionFinalThird: 'Progressioni di palla nell\'ultimo ⅓',
      DuelsTotal: 'Numero totale di tackle, aerials, tocchi di palla, dribbling e falli commessi',
      QuickRecoveries: 'Recuperi a 40 metri o più dalla propria porta nei seguenti 8 secondi dopo una perdita',
      ShotsPerNPG: 'Numero di tiri per Non Penalty Goials',
      ShotsOutBox: 'Tiri fuori dall\'Area',
      GoalsOutBox: 'Gol da fuori area',
      ShootingOutBox: 'Percentuale di tiri in porta dei tiri da fuori area',
      HandPassing: 'Percentuale di Passaggi completati con le mani',
      ShotEndingHighTurnovers: 'Palle Perse alte che terminano in un tiro della squadra avversaria',
      GoalEndingHighTurnovers: 'Palle perse alte che terminano con un gol della squadra avversaria',
      AverageCarriesProgress: 'Distanza Media che un giocatore muove la palla verticalmente in conduzione (metri)',
      ChanceEndingCarries: 'Conduzione di almeno 7 metri che terminano con un passaggio seguito da un tiro',
      AssistEndingCarries: 'Conduzione di almeno 7 metri che terminano con un passaggio seguito da un gol',
      ShotEndingCarries: 'Conduzione di almeno 7 metri che terminano con un tiro',
      GoalEndingCarries: 'Conduzione di almeno 7 metri che terminano con un gol',
      ShotEndingSequence: 'Sequenze che terminano in Tiro in cui il giocatore è stato coinvolto',
      GoalEndingSequence: 'Sequenze che terminano in Gol in cui il giocatore è stato coinvolto',
      AerialWonOffensive: 'Duelli Aerei Offensivi Vinti',
      AerialWonDefensive: 'Duelli Aerei Defensivi Vinti',
      xGAgainst: 'xG Subiti',
      xGDiffAgainst: 'xG Diff Subiti',
      xGPerNPGAgainst: 'xG per Non Penalty Goals subiti',
      xGOpenPlayAgainst: 'xG su azione subiti',
      xGSetPieceAgainst: 'xG da Calci Piazzati subiti',
      xGPerShotAgainst: 'xG per Tiri subiti',
      ShotsAgainst: 'Tiri Subiti',
      ShotsOnTargetAgainst: 'Tiri in porta subiti',
      RivalPossession: 'Possesso dell\'avversario',
      AerialDefensivePct: '% Duelli Aerei Difensivi',
      HighRecoveries: 'Recuperi Pericolosi',
      HighDefensiveActions: 'Azioni Difensive (contrasti, intercetti,recuperi, falli e duelli) effettuate a 40 metri dalla propria porta',
      HighDefensiveActionPct: 'Percentuale di azioni difensive (placcaggi, intercettazioni, blocchi, falli e 1vs1) effettuate a 40 metri dalla propria linea di base',
      HighDefensiveDistance: 'Distanza media dalla propria porta di tutte le Azioni Difensive',
      PassesPerPossession: 'Passaggi per Possesso',
      LengthPerPossession: 'Distanza per Possesso',
      xTNet: 'Peligro Esperado Neto',
      AvgCarriesDistance: 'Distanza Media Conduzioni',
      PassesForwardPct: 'Porcentuale di Passaggi in avanti sul totale',
      PassesForwardSuccessful: 'Passaggi in avanti riusciti',
      PassesForwardTotal: 'Passaggi in avanti totali',
      TacklesAttempted: 'Tackles tentati',
      DuelsLost: 'Duelli persi',
      Carries: 'Conduzioni',
      CarriesPct: '% Conduzioni',
      Aerials: 'Duellli aerei',
      ProgressivePassesReceivedIntoBox: 'Passaggi progressivi ricevuti in Aerea',
      PassesOppHalf: 'Numero totale di passaggi riusciti che finiscono nel campo avversario',
      LongBallReceived: 'Passaggi Lunghi ricevuti',
      ShotsOnTarget: 'Tiri in Porta',
      AggressiveActions: 'Azioni Aggressive',
      Crosses: 'Cross',
      xGBuildup5pass: 'xG Costruzione 5 passaggi',
      DefensiveDistance: 'Distanza media dalla propria porta dei duelli difensivi ingaggiati',
      SpeedSequence: 'Velocità sequenza',
      Touches: 'Tocchi',
      AerialsTotalOppHalf: 'Duelli Totali Aerei Metà Campo Avv.',
      AerialsWonOppHalf: 'Duelli aerei riusciti nella metà campo avversaria',
      AerialsWonOppHalfPct: '% Duelli aerei vinti metà campo avversaria',
      AerialsPctOppBox: 'Percentage of aerials duels won into opponent box',
      AerialsPctOwnBox: 'Percentage of aerials duels won into own box',
      AerialDefensive: 'Numero totale di duelli aerei quando la squadra avversaria ha il possesso palla',
      AerialOffensive: 'Numero totale di duelli aerei in fase di possesso della propria squadra',
      AerialOffensivePct: 'Percentuale di duelli aerei vinti quando la propria squadra ha il possesso',
      IndividualPressureOppHalf: 'Pressione individuale metà campo avversaria',
      TouchesPerShot: 'Tocchi per tiro',
      PassesFinalThirdTotalPct: '% Passaggi ultimo ⅓',
      xACrosses: 'xA da cross',
      Passes: 'Passaggi',
      PassesSuccessful: 'Passaggi con successo',
      TacklesWasDribbledFouls: 'Percentuale di tackle vinti rispetto al totale dei tackle e dei falli commessi',
      OffsidesCaught: 'Fuorigioco',
      ProgressivePassesReceivedFinalThird: 'Passaggi Progressivi Ricevuti Ultimo ⅓',
      ProgressivePassesReceived: 'Passaggi Progressivi Ricevuti',
      Breadth: 'Sum of tackles, challenges, interceptions and fouls committed, on the sides of the field',
      DuelsDefTotal: 'Duelli difensivi',
      DefensiveActions: 'Azioni Difensive',
      ProgressivePassesReceivedOppHalf: 'Passaggi progressivi ricevuti nella metà campo avversaria',
      CompletedCrossesOP: 'Cross Completati su Azione',
      CrossingOP: '% Cross su azione',
      CrossesOP: 'Numero totale di cross durante il gioco aperto',
      PassingContribution: '% Contribuzione Passaggio',
      BallProgressionOppHalfInTeam: '% Progressione Palla nella metà campo avversaria',
      PassesOPIntoBoxInTeam: '% Passaggi su Azione nell\'Area Avversaria in Squadra',
      TouchesOppBoxInTeam: '% Tocchi in Area Avversaria in Squadra',
      xGOPInTeam: '% xG su Azione in Squadra',
      DeepPasses: 'Passaggi dall\'esterno di un raggio di 20 metri dalla porta avversaria che terminano all\'interno di tale area',
      DeepPassesTotal: 'Totale dei passaggi tentati dall\'esterno del raggio di 20 metri dalla porta avversaria che terminano all\'interno di quell\'area',
      DefensiveDuelsPct: 'Percentuale di duelli difensivi vinti sul totale dei duelli difensivi',
      QuickRecoveriesPct: 'Percentuale di recuperi rapidi rispetto agli intercetti e ai tackle tentati',
      DiffDefensiveDistanceTeam: 'Differenza tra la distanza difensiva del giocatore e la distanza difensiva della sua squadra',
      xTPassing: 'Pericolo Previsto provocato solo dai passaggi',
      xTPassing100Passes: 'Pericolo Previsto provocato solo dai passaggi e per 100 passaggi',
      ProgressivePassesAccurate: 'Passaggi Completati di 10 o più metri nell’asse delle X',
      PassAbility: 'Rapporto tra passaggi completati e passaggi previsti (xP)',
      OPPassesIntoOppBoxPct: 'Percentuale di passaggi completati verso l’area di rigore avversaria e di passaggi tentati verso l’area di rigore avversaria',
      EntriesOppBox: 'Numero di passaggi e conduzioni verso l’area avversaria',
      Crosses6yardBox: 'Numero totale di cross che terminano nell’area piccola',
      Cutbacks: 'Cross o Passaggi arretrati dalla linea di fondo verso il centro dell’area dei rigore',
      xTDribbling: 'Pericolo Previsto provocato solo dai dribbling',
      AvgShotDistance: 'Distanza media del numero totale dei tiri effettuati',
      xGOnTarget: 'Expected Goals da tiri in porta. Questo modello misura la probabilità di un tiro che finisca nello specchio della porta, una volta che il giocatore ha effettuato il tiro e verso quale lato della porta è stato indirizzato',
      FinishingxGOT: 'Percentuale di tiri in porta che terminano in gol. Questa metrica misura il valore aggiunto dall’attaccante con la qualità dei suoi tiri',
      DribblesWonOwnHalf: 'Numero di dribbling completati nella propria metà campo',
      DribblesOwnHalf: 'Numero di dribbling tentati nella propria metà campo',
      DribblesOwnHalfPct: 'Percentuale di dribbling completati e di dribbling tentati effettuati nella propria metà campo',
      DribblesWonOppHalf: 'Numero di dribbling completati nella metà campo avversaria',
      DribblesOppHalf: 'Numero di dribbling tentati nella metà campo avversaria',
      DribblesOppHalfPct: 'Percentuale di dribbling completati e di dribbling tentati effettuati nella metà campo avversaria',
      DribblesWonFinalThird: 'Numero di dribbling completati nell’ultimo ⅓ di campo',
      DribblesFinalThird: 'Numero di dribbling tentati nell’ultimo ⅓ di campo',
      DribblesFinalThirdPct: 'Percentuale di dribbling completati e di dribbling tentati effettuati nell’ultimo ⅓ di campo',
      ShotEndingHighRecoveries: 'Recuperi alti (entro 40 metri dalla porta avversaria) che terminano con un tiro',
      PassingFinalThirdAgainst: 'Passaggi riusciti dell’avversario nell’ultimo terzo',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Numero totale di passaggi tentati dall’avversario nella nostra area su azione',
      EntriesOppBoxAgainst: 'Numero di passaggi e conduzioni dell’avversario nella nostra area',
      DeepProgressionAgainst: 'Numero di volte in cui l’avversario raggiunge l’ultimo quinto del campo portando palla, più i momenti di possesso nel nostro primo quinto',
      TouchesInOpponentBoxAgainst: 'Numero di volte che l’avversario ha il possesso nella nostra area',
      Score: 'Prestazioni dei giocatori basate su diverse metriche',
      PDScore: 'Prestazioni fisiche dei giocatori basate su diverse metriche fisiche',
      OrlegiScore: 'Prestazioni dei giocatori basate su diverse metriche',
      SirScore: 'Prestazioni dei giocatori basate su diverse metriche',
      ExcScore: 'Prestazioni dei giocatori basate su diverse metriche',
      xTOPInTeam: 'Pericolo atteso (xT) generato in partita rispetto al totale della propria squadra',
      YellowCards: 'Cartellini Gialli',
      RedCards: 'Cartellini Rossi',
      xTOpenPlayAgainst: 'Pericolo previsto in campo aperto',
      xTSetPieceAgainst: 'Pericolo previsto concessa da calci piazzati',
      NPGOpenPlayAgainst: 'NPG su Azione Subiti',
      NPGSetPieceAgainst: 'NPG da Palla Ferma Subiti',
      PassesOppHalfPerPossession: 'Passaggi Metà Campo Avversaria per Possesso',
      AverageTimeRecovery: 'Tempo Medio di Recupero',
      ExpectedPassing: 'Percentuale di passaggi che avrebbero dovuto essere completati',
      NumPossession10Passes: 'Possessi 10 Passaggi',
      PassesReceived: 'Passaggi Ricevuti',
      PassesReceivedFinalThird: 'Passes Received Final ⅓',
      ProgressivePassesTotalPct: '% Passaggi progressivi',
      ShortPassesPct: '% Passaggi Corti',
      TouchesOppBoxOppTeam: 'Numero di azioni avversarie concesse nella propria area quando il giocatore è in campo',
      ShotsOnTargetOppTeam: 'Tiri in porta concessi quando il giocatore è in campo',
      NPGOppTeam: 'Gol subiti esclusi i rigori quando il giocatore è in campo',
      xGSetPiecePerxG: 'xG da palla inattiva necessari per generare un xG',
      ShotsOpenPlay: 'Numero di tiri generati su azione',
      ShotsOpenPlayAgainst: 'Numero di tiri subiti su azione',
      ShotsFromDribble: 'Tiri effettuati dopo aver dribblato un avversario',
      GoalsFromDribble: 'Gol segnati dopo aver dribblato un avversario',
      PassesIntoFinalThird: 'Passaggi riusciti dall’ultimo terzo',
      PassesIntoFinalThirdTotal: 'Passaggi totali tentati che iniziano all\'esterno e terminano all\'interno del terzo finale',
      PassesInsideFinalThird: 'Passaggi riusciti all’interno dell’ultimo terzo (inizio e fine nell’ultimo terzo)',
      PassesInsideFinalThirdTotal: 'Totale dei passaggi tentati nell\'ultimo terzo (inizio e fine nell\'ultimo terzo)',
      PassesFinalThirdNoArea: 'Passa il terzo finale (SENZA casella)',
      PassesIntoOppBox: 'Passaggi riusciti che terminano nell’area avversaria',
      CarriesFinalThird: 'Conduzioni di almeno 7 metri che terminano nell’ultimo terzo',
      CarriesInsideFinalThird: 'Conduzioni di almeno 7 metri all’interno dell’ultimo terzo (inizio e fine nell’ultimo terzo)',
      CarriesFinalThirdNoBox: 'Trasporta il terzo finale (SENZA scatola)',
      CarriesIntoOppBox: 'Conduzioni di almeno 7 metri che terminano nell’area avversaria',
      TimePossessionAgainst: 'Tempo di possesso palla della squadra avversaria',
      TimePossessionTotal: 'Tempo di possesso palla di entrambe le squadre',
      PassesInBox: 'Passaggi riusciti che iniziano all\'interno dell\'area avversaria',
      LongThrowInSuccessful: 'Rimessa laterale lunga riuscita dalla linea laterale, progettata per lanciare il pallone oltre i 20 metri',
      LongThrowInTotal: 'Totale delle rimesse laterali lunghe dalla linea laterale, progettate per lanciare il pallone oltre i 20 metri',
      LongThrowInPct: 'Percentuale di rimesse laterali lunghe (oltre 20 metri) riuscite',
      Games: 'Giochi giocati',
      PointsPerGame: 'Punti per partita',
      ExpectedPointsDiff: 'Differenza di punti prevista',
      PassesTotalOwnHalf: 'Numero totale di passaggi effettuati dalla propria metà campo',
      PassesOwnHalf: 'Numero di passaggi riusciti effettuati dalla propria metà campo',
      PassesTotalOppHalf: 'Numero totale di passaggi effettuati dalla metà campo avversaria',
      ProgressivePassesTotal: 'Numero totale di passaggi di 10 metri o più sull\'asse X',
      DuelsWon: 'Duelli riusciti (contrasti, antenne, tocchi di palla, dribbling e falli commessi)',
      NonPenaltySaves: 'Parate esclusi i tiri di rigore',
      BadActionsOppHalf: 'Somma di tutte le cattive azioni commesse nella metà campo avversaria',
      CarriesSuccessful: 'Numero di carry di almeno 7 metri terminati con un evento riuscito',
      ShotsOnTargetOutBox: 'Tiri in porta da fuori area',
      TotalDistance: 'Distanza Totale',
      WalkingDistance: 'Distanza totale percorsa dal Giocatore durante una partita a una velocità inferiore a 2 m/s (7,2 km/h)',
      JoggingDistance: 'Distanza totale percorsa dal Giocatore durante una partita a una velocità compresa tra 2 m/s (7,2 km/h) e 4 m/s (14,4 km/h)',
      RunningDistance: 'Distanza totale percorsa dal Giocatore durante una partita a una velocità compresa tra 4 m/s (14,4 km/h) e 5,5 m/s (19,8 km/h)',
      ExtremeAccelerations: 'Numero di volte in cui il giocatore accelera più di 3 m/s<sup>2</sup>',
      NumberOfRuns: 'Numero di corse completate ad una velocità compresa tra 14,4 km/h e 19,8 km/h',
      HsrDistance: 'Distanza Sprint >19.8 km/h',
      HsrNumber: 'Quantità Sprint >19.8 km/h',
      HsrDistancePct: '% HSR Distance',
      SprintsNumber: 'Quantità Sprin >25.2 km/h',
      SprintsDistance: 'Distanza Sprint >25.2 km/h',
      SprintNumberDeclinePct: 'Percentuale di diminuzione nel numero di sprint effettuati rispetto al secondo tempo della partita',
      SprintDistanceDeclinePct: 'Percentuale di diminuzione della distanza percorsa durante gli sprint rispetto al secondo tempo della partita',
      SprintNumberDecline: 'Diminuzione nel numero di sprint effettuati rispetto al secondo tempo della partita',
      SprintDistanceDecline: 'Diminuzione della distanza percorsa durante gli sprint rispetto al secondo tempo della partita',
      SprintDistancePct: '% Distanza Sprint',
      Accelerations: 'Quantità Accelerazione',
      MaxSpeed: 'Massima Velocità',
      AvgMaxSpeed: 'Media della velocità massima raggiunta dal giocatore',
      MaxAccelerations: 'Massima accelerazione in metri/secondo² raggiunta dal giocatore',
      BypassedPlayersByPasses: 'Numero di giocatori dal lato del portiere del portatore di palla all\'inizio dell\'azione, meno il numero di giocatori dal lato del portiere alla fine dell\'azione',
      BypassedDefendersByPasses: 'Numero di difensori dal lato del portiere del portatore di palla all\'inizio dell\'azione, meno il numero di difensori dal lato del portiere alla fine dell\'azione',
      PassesBypassingPlayers: 'Numero di passaggi che hanno superato i giocatori',
      PassesBypassingDefenders: 'Numero di passaggi che hanno superato i difensori',
      BypassedPlayersPerPass: 'Numero totale di giocatori superati per passaggio',
      BypassedDefendersPerPass: 'Numero totale di difensori superati per passaggio',
      LineBreakingPasses: 'Passaggi completati che avanzano la palla almeno del 10% più vicino alla porta avversaria e attraversano una coppia di difensori vicini o passano dietro la linea difensiva',
      LineBreakingPassesMD: 'Passaggi completati che superano le linee di centrocampo e difesa',
      LineBreakingPassesM: 'Passaggi completati che superano la linea di centrocampo',
      LineBreakingThroughBalls: 'Passaggi completati che superano la linea difensiva',
      LineBreakingPassesPerPass: 'Numero di linee rotte per passaggio',
      TotalPassesUnderStrongPressure: 'Numero totale di passaggi effettuati sotto forte pressione (entro 0-2 metri dall\'avversario più vicino)',
      TotalPassesUnderLightPressure: 'Numero totale di passaggi effettuati sotto pressione (entro 2-4 metri dall\'avversario più vicino)',
      SuccessfulPassesUnderStrongPressure: 'Numero di passaggi riusciti effettuati sotto forte pressione (entro 0-2 metri dall\'avversario più vicino)',
      SuccessfulPassesUnderLightPressure: 'Numero di passaggi riusciti effettuati sotto pressione (entro 2-4 metri dall\'avversario più vicino)',
      PassingUnderStrongPressure: 'Percentuale di passaggi riusciti e totali sotto forte pressione (entro 0-2 metri dall\'avversario più vicino)',
      PassingUnderLightPressure: 'Percentuale di passaggi riusciti e totali sotto pressione (entro 2-4 metri dall\'avversario più vicino)',
      PassReceiptsInSpaceCompleted: 'Passaggi effettuati dove il ricevitore è nella metà offensiva senza difensori entro un raggio di 5 metri verso la porta',
      PassReceiptsInSpace: 'Passaggi ricevuti nella metà offensiva senza difensori entro un raggio di 5 metri verso la porta',
      PassReceiptsInSpaceCompletedFirstThird: 'Passaggi effettuati con ricezione nel primo terzo senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceCompletedSecondThird: 'Passaggi effettuati con ricezione nel secondo terzo senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceCompletedFinalThird: 'Passaggi effettuati con ricezione nell’ultimo terzo senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Passaggi effettuati con ricezione nella metà campo avversaria (lato destro) senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Passaggi effettuati con ricezione nella metà campo avversaria (zona centrale) senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Passaggi effettuati con ricezione nella metà campo avversaria (lato sinistro) senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceFirstThird: 'Passaggi ricevuti nel primo terzo senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceSecondThird: 'Passaggi ricevuti nel secondo terzo senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceFinalThird: 'Passaggi ricevuti nell’ultimo terzo senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceOppHalfRight: 'Passaggi ricevuti nella metà campo avversaria (lato destro) senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceOppHalfCenter: 'Passaggi ricevuti nella metà campo avversaria (zona centrale) senza difensori entro 5 metri nella direzione della porta',
      PassReceiptsInSpaceOppHalfLeft: 'Passaggi ricevuti nella metà campo avversaria (lato sinistro) senza difensori entro 5 metri nella direzione della porta',
      TotalStrongOnBallPressures: 'Numero di pressioni forti sul portatore di palla (entro 0-2 metri)',
      TotalLightOnBallPressures: 'Numero di pressioni sul portatore di palla (entro 2-4 metri)',
      SuccessfulStrongOnBallPressures: 'Numero di pressioni forti riuscite sul portatore di palla (entro 0-2 metri)',
      SuccessfulLightOnBallPressures: 'Numero di pressioni riuscite sul portatore di palla (entro 2-4 metri)',
      StrongOnBallPressuresPct: 'Percentuale di pressioni forti riuscite e totali sul portatore di palla (entro 0-2 metri dall\'avversario più vicino)',
      LightOnBallPressuresPct: 'Percentuale di pressioni riuscite e totali sul portatore di palla (entro 2-4 metri dall\'avversario più vicino)',
      TimesBypassedByPasses: 'Numero totale di volte superato da un passaggio',
      TimesBypassedByCarries: 'Numero totale di volte superato da una conduzione',
      TimesBypassedByActions: 'Numero totale di volte superato da passaggi e conduzioni combinati',
      BypassedPlayersByCarries: 'Numero totale di avversari (difensori e centrocampisti) superati tramite conduzioni',
      BypassedDefendersByCarries: 'Numero totale di avversari (difensori) superati tramite conduzioni',
      BypassedPlayersByActions: 'Numero totale di avversari (difensori e centrocampisti) superati tramite passaggi e conduzioni combinati',
      BypassedDefendersByActions: 'Numero totale di avversari (difensori) superati tramite passaggi e conduzioni combinati',
      CarriesBypassingPlayers: 'Numero di conduzioni che hanno superato giocatori',
      CarriesBypassingDefenders: 'Numero di conduzioni che hanno superato difensori',
      BypassedPlayersPerCarry: 'Media di avversari superati per conduzione',
      BypassedDefendersPerCarry: 'Media di difensori superati per conduzione',
      LineBreakingCarries: 'Numero di conduzioni che hanno superato una o più linee difensive',
      LineBreakingCarriesMD: 'Numero di conduzioni che hanno superato le linee di centrocampo e difesa',
      LineBreakingCarriesM: 'Numero di conduzioni che hanno superato la linea di centrocampo',
      LineBreakingCarriesD: 'Numero di conduzioni che hanno superato la linea difensiva',
      LineBreakingCarriesPerCarry: 'Percentuale di conduzioni tra le linee per conduzione',
      LineBreakingActions: 'Numero di passaggi e conduzioni combinati che hanno superato una o più linee difensive',
      LineBreakingActionsMD: 'Numero di passaggi e conduzioni combinati che hanno superato le linee di centrocampo e difesa',
      LineBreakingActionsM: 'Numero di passaggi e conduzioni combinati che hanno superato la linea di centrocampo',
      LineBreakingActionsD: 'Numero di passaggi e conduzioni combinati che hanno superato la linea difensiva',
      PassesPerLineBreakingPass: 'Rapporto tra il numero totale di passaggi per passaggio tra le linee',
      CarriesPerLineBreakingCarry: 'Rapporto tra il numero totale di conduzioni per conduzione tra le linee',
      LinesBrokenByPasses: 'Numero totale di linee superate tramite passaggi',
      LinesBrokenByCarries: 'Numero totale di linee superate tramite conduzioni',
      LinesBrokenByActions: 'Numero totale di linee superate tramite passaggi e conduzioni combinati',
      LinesBrokenPerPass: 'Rapporto tra il numero totale di linee superate per passaggio',
      LinesBrokenPerCarry: 'Rapporto tra il numero totale di linee superate per conduzione',
      AvgLastDefenderDistanceIP: 'Distanza tra l\'ultimo difensore (più vicino alla propria porta) e la linea di porta in possesso',
      AvgLastDefenderDistanceOOP: 'Distanza tra l\'ultimo difensore (più vicino alla propria porta) e la linea di porta senza possesso',
      AvgDefensiveLineDistanceIP: 'Distanza tra la linea difensiva più arretrata e la porta in possesso',
      AvgDefensiveLineDistanceOOP: 'Distanza tra la linea difensiva più arretrata e la porta senza possesso',
      AvgRBDistanceIP: 'Distanza tra il terzino destro e la propria porta in possesso',
      AvgRBDistanceOOP: 'Distanza tra il terzino destro e la propria porta senza possesso',
      AvgLBDistanceIP: 'Distanza tra il terzino sinistro e la propria porta in possesso',
      AvgLBDistanceOOP: 'Distanza tra il terzino sinistro e la propria porta senza possesso',
      AvgBlockDistanceIP: 'Distanza tra il giocatore più avanzato e quello più arretrato in possesso',
      AvgBlockDistanceOOP: 'Distanza tra il giocatore più avanzato e quello più arretrato senza possesso',
      AvgBlockAreaIP: 'Area del rettangolo che racchiude tutti i giocatori di movimento (misura dello spazio occupato) in possesso',
      AvgBlockAreaOOP: 'Area del rettangolo che racchiude tutti i giocatori di movimento (misura dello spazio occupato) senza possesso',
      AvgDefensiveLineWidthOOP: 'Larghezza della linea difensiva più arretrata senza possesso',
      AvgOffensiveLineLastThirdWidthIP: 'Larghezza orizzontale della linea offensiva nell’ultimo terzo in possesso',
      AvgLByIP: 'Posizione del terzino sinistro in possesso',
      AvgRByIP: 'Posizione del terzino destro in possesso',
      AvgOffensiveLineDistanceIP: 'Distanza tra la propria porta e la linea offensiva in possesso',
      AvgOffensiveLineLastThirdDistanceIP: 'Distanza tra la propria porta e la linea offensiva nell’ultimo terzo in possesso',
      AvgOffensiveLineWidthIP: 'Larghezza orizzontale della linea offensiva in possesso',
      OffBallRuns: 'Movimenti intenzionali senza palla per supportare la fase offensiva',
      OffBallRunsOverlap: 'Movimenti in cui il giocatore corre all\'esterno del compagno (verso la fascia) mentre quest\'ultimo ha il pallone',
      OffBallRunsUnderlap: 'Movimenti in cui il giocatore corre all’interno del compagno, verso il centro del campo',
      OffBallRunsRunAhead: 'Corsa in avanti che supera il portatore di palla ma resta davanti all’ultimo difensore',
      OffBallRunsRunBehind: 'Corsa in avanti che entra nell’ultima linea difensiva, tra difensori e portiere',
      OffBallRunsCrossReceiver: 'Un giocatore si inserisce in area per ricevere un cross da un compagno',
      OffBallRunsSupport: 'Il giocatore corre per affiancare il portatore di palla offrendo un’opzione di passaggio vicina',
      OffBallRunsComingShort: 'Il giocatore va incontro al portatore di palla per offrire supporto o una linea di passaggio lontano dalla porta',
      AerialsOppHalf: 'Duelli aerei metà campo avversaria',
      CarriesIntoFinalThird: 'Condotte di almeno 7 metri dall\'esterno all\'interno dell\'ultimo terzo',
      DribblesAttempted: 'Numero di dribbling tentati',
      SpeedScore: 'Prestazioni fisiche del giocatore basate su diversi parametri di velocità',
      EnduranceScore: 'Prestazioni fisiche di resistenza del giocatore basate su diverse metriche',
      GoalsConceded: 'Numero di gol subiti',
      HeadedGoals: 'Numero di gol segnati di testa',
      SavesInBox: 'Numero di parate da tiri all\'interno dell\'area',
      SavesOutBox: 'Numero di parate da tiri fuori area',
      ShotsOnTargetInBoxAgainst: 'Numero di tiri in porta subiti da dentro l\'area',
      ShotsOnTargetOutBoxAgainst: 'Numero di tiri in porta subiti da fuori area',
      SwitchPlaySuccessful: 'Numero di passaggi completati su una distanza di 32 metri in cui lo spostamento laterale della palla è maggiore del suo spostamento verso la porta avversaria',
      SwitchPlayTotal: 'Numero totale di tentativi di passaggio oltre i 32 metri in cui lo spostamento laterale della palla è maggiore del suo spostamento verso la porta avversaria',
      PassesInsideOppHalf: 'Numero totale di passaggi che iniziano e finiscono nella metà campo avversaria',
      PassesInsideOppHalfSuccessful: 'Numero di passaggi completati che iniziano e finiscono nella metà campo avversaria',
      TacklesAttemptedFirstThird: 'Numero totale di contrasti tentati nel primo terzo del campo',
      TacklesAttemptedSecondThird: 'Numero totale di contrasti tentati nel secondo terzo del campo',
      TacklesFirstThird: 'Numero di contrasti riusciti effettuati nel primo terzo del campo',
      TacklesSecondThird: 'Numero di contrasti riusciti effettuati nel secondo terzo del campo',
      FoulsOwnHalf: 'Numero di falli commessi nella propria metà campo',
      TouchesOppHalf: 'Numero di tocchi di palla nella metà campo avversaria',
      TacklesAttemptedNotAdjusted: 'Numero totale di contrasti tentati, senza aggiustamento del possesso',
      TacklesSuccessfulNotAdjusted: 'Numero totale di contrasti riusciti, senza aggiustamento del possesso',
      AvgTop5MaxSpeed: 'Media delle cinque velocità massime più alte del giocatore',
      LBPReceived: 'Numero di passaggi di interruzione di riga ricevuti',
      LBPMReceived: 'Numero di passaggi ricevuti che sfondano la linea del centrocampo avversario',
      LBPMDReceived: 'Numero di passaggi ricevuti che sfondano sia il centrocampo avversario che le linee difensive',
      ThroughBallReceived: 'Numero di passaggi ricevuti che sfondano l\'ultima linea difensiva degli avversari',
      ShortPassesSuccessful: 'Numero di passaggi brevi (meno di 12 metri) completati',
      PassingSuccessForwardPct: 'Percentuale di passaggi in avanti riusciti',
      PassingSuccessBackwardPct: 'Percentuale di passaggi all\'indietro riusciti',
      PassingForwardBackwardPct: 'Rapporto tra passaggi in avanti e passaggi all\'indietro',
      LongBallPerPassesPct: 'Percentuale di lanci lunghi rispetto ai passaggi totali',
      LongBallReceivedOppHalf: 'Numero di palloni lunghi ricevuti nel campo avversario',
      OffensiveActions: 'Azioni offensive',
      SuccessfulDribblesPct: 'Dribbling riusciti/tentativi di dribbling totali effettuati',
      OffensiveTouchesOutBoxPct: '% di tocchi offensivi fuori area',
      HsrDistanceIP: 'Distanza dello sprint >21 km/h in possesso di possesso',
      HsrDistanceOOP: 'Distanza dello sprint >21 km/h senza possesso palla',
      JoggingDistanceIP: 'Distanza di jogging in possesso di palla',
      JoggingDistanceOOP: 'Distanza di jogging senza possesso palla',
      RunningDistanceIP: 'Distanza di corsa in possesso di palla',
      RunningDistanceOOP: 'Correre a distanza senza possesso palla',
      SprintsDistanceIP: 'Distanza dello sprint >24 km/h in possesso di palla',
      SprintsDistanceOOP: 'Distanza dello sprint >24 km/h senza possesso palla',
      WalkingDistanceIP: 'Possesso a pochi passi',
      WalkingDistanceOOP: 'A pochi passi dal possesso',
      PossessionRegain: 'Numero di volte in cui costringi l\'avversario a perdere il possesso',
      HandPassesSuccessful: 'Passaggi riusciti effettuati con le mani (portieri o rimesse su calcio piazzato)',
      HandPassesTotal: 'Numero totale di passaggi effettuati con le mani (portieri o rimesse su calcio piazzato)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      Clearances: 'Number of times the player hits the ball clear of the defensive zone',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player (via Tackles or Interceptions)'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'CAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: 'POH',
      PassesTotalOppHalf: 'PTOPPH',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS',
      BadActionsOppHalf: 'BAOPPH',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: 'SOTOB',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: 'SINGHIOZZARE',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRMS',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR',
      DistanceIP: 'DST IP',
      WalkingDistanceIP: 'WLKD IP',
      JoggingDistanceIP: 'JOGD IP',
      RunningDistanceIP: 'RUND IP',
      HsrDistanceIP: 'HSRD IP',
      SprintsDistanceIP: 'SPRD IP',
      RunningNumberIP: 'RUNQ IP',
      HsrNumberIP: 'HSRQ IP',
      SprintsNumberIP: 'SPRQ IP',
      DistanceOOP: 'DST OOP',
      WalkingDistanceOOP: 'WLKD OOP',
      JoggingDistanceOOP: 'JOGD OOP',
      RunningDistanceOOP: 'RUND OOP',
      HsrDistanceOOP: 'HSRD OOP',
      SprintsDistanceOOP: 'SPRD OOP',
      RunningNumberOOP: 'RUNQ OOP',
      HsrNumberOOP: 'HSRQ OOP',
      SprintsNumberOOP: 'SPRQ OOP',
      PossessionRegain: 'PR',
      HandPassesSuccessful: 'SHP',
      HandPassesTotal: 'THP',
      InterceptionsNotAdjusted: 'INT',
      ClearancesNotAdjusted: 'CLE',
      RecoveriesNotAdjusted: 'REC'
    },
    AerialsOppHalf: 'Duelli Aerei Metà Campo Avv.',
    CarriesIntoFinalThird: 'Guida fino all\'ultimo ⅓',
    scoreDifference: 'Differenza di punteggio: mostra se la prestazione di questo gioco è stata superiore o inferiore alla media stagionale',
    SpeedScore: 'Punteggio Potenza Velocità',
    EnduranceScore: 'Punteggio di resistenza',
    HeadedShots: 'Colpi di testa',
    HeadedXG: 'Intestata xG',
    HeadedSetPieceTooltip: 'Vengono visualizzati solo i giocatori che hanno segnato di testa su calci piazzati',
    SwitchPlaySuccessful: 'Cambio riproduzione riuscito',
    SwitchPlayTotal: 'Cambia totale riproduzione',
    PassesInsideOppHalf: 'Passa all\'interno della metà Avv',
    PassesInsideOppHalfSuccessful: 'Passa all\'interno dell\'Opp a metà con successo',
    TacklesAttemptedFirstThird: 'Contrasto tentato per primo ⅓',
    TacklesAttemptedSecondThird: 'Contrasto tentato secondo ⅓',
    TacklesFirstThird: 'Affronta con successo il primo ⅓',
    TacklesSecondThird: 'Affronta con successo il secondo ⅓',
    FoulsOwnHalf: 'Falli nella propria metà campo',
    TouchesOppHalf: 'Tocca la metà avversario',
    TacklesAttemptedNotAdjusted: 'Contrasti tentati non corretti',
    TacklesSuccessfulNotAdjusted: 'Contrasti riusciti non aggiustati',
    AvgTop5MaxSpeed: 'Velocità massima media Top5',
    LBPReceived: 'Passaggi di interruzione della linea ricevuti',
    LBPMReceived: 'Passaggi di interruzione della linea (linea M) ricevuti',
    LBPMDReceived: 'Passaggi di interruzione di linea (linea MD) ricevuti',
    ThroughBallReceived: 'Palle filtranti ricevute',
    recoveriesRate: 'Rapporto di recupero',
    turnoversRate: 'Rapporto di perdita',
    HsrDistanceIP: 'Distanza HSR IP',
    HsrDistanceOOP: 'Distanza HSR OOP',
    JoggingDistanceIP: 'Distanza di jogging IP',
    JoggingDistanceOOP: 'Distanza di jogging OOP',
    RunningDistanceIP: 'IP della distanza di corsa',
    RunningDistanceOOP: 'Distanza di corsa OOP',
    SprintsDistanceIP: 'Sprint Distanza IP',
    SprintsDistanceOOP: 'Sprint Distanza OOP',
    WalkingDistanceIP: 'IP raggiungibile a piedi',
    WalkingDistanceOOP: 'Distanza a piedi OOP',
    PossessionRegain: 'Riconquista del possesso',
    HandPassesSuccessful: 'Passaggi di mano riusciti',
    HandPassesTotal: 'Passaggi manuali',
    SprintsNumberIP: 'Sprint Quantità IP',
    SprintsNumberOOP: 'Quantità sprint OOP',
    RunningNumberIP: 'Quantità corrente IP',
    RunningNumberOOP: 'Quantità corrente OOP',
    HsrNumberIP: 'HSR Quantità IP',
    HsrNumberOOP: 'Quantità HSR OOP',
    InterceptionsNotAdjusted: 'Interceptions',
    ClearancesNotAdjusted: '',
    RecoveriesNotAdjusted: 'Recoveries'
  },
  team: {
    title: 'Scheda squadra',
    subtitle: 'Approfondire le caratteristiche e le statistiche della squadra',
    averageAge: 'Età media',
    transferBalance: 'Bilancio trasferimenti',
    roster: 'Rosa',
    stadium: 'Stadio',
    coach: 'Allenatore',
    transfers: 'Trasferimenti',
    trends: 'Tendenze',
    loans: 'Prestiti',
    loanFrom: 'In prestito da',
    loanTo: 'Prestato a',
    latestGames: 'Ultime partite',
    latestXGames: 'Latest {0} Games',
    playingFor: 'Gioca per',
    overview: 'Descrizione',
    visualization: 'Visualizzazione',
    location: 'Posizione',
    outcome: 'Risultato',
    beeswarm: 'Ranking',
    parentTeam: 'Prima squadra',
    childTeam: 'Primavera',
    preferredFormation: 'Formazione preferita',
    mostFrecuentFormations: 'Formazioni più frequenti',
    viewType: 'Tipo di visuale',
    overviewTab: {
      axisXTotal: 'Totale',
      axisXper90: 'Per 90\'',
      dataPerGameText: 'Dati per partita',
      season: 'Stagione',
      last: 'Precedente',
      current: 'In Corso',
      TeamStyle: 'Stile',
      TeamDefensive: 'Difensivo',
      TeamOffensive: 'Offensivo',
      TeamCustom1: 'Cliente 1',
      TeamCustom2: 'Cliente 2',
      TeamCustom3: 'Cliente 3',
      TeamCustom4: 'Cliente 4',
      coach: 'Allenatore',
      groups: {
        Goals: {
          name: 'Gol',
          desc: 'Tutti i gol con e senza rigori (da \'Calcio Piazzato\' e \'Su azione\').'
        },
        Assists: {
          name: 'Assist',
          desc: 'Giocatori con più assist (su azione e da calcio piazzato) in questa stagione.'
        },
        xG: {
          name: 'Expected Goals',
          desc: 'Gol previsti su azione e da calcio piazzato, ordinati in ordine decrescente per xG totali creati.'
        },
        xA: {
          name: 'Expected Assists',
          desc: 'Expected assist sia da calcio piazzato che su azione.'
        },
        Finishing: {
          name: 'Finalizzazione',
          desc: 'Percentuale di tiri che terminano in un gol.'
        },
        ScoringContribution: {
          name: 'Contributo in zona Gol',
          desc: 'Numero di assist e gol della squadra.'
        },
        xT: {
          name: 'Pericolo Previsto',
          desc: 'Pericolo previsto creato durante l\'incontro, da calcio piazzato e i negativi.'
        }
      },
      stats: {
        openPlay: 'Su azione',
        setPiece: 'Palla Ferma',
        negative: 'Negativo',
        npg: 'Non-Penalty Goals',
        goalsPenalty: 'Gol su Rigore',
        npgOpenPlay: 'NPG su azione',
        npgSetPiece: 'NPG da Calcio Piazzato',
        assists: 'Assist',
        assistsConceded: 'Assist subiti',
        assistsOpenPlay: 'Assist su azione',
        assistsSetPiece: 'Assist da Calcio Piazzato',
        xGOpenPlay: 'xG su azione',
        xGSetPiece: 'xG da Calcio Piazzato',
        xAOpenPlay: 'xA su azione',
        xASetPiece: 'xA da Calcio Piazzato',
        xAConceded: 'xA subiti',
        nonPenaltyShots: 'Non-Penalty Shots',
        penaltyShots: 'Calci di Rigore',
        xT: 'Pericolo Previsto',
        xTOpenPlay: 'xT su azione',
        xTSetPiece: 'xT da Calcio Piazzato',
        xTNeg: 'xT Negativo',
        totalFinishing: 'Finalizzazione',
        nonPenaltyFinishing: 'Non Penalty Finalizzazione',
        goalsPenaltyFinishing: 'Penalty Finalizzazione',
        goal: 'Obiettivo',
        notGoal: 'Non obiettivo',
        chance: 'Opportunità',
        finished: 'Finito',
        notFinished: 'Non finito',
        walkingDistance: 'Camminata',
        joggingDistance: 'Jogging',
        runningDistance: 'Corsa',
        hsrDistance: 'HSR',
        sprintsDistance: 'Sprint',
        runningNumber: 'Numero di corse',
        hsrNumber: 'Sprint HSR',
        sprintsNumber: 'Numero di sprint',
        maxSpeed: 'Velocità massima',
        accelerations: 'Accelerazioni',
        extremeAccelerations: 'Accelerazioni estreme',
        maxAcceleration: 'Massima accelerazione'
      }
    },
    teamAnalysis: 'Analisi della Squadra',
    agentView: {
      positions: {
        gk: 'Portieri',
        leftFullback: 'Terzini sx.',
        centralDefender: 'Difensori centrali',
        rightFullback: 'Terzini dx.',
        midfielder: 'Centrocampisti',
        attackingMidfielder: 'Mezzepunte',
        leftWinger: 'Ali sx.',
        rightWinger: 'Ali dx.',
        fw: 'Attaccanti'
      },
      groups: {
        contractEnd: 'Mesi',
        age: 'Età',
        availability: 'Disponibilità'
      },
      placer: {
        legend: 'Forza basata su età, contratto, disponibilità e prestazioni'
      }
    },
    transfersTab: {
      valueMovements: 'Valore movimenti',
      valueTransfers: 'Valore trasferimenti',
      valueLoans: 'Valore Prestiti',
      avgAgeMovements: 'Età media Movimenti',
      avgAgeTransfers: 'Età media trasferimenti',
      avgAgeLoans: 'Età media prestiti',
      operations: {
        buys: {
          buy: 'Acquisto',
          loan: 'Prestiti',
          'end of loan': 'Fine prestito',
          'free transfer': 'Costo zero',
          free: 'Svincolati',
          'loan transfer': 'Prestito',
          other: 'Altro'
        },
        sells: {
          buy: 'Cessioni',
          loan: 'Prestiti',
          'end of loan': 'Fine prestito',
          'free transfer': 'Costo zero',
          free: 'Svincolati',
          'loan transfer': 'Prestito',
          other: 'Altro',
          retired: 'Ritirato'
        }
      }
    },
    trendsTab: {
      streaks: 'Strisce',
      wins: 'Vittorie',
      cleanSheets: 'Fogli Puliti',
      goalPeriods: 'Periodi con Gol Segnati',
      concededGoalPeriods: 'Periodi con Gol Subiti',
      comebacks: 'Rimonte',
      avgTime: 'Tempo Medio',
      kindOfGoals: 'Tipi di Gol',
      percentWinning: '% di Vittorie',
      percentDrawing: '% di Pareggi',
      percentLosing: '% di Perdita',
      totalOf: 'Totale di',
      minutes: 'minuti',
      before: 'Prima',
      after: 'Dopo',
      playedOn: 'Riprodotto su',
      scored: 'Punteggio',
      conceded: 'Concedere',
      ownGoals: 'Autogol',
      phasesOfGame: 'Fasi di Gioco',
      intensityLabel: 'Intensità zona',
      intensityByTeam: 'Per squadra %',
      intensityByLeagueAvg: 'Per media campionato %',
      buildup: 'Costruzione',
      midfieldProgression: 'Progressione a centrocampo',
      attackOpposition: 'Attacco all\'avversario',
      attackingTransition: 'Transizione offensiva',
      highPress: 'Pressing alto',
      midBlock: 'Blocco medio',
      lowBlock: 'Blocco basso',
      defensiveTransition: 'Transizione difensiva',
      draws: 'Pareggia',
      losts: 'Perse',
      chokes: 'Strangola',
      zoneTooltip: 'Determina i criteri utilizzati per il gradiente di colore di ciascun blocco:',
      teamPctTooltip: 'Basato sulla percentuale del tempo totale giocato dalla squadra in ciascuna zona.',
      leagueAvgPctTooltip: 'Confronta la percentuale della squadra con la media del campionato per ciascuna zona.',
      leagueAvgMinsTooltip: 'Applica gli stessi criteri di confronto con il campionato, ma valuta il tempo totale in minuti anziché in percentuale.',
      losses: 'Perdite',
      results: 'Risultati',
      kindOfConcededGoals: 'Tipi di gol subiti',
      showMinutes: 'Mostra verbali'
    },
    onOff: 'On/Off',
    dragUpToXPlayers: 'Trascina fino a {x} giocatori',
    selectUpToXPlayers: 'Seleziona fino a {x} giocatori',
    onOffTab: {
      G90: 'Gol 90',
      GA90: 'Gol subiti 90',
      diffG90: 'Differenza gol 90',
      XG90: 'xG 90',
      XGA90: 'xG subiti 90',
      diffXG90: 'Differenza xG 90',
      playersOn: 'Combinazione ON',
      playersOff: 'Combinazione OFF',
      ground: 'Campo',
      playersOnThePitch: 'Giocatori in campo',
      playersOffThePitch: 'Giocatori fuori dal campo',
      attackTitle: 'Attacco',
      attackSubTitle: 'Statistiche offensive',
      defenseTitle: 'Difesa',
      defenseSubTitle: 'Statistiche difensive',
      associationTitle: 'Associa',
      associationSubTitle: 'Statistiche associative',
      comboOn: 'Combinazione attiva',
      comboOff: 'Altre combinazioni',
      diffGoals90: 'G Diff 90',
      goals90: 'Non Penalty Goals 90',
      goalsAgainst90: 'Non Penalty Goals subiti 90',
      xgAgainstPer90: 'xG subiti 90',
      xgDiffPer90: 'xG Diff 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: 'Tiri in porta 90',
      touchesOppBox90: 'Tocchi in area 90',
      shotsOnTargetAgainst90: 'Tiri in porta subiti 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: 'Verticalità 90',
      possession: '% Possesso',
      pctPasses: '% Passaggi',
      pctPassesFinalThird: '% Passaggi Ultimo ⅓',
      placeholder: 'Inizia selezionando una squadra',
      subtitle: 'Ottimizza le metriche della squadra aggiungendo o rimuovendo giocatori dalla formazione'
    },
    terms: {
      short: 'Breve durata',
      mid: 'Media durata',
      long: 'Lunga durata'
    },
    report: {
      title: 'Rapporto Squadra',
      selectedPeriod: 'Periodo Selezionato',
      stackedCharts: 'Grafici Sovrapposti',
      radars: 'Radars',
      generalData: 'Dati Generali',
      scoringChances: 'Occasioni da Gol',
      areasReport: 'Rapporto Aree',
      setPieceReport: 'Rapporto Calci Piazzati',
      corners: 'Calci d\'Angolo',
      cornersAgainst: 'Angoli Contro',
      indirectFreeKicks: 'Calci di Punizione Indiretti',
      indirectFreeKicksAgainst: 'Punizioni Indirette Contro',
      freeKicks: 'Calci di Punizione',
      freeKicksAgainst: 'Punizioni Contro',
      penaltys: 'Rigori',
      freeKicksContribution: 'Contributo Calci di Punizione',
      shotsContribution: 'Contributo Tiri',
      topXPlayersByStats: 'Top {x} Giocatori per Statistiche',
      lastShotZone: 'Ultima Zona di Tiro',
      throwSide: 'Lato della Rimessa',
      kindOfThrow: 'Tipo di Rimessa',
      scored: 'Segnati',
      against: 'Contro',
      perGame: 'per Partita',
      total: 'Totale',
      efficiency: 'Efficienza',
      organizedAttack: 'Attacco Organizzato',
      offTransition: 'Transizione Offensiva',
      chances: 'Occasioni',
      chancesScored: 'Occasioni Segnate',
      chancesAgainst: 'Occasioni Contro',
      goalsScored: 'Gol Segnati',
      goalsAgainst: 'Gol Subiti',
      goalsOrganizedAttack: 'Gol Attacco Organizzato',
      goalsOffTransition: 'Gol Transizione Offensiva',
      goalsSetPiece: 'Gol Calcio Piazzato',
      goalsOrganizedAttackScored: 'Gol Att. Org. Segnati',
      goalsOrganizedAttackAgainst: 'Gol Att. Org. Contro',
      goalsOffTransitionScored: 'Gol Trans. Off. Segnati',
      goalsOffTransitionAgainst: 'Gol Trans. Off. Contro',
      goalsSetPieceScored: 'Gol Calcio Piazzato Segnati',
      goalsSetPieceAgainst: 'Gol Calcio Piazzato Contro',
      crossSide: 'Lato del Cross',
      externalShot: 'Tiro da Fuori',
      innerPlay: 'Gioco Interno',
      throwIn: 'Rimessa Laterale',
      box: 'Area di Rigore',
      zone2: 'Zona 2',
      goalsPerPhases: 'Gol per Fasi'
    },
    minutesAlert: '*Mostra solo i giocatori con 450 o più minuti giocati',
    minutesException: 'Non ci sono giocatori con 450 o più minuti giocati. Mostra tutti i giocatori',
    analysis: 'Analisi',
    substitutions: 'Sostituzioni',
    attackZones: 'Zone d\'attacco',
    formations: 'Formazioni',
    shotZones: 'Zone di tiro',
    crossings: 'Cross',
    byTime: 'per Tempo',
    byPosition: 'per Posizione',
    byPlayer: 'per Giocatore',
    W: 'Vittoria',
    D: 'Pareggio',
    L: 'Sconfitta',
    substitutionsByGame: 'Sostituzioni per partita',
    substitutionsShort: 'Sost.',
    avgSeasonShort: 'Media Stagione',
    startingAt: 'A partire da',
    endingAt: 'Fine a',
    startingAtInfo: 'Mostra la quota di possesso basata sulla localizzazione del primo evento',
    endingAtInfo: 'Mostra la quota di possesso basata sulla localizzazione dell\'ultimo evento',
    endingWithShot: 'che termina con un tiro',
    endingInBox: 'che termina dentro dell\'area',
    pfX: 'PF {x}',
    bySide: 'Per lato',
    cornerKicks: 'Calcio d\'Angolo',
    included: 'Incluso',
    excluded: 'Escluso',
    onlyCorner: 'Solo da calcio d\'Angolo',
    sizeByMarketValue: 'Dimensioni per valore di mercato',
    timeInTeam: 'Stagioni in Squadra',
    newSignings: 'Nuovi Acquisti',
    sizeBy: 'dimensione per',
    connections: 'Connections',
    assistant: 'Passer',
    finisher: 'Finisher',
    playersMinutesAlert: 'Mostrando solo i giocatori con minuti giocati nella stagione selezionata',
    strategyFilterTooltip: 'Visualizza gli eventi accaduti durante i calci piazzati o durante un gioco aperto',
    sideFilterTooltip: 'Visualizza solo i calci piazzati che iniziano dal lato selezionato (sinistra o destra)',
    teamMinutesAlert: '*Mostra solo le squadre con 450 o più minuti giocati',
    homeCoach: 'Allenatore di casa',
    awayCoach: 'Allenatore in trasferta'
  },
  leagueTable: {
    subtitle: 'Analizza i Campionati'
  },
  leagueMatchdays: {
    byRound: 'Per giornata',
    byDate: 'Per data',
    byTeam: 'Per squadra'
  },
  teamStats: {
    subtitle: 'Confronta il rendimento delle squadre',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: 'Difference between Expected Goals and Goals',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: 'Difference between Expected Points and Points',
    games: 'GAM',
    gamesExplicit: 'Games played',
    pointsPerGame: 'PPG',
    pointsPerGameExplicit: 'Points per Game'
  },
  roles: {
    ROLE_USER: 'Utente',
    ROLE_ADMIN: 'Amministratore',
    ROLE_REPORTS: 'Driblab Reports',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Dati Fisici',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Tracking',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: 'Estraete senza problemi le informazioni su giocatori, squadre, partite e campionati in formato JSON.',
    ROLE_EVENTING_DATA_description: 'Approfondisci le statistiche con i grafici radar, le classifiche dei giocatori, le mappe e molto altro ancora basato su +100 metriche di rendimento.',
    ROLE_PHYSICAL_DATA_description: 'Accedere ai dati sulla forma fisica e filtrare i giocatori in base a varie metriche di prestazione (distanza, velocità, sprint, accelerazione...).',
    ROLE_VIDEO_description: 'Fornisci video e formazioni e ottieni partite etichettate con eventi e statistiche per un\'analisi approfondita.',
    ROLE_DRIBLAB_HUB_description: 'Tracciate e gestite in modo efficiente le attività di scouting con calendari, note, avvisi e condivisione di documenti.',
    ROLE_TRACKING_description: 'Ricevere i dati di posizione di tutti i giocatori in una partita attraverso la nostra API per un\'analisi completa.',
    ROLE_ARRIGO_description: 'Combina eventing e tracking in metriche innovative che vanno oltre la tradizione e aggiungono valore a ogni azione.',
    ROLE_REPORTS_description: 'Richiedete rapporti di scouting dettagliati al nostro team di analisti per trovare la squadra o il giocatore perfetto.',
    ROLE_RAW_EVENTING: 'Evento grezzo'
  },
  administration: {
    pageSubtitle: 'Gestire il funzionamento dell\'applicazione',
    newClient: 'Nuovo cliente',
    clientDuplicateName: 'Esiste già un cliente con questo nome. Selezionalo nell’elenco e usa «Nuovo utente» per aggiungere utenti a quel cliente.',
    newUser: 'Nuovo utente',
    editClient: 'Modifica cliente',
    editUser: 'Modifica usuario',
    clientName: 'Nome',
    permissions: 'Permessi',
    releaseUser: 'Libera utente',
    connectAsUser: 'Connettersi come',
    releaseModalTitle: 'Conferma liberare utente',
    releaseModalMessage: 'L\'utente riceverà un\'e-mail. Sei sicuro di avvisarlo?',
    clientType: {
      Driblab: 'Driblab',
      Team: 'Squadra',
      Brand: 'Marchio',
      Federation: 'Federazione',
      Media: 'Mezzi di Comunicazione',
      Agency: 'Agenzia',
      Individual: 'Persona fisica'
    },
    userType: {
      Ownership: 'Proprietà',
      SportingDirector: 'Direttore Sportivo',
      Brand: 'Marchio',
      Federation: 'Federazione',
      Media: 'Media',
      Agency: 'Agenzia',
      Individual: 'Persona fisica',
      Scout: 'Scout',
      Coach: 'Allenatore',
      supervision: {
        title: 'Gerarchia di supervisione',
        subtitle: 'La vigilanza scorre solo verso il basso. Non è consentita la supervisione allo stesso livello.',
        supervisesLowerLevels: 'Supervisiona tutti i ruoli di seguito',
        ruleNoSameLevel: 'Ruoli allo stesso livello non possono supervisionarsi a vicenda.',
        ruleOnlyDownwards: 'La supervisione è consentita solo dai ruoli superiori a quelli inferiori.',
        ruleLevel3NoSupervision: 'Il livello più basso non ha autorizzazioni di supervisione.',
        currentUserType: 'Il tuo attuale tipo di utente'
      }
    },
    visibleYears: 'Anni visibili',
    areaModalTitle: 'Attiva/Disattiva Conferma Campionati',
    areaModalMessage: 'Sei sicuro di attivare/disattivare tutti i campionati dalle aree selezionate?',
    countStats: 'Count Stats',
    userClientModalTitle: 'User already exists in another client',
    eventing: 'Eventing',
    hub: 'Hub',
    contract: 'Contratto',
    contracts: 'Contratti',
    invoiceName: 'Nome Fattura',
    contractFee: 'Costo del Contratto',
    renewal: 'Rinnovo',
    consultancy: 'Consulenza',
    deleteContract: 'Elimina Contratto Cliente',
    deleteContractMessage: 'Il contratto verrà eliminato permanentemente. Sei sicuro?',
    activeVsHired: 'Attivo vs Assunto',
    requestedVsHired: 'Richiesto vs Assunto',
    activeVsHiredWithPlaceholder: '{0} Attivo vs {1} Assunto',
    requestedVsHiredWithPlaceholder: '{0} Richiesto vs {1} Assunto',
    salesRepresentative: 'Rappresentante di Vendite',
    periodicities: {
      periodicity: 'Periodicità',
      annual: 'Annuale',
      biannual: 'Semestrale',
      quarterly: 'Trimestrale',
      monthly: 'Mensile',
      bimonthly: 'Bimestrale',
      onePayment: 'Un pagamento',
      fourmonthly: 'Ogni quattro mesi'
    },
    paymentMethods: {
      payment: 'Pagamento',
      method: 'Metodo',
      transfer: 'Bonifico',
      mandate: 'Mandato'
    },
    marketingOptions: {
      marketing: 'Marketing',
      socialMediaAdd: 'Pubblicità sui Social Media',
      videoWithFeedback: 'Video con Feedback'
    },
    status: {
      status: 'Stato',
      pending: 'In attesa',
      active: 'Attivo',
      expiringSoon: 'In scadenza',
      expired: 'Scaduto',
      expiringSoonWithDays: 'Il contratto sta per scadere: restano {0} giorni'
    },
    updates: {
      roleAdded: '<b>{0}</b> ha aggiunto il ruolo <b>{1}</b> a <b>{2}</b>.',
      roleRemoved: '<b>{0}</b> ha rimosso il ruolo <b>{1}</b> da <b>{2}</b>.',
      leagueAdded: '<b>{0}</b> ha aggiunto <b>{1}</b> alla lega <b>{2}</b>.',
      leagueRemoved: '<b>{0}</b> ha rimosso <b>{1}</b> dalla lega <b>{2}</b>.',
      seasonAdded: '<b>{0}</b> ha aggiunto <b>{1}</b> alla stagione <b>{2}</b>.',
      seasonRemoved: '<b>{0}</b> ha rimosso <b>{1}</b> dalla stagione <b>{2}</b>.',
      updateNotesPlaceholder: 'Inserisci un contesto per la modifica o aggiungi eventuali note rilevanti qui...',
      updates: 'Aggiornamenti',
      products: 'Prodotti'
    },
    clients: 'Clienti',
    trials: 'Prove',
    activeClients: 'Clienti attivi',
    activeTrials: 'Prove attive',
    activeTrialUsers: 'Utenti di prova attivi',
    activeContracts: 'Contratti attivi',
    expiration: 'Scadenza',
    clientWarnings: {
      activeContractInactiveClient: 'Clienti con contratti attivi ma senza utenti abilitati',
      activeContractTrialUsers: 'Clienti con utenti di prova mentre un contratto è attivo',
      activeUsersWithoutContract: 'Clienti con utenti attivi non di prova ma senza contratto attivo',
      upcomingExpirations: 'Prossime scadenze',
      renewedContracts: 'Clienti con contratti rinnovati',
      clientsWithWarnings: 'Clienti che richiedono attenzione',
      enabledUsersWithoutContract: '"Abilitati utenti non in prova senza contratto attivo"',
      trialUsersWithContract: 'Utenti in modalità di prova nonostante un contratto attivo',
      activeContractInactiveUsers: 'Il cliente ha un contratto attivo con tutti gli utenti inattivi',
      activeContract: 'Questo cliente ha un contratto attivo',
      noEnabledUsers: 'Questo client non ha utenti abilitati',
      ongoingTrialInactiveUsers: 'Client con una prova in corso ma nessun utente abilitato',
      neverLoggedIn: 'Clienti che non hanno mai effettuato l\'accesso'
    },
    daysLeft: 'Giorni rimasti',
    expiringSoon: 'In scadenza a breve',
    loggedThisWeek: 'Effettuato l\'accesso questa settimana',
    withWarnings: 'Con avvertimenti',
    ofActiveClients: 'di clienti attivi',
    endingIn30Days: 'terminerà tra 30 giorni',
    neverLogged: 'mai effettuato l\'accesso',
    ofActiveTrials: 'di sperimentazioni attive',
    activeClientsWithoutTrial: 'clienti attivi (escl. prova)',
    renewals: 'Rinnovi',
    ofActiveContracts: 'di contratti attivi'
  },
  dashboards: {
    lastGame: 'Analisi ultima Partita',
    lastGameSimple: 'Ultima partita',
    seeAllGameInfo: 'Vedi tutte le info',
    nextGame: 'Partita successiva',
    myTeam: 'La mia Squadra',
    lastMatchdayGames: 'Ultima giornata',
    lastAdded: 'Aggiunti recenti',
    myFavorites: 'Preferiti',
    seeAllFavorites: 'Vedi tutti i miei preferiti',
    placeholderFavorites: 'Dal dettaglio di un giocatore puoi aggiungerlo ai preferiti',
    placeholderTeamFavorites: 'Dal dettaglio di una squadra puoi aggiungerla ai preferiti',
    placeholderLeagueFavorites: 'Dal dettaglio di una lega puoi aggiungerla ai preferiti',
    myCollections: 'Le mie collezioni',
    placeholderCollections: 'Non hai collezioni create',
    lastCreated: 'Create recentemente',
    seeAllCollections: 'Vedi tutte le collezioni',
    seeRival: 'Vedi avversario',
    seeMyTeam: 'Vedi la mia Squadra',
    title: 'Home',
    subtitle: 'Benvenuto',
    recentPlayers: 'Giocatori recenti',
    lastScouted: 'Ultimi osservati',
    scout: 'Scout',
    reportsRequested: 'Report',
    lastRequested: 'Ultime Richieste',
    goInbox: 'Vai alla posta in arrivo',
    placeholderLastScouted: 'Puoi cercare giocatori nella barra di sinistra o negli strumenti scout',
    placeholderReports: 'Puoi richiedere un report dai dettagli di un giocatore',
    nationalPlayers: 'Giocatori nazionali di maggior valore in altri paesi',
    lastGames: 'Ultime partite',
    nationalPlayersShort: 'Giocatori nazionali di maggior valore in altri paesi',
    nextMatchdayGames: 'Giornata successiva',
    injuredPlayers: 'Giocatori infortunati',
    atPresent: 'Attualmente',
    seeAllPlayers: 'Vedi tutti',
    suspendedPlayers: 'Giocatori squalificati',
    placeholderInjured: 'Non ci sono giocatori infortunati',
    teamValueImpacted: 'Valore della squadra impattato',
    placeholderSuspended: 'Non ci sono giocatori squalificati',
    placeholderNextGame: 'Non ci sono partite disponibili',
    placeholderNoGames: 'Ancorna non ci sono partite disponibili',
    placeholderLastMatchDayNotFound: 'Ultima giornata non disponibile',
    placeholderNextMatchDayNotFound: 'Prossima giornata non disponibile',
    usersMostSearch: 'Utenti che cercano di più',
    lastTwoDays: 'Ultimi due giorni',
    searchesHistory: 'Cronologia delle ricerche',
    dayByDay: 'Giorno per Giorno',
    activeUsersTitle: 'Utenti attivi',
    activeUsersSubtitle: 'Connessioni ultimo mese',
    onlineUsersTitle: 'Utenti connessi',
    onlineUsersSubtitle: 'Hanno cercato nell\'ultima ora',
    searchesPerformed: 'Ricerche realizzate',
    onlyClients: 'Solo clienti',
    activeClientsTitle: 'Clienti attivi',
    activeClientsSubtitle: 'Almeno un utente attivo',
    last24Hours: 'Ultime 24 ore',
    activityHistory: 'Cronologia attività',
    loginHistory: 'Cronologia degli accessi',
    failLogins: 'Accessi non riusciti',
    successLogins: 'Accessi riusciti',
    clientStats: 'Statistiche del cliente',
    playersMostSearch: 'Giocatori più cercati',
    toolsMoreUsed: 'Strumenti più usati',
    hotPlayers: 'Giocatori più ricercati',
    last_month: 'Ultimo mese',
    last_week: 'Ultima settimana',
    last_day: 'Ultimo giorno',
    nClients: 'Nº di Clienti',
    userDashboard: 'Dashboard utente',
    userDashboardSubtitle: 'Riepilogo dell\'attività del conto',
    offlineDaysOfClient: 'Giorni offline per ogni cliente',
    hideNoConnected: 'Nascondi non connessi',
    onlyTrial: 'Solo clienti di prova',
    daysWithoutLogin: 'Giorni senza accesso',
    trialDays: 'Giorni di prova'
  },
  faq: {
    subtitle: '¿Che cos\'è Driblab PRO?',
    categories: {
      playerMetrics: 'Parametri del giocatore',
      teamMetrics: 'Parametri della Squadra',
      positions: 'Posizioni della squadra',
      tools: 'Strumenti',
      api: 'API',
      videos: 'Tutorial',
      playerPositions: 'Posizioni dei Giocatori',
      userTypes: 'Tipi di utenti'
    },
    positions: {
      GK: 'Portiere',
      DR: 'Terzino destro',
      DC: 'Difensore centrale',
      DL: 'Terzino sinistro',
      DMR: 'Terzino fluidificante destro',
      DMC: 'Centrocampista difensivo',
      DML: 'Terzino fluidificante sinistro',
      MR: 'Centrocampista destra',
      MC: 'Centrocampista',
      ML: 'Centrocampista sinistro',
      AMR: 'Mezzala Destra',
      AMC: 'Trequartista',
      AML: 'Mezzala Sinistra',
      FWR: 'Ala destra',
      FW: 'Attaccante',
      FWL: 'Ala Sinistra'
    },
    metrics: {
      categories: {
        Association: 'Associazione',
        Saving: 'Parate',
        Shooting: 'Tiro',
        Defending: 'Difesa',
        Passing: 'Passaggi',
        BallHandling: 'Controllo Palla',
        Aerial: 'Aereo',
        Physical: 'Fisiche',
        Predictive: 'Predittivo',
        Arrigo: 'Arrigo',
        Score: 'Punteggio',
        Turnovers: 'Palle Perse',
        Carries: 'Conduzione',
        SequenceInvolvement: 'Coinvolgimento delle sequenze',
        Crosses: 'Cross',
        Distance: 'Distanza',
        Sprint: 'Sprint',
        Acceleration: 'Accelerazioni',
        MaxAcceleration: 'Accelerazione massima',
        Speed: 'Velocità',
        OutPlay: 'Outplay',
        LineBreakingPasses: 'Passaggi tra le Linee',
        LineBreakingCarries: 'Conduzione tra le Linee',
        LineBreakingActions: 'Azioni tra le Linee',
        PassUnderPressure: 'Passaggio sotto Pressione',
        BallReceived: 'Palla Ricevuta',
        PassesUnderPressure: 'Passa Sotto Pressione',
        OnBallPressureReceived: 'Pressione sul Portatore di Palla Ricevuta',
        OnBallPressure: 'Pressione sul Portatore di Palla',
        BallReceiptsInSpace: 'Ricezioni Palla in Spazio',
        SpatialCoverage: 'Controllo del Campo',
        OffBallPressure: 'Pressione senza Palla',
        OffBallRuns: 'Movimenti Senza Palla',
        NoCategory: 'Altri',
        subcategories: {
          Quality: 'Qualità',
          Quantity: 'Quantità',
          TeamComparison: 'Confronto squadre',
          Receptions: 'Ricezioni',
          LongBalls: 'Lanci lunghi',
          Efficiency: 'Efficienza',
          Ratio: 'Rapporto',
          Defensive: 'Difensivo',
          Offensive: 'Offensivo',
          Foot: 'Piede',
          Progression: 'Progressione',
          TopValue: 'Valore massimo',
          Predictive: 'Predittivo',
          Distance: 'Distanza',
          Aerial: 'Aereo',
          Crosses: 'Cross',
          NoCategory: 'Altri'
        },
        desc: {
          Association: 'Associazione',
          Saving: 'Parate',
          Shooting: 'Tiro',
          Defending: 'Difesa',
          Passing: 'Passaggi',
          BallHandling: 'Controllo Palla',
          Aerial: 'Aereo',
          Physical: 'Fisiche',
          Predictive: 'Predittivo',
          Arrigo: 'Arrigo',
          Score: 'Punteggio',
          Turnovers: 'Palle Perse',
          Carries: 'Conduzione',
          SequenceInvolvement: 'Coinvolgimento delle sequenze',
          Crosses: 'Cross',
          Distance: 'Distanza coperta a diverse velocità',
          Sprint: 'Corse a diverse velocità',
          Acceleration: 'Accelerazioni',
          Speed: 'Velocità',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Passaggi tra le Linee',
          LineBreakingCarries: 'Conduzione tra le Linee',
          LineBreakingActions: 'Azioni tra le Linee',
          PassUnderPressure: 'Passaggio sotto Pressione',
          BallReceived: 'Palla Ricevuta',
          OnBallPressureReceived: 'Pressione sul Portatore di Palla Ricevuta',
          OnBallPressure: 'Pressione sul Portatore di Palla',
          BallReceiptsInSpace: 'Ricezioni Palla in Spazio',
          SpatialCoverage: 'Controllo del Campo',
          OffBallPressure: 'Pressione senza Palla',
          OffBallRuns: 'Movimenti Senza Palla',
          HandPassing: 'Passaggio effettuato con la mano dal portiere o rimessa su calcio piazzato'
        },
        abbr: {
          Association: 'Associazione',
          Saving: 'Parate',
          Shooting: 'Tiro',
          Defending: 'Difesa',
          Passing: 'Passaggi',
          BallHandling: 'Cont. P',
          Aerial: 'Aereo',
          Physical: 'Fisiche',
          Predictive: 'Predittivo',
          Arrigo: 'Arrigo',
          Score: 'Score',
          Turnovers: 'PP',
          Carries: 'Conduzione',
          SequenceInvolvement: 'Coinvol. delle seq.',
          Crosses: 'Cross',
          Distance: 'Distanza',
          Sprint: 'Sprint',
          Acceleration: 'Accelerazioni',
          MaxAcceleration: 'Massimo. Accelerazione',
          Speed: 'Velocità',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Passaggi tra le Linee',
          LineBreakingCarries: 'Conduzione tra le Linee',
          LineBreakingActions: 'Azioni tra le Linee',
          PassUnderPressure: 'Passaggio sotto Pressione',
          BallReceived: 'Palla Ricevuta',
          OnBallPressureReceived: 'Pressione sul Portatore di Palla Ricevuta',
          OnBallPressure: 'Pressione sul Portatore di Palla',
          BallReceiptsInSpace: 'Ricezioni Palla in Spazio',
          SpatialCoverage: 'Controllo del Campo',
          OffBallPressure: 'Pressione senza Palla',
          OffBallRuns: 'Movimenti Senza Palla',
          HandPassing: 'Passaggio a mano'
        },
        HandPassing: 'Passaggio a mano'
      },
      types: {
        1: 'Per 90',
        2: 'Percentuale',
        3: 'Rapporto',
        4: 'Efficacia',
        5: 'Media',
        6: 'Per partita',
        7: 'Differenza',
        8: 'Max'
      },
      moreInfo: 'Puoi leggere di più qui'
    },
    api: {
      subtitle: 'Ottenere dati da diverse richieste',
      resourcesTitle: 'Risorse',
      authentication: 'Autenticazione',
      authText: 'Per effettuare una chiamata a API è necessario includere l\'intestazione in ogni richiesta `Authorization` con valore `Bearer {API_TOKEN}`',
      generate: 'Creare',
      tokenPlaceholder: 'Se non hai un token o è scaduto, fai clic su \'Crea\'',
      pathParameters: 'Parametri di percorso',
      queryParameters: 'Parametri di ricerca',
      responseModel: 'Modelli di risposta',
      tokenWarning: '* Crea un token per poter testare l\'API',
      pathParamsWarning: '* Ci sono parametri di percorso non riempiti',
      genericDescription: 'Un\'API (Application Programming Interface) consente agli sviluppatori di accedere e integrare dati o funzionalità nelle proprie applicazioni. La nostra API di statistiche calcistiche offre un accesso completo a una varietà di dati su paesi, competizioni, squadre, giocatori, partite e altro ancora. Utilizzando questa API, puoi creare applicazioni che sfruttano i nostri ricchi dati sul calcio per analisi, visualizzazioni o altre soluzioni innovative.',
      methods: {
        getAllCountries: 'Questo metodo recupera un elenco completo di tutti i paesi disponibili nell\'API, fornendo dettagli chiave come l\'identificativo univoco e il nome di ciascun paese. Questo endpoint è ideale per applicazioni che necessitano di dati geografici sul calcio, abilitando funzionalità come la selezione dei paesi, i filtri e le analisi. Serve anche come risorsa fondamentale per interagire con altri endpoint che dipendono dal parametro `countryId`, garantendo una navigazione fluida e un\'integrazione ottimale con il dataset dell\'API.',
        getCountryDetail: 'Questo metodo fornisce informazioni dettagliate su un paese specifico disponibile nell\'API. Utilizzando questo endpoint, è possibile ottenere dati come il nome del paese, il codice e eventuali metadati associati. Questo metodo è particolarmente utile per applicazioni che richiedono dettagli specifici di un paese per migliorare l\'esperienza utente, come la visualizzazione di informazioni contestuali o la creazione di approfondimenti personalizzati basati su dati geografici. Completa altri endpoint permettendo un\'esplorazione più approfondita di un paese selezionato.',
        getCountryCompetitions: 'Questo metodo recupera un elenco di tutte le competizioni disponibili in un paese specifico. È una risorsa preziosa per costruire funzionalità che consentono agli utenti di esplorare competizioni per regione, offrendo un modo fluido per collegare i dati di un paese ai relativi tornei. Questo endpoint è essenziale per applicazioni focalizzate su contenuti calcistici localizzati o analisi regionali.',
        getAllCompetitionTypes: 'Questo metodo restituisce un elenco di tutti i tipi di competizioni disponibili nell\'API, come campionati, coppe e tornei internazionali. Questo endpoint è ideale per categorizzare le competizioni e fornire agli utenti una visione organizzata dei diversi tipi di eventi coperti. È particolarmente utile per creare funzionalità come filtri o menu a tendina che permettono agli utenti di esplorare i dati calcistici in base alla natura della competizione.',
        getAllCompetitions: 'Questo metodo recupera un elenco completo di tutte le competizioni disponibili nell\'API, indipendentemente dal tipo o dalla localizzazione. Questo endpoint è utile per applicazioni che necessitano di visualizzare o analizzare un\'ampia gamma di competizioni calcistiche, consentendo agli utenti di esplorare e selezionare eventi di interesse.',
        getCompetitionAvailable: 'Questo metodo recupera un elenco delle competizioni attualmente disponibili nell\'API. Questo garantisce che i dati restituiti siano aggiornati e pronti per l\'uso nelle applicazioni. È particolarmente utile per sviluppatori che creano funzionalità basate su competizioni attive o accessibili, consentendo agli utenti di esplorare eventi rilevanti senza incontrare dati obsoleti o incompleti.',
        getCompetitionDetail: 'Questo metodo fornisce informazioni dettagliate su una specifica competizione disponibile nell\'API. È particolarmente utile per applicazioni che richiedono informazioni approfondite su una competizione, consentendo funzionalità come visualizzazioni dettagliate, approfondimenti contestuali o opzioni di filtro basate sulle caratteristiche della competizione.',
        getCompetitionSeasons: 'Questo metodo recupera un elenco di tutte le stagioni associate a una specifica competizione. Questo endpoint è essenziale per applicazioni che mirano a fornire una copertura completa della storia o dello stato attuale di una competizione, consentendo agli utenti di esplorare i dati stagione per stagione.',
        getSeasonAvailable: 'Questo metodo fornisce un elenco delle stagioni attualmente disponibili nell\'API. È particolarmente utile per applicazioni focalizzate su eventi calcistici in diretta o in corso, consentendo agli utenti di interagire con i dati pertinenti e aggiornati della stagione.',
        getSeasonDetail: 'Questo metodo recupera informazioni dettagliate su una stagione specifica, inclusa la sua timeline, la competizione associata e i principali metadati. Questo endpoint è essenziale per applicazioni che richiedono approfondimenti su una stagione particolare, abilitando funzionalità come panoramiche di stagione, filtri per competizione o visualizzazioni di timeline dettagliate per l\'interazione dell\'utente.',
        getSeasonTeams: 'Questo metodo fornisce un elenco di tutte le squadre partecipanti a una stagione specifica. È ideale per funzionalità come la gestione delle rose, l\'analisi delle prestazioni delle squadre o la creazione di filtri specifici per stagione.',
        getSeasonPlayer: 'Questo metodo recupera un elenco di tutti i giocatori registrati in una stagione specifica. È ideale per costruire funzionalità come rose dei giocatori, monitoraggio delle prestazioni o filtri basati sulla stagione selezionata.',
        getSeasonPlayerStats: 'Questo metodo fornisce statistiche dettagliate per tutti i giocatori di una stagione specifica. È particolarmente utile per applicazioni focalizzate su analisi, confronti tra giocatori o creazione di visualizzazioni dinamiche sui traguardi raggiunti dai giocatori durante la stagione.',
        getSeasonArrigoMetrics: 'Questo metodo fornisce statistiche combinate per tutti i giocatori in una specifica stagione. È particolarmente utile per applicazioni incentrate su analisi, confronti tra giocatori o creazione di visualizzazioni dinamiche dei risultati stagionali dei giocatori.',
        getSeasonTeamStats: 'Questo metodo fornisce statistiche complete per tutte le squadre partecipanti a una stagione specifica. È particolarmente utile per applicazioni focalizzate sull\'analisi delle squadre, sui riepiloghi della stagione o sui confronti delle prestazioni delle squadre durante la stagione.',
        getSeasonCoaches: 'Questo metodo recupera un elenco di tutti gli allenatori che hanno guidato le squadre durante una stagione specifica. È particolarmente utile per applicazioni che si concentrano su approfondimenti sulla stagione, analisi degli allenatori o monitoraggio dei cambiamenti nella gestione delle squadre nel corso della stagione.',
        getSeasonGames: 'Questo metodo fornisce un elenco di tutte le partite giocate in una stagione specifica. È ideale per applicazioni che necessitano di visualizzare i calendari completi della stagione, analizzare i risultati delle partite o fornire agli utenti l\'accesso a dati completi sulle partite della stagione.',
        getSeasonGamesMatchday: 'Questo metodo recupera tutte le partite di una giornata specifica all\'interno di una determinata stagione. È particolarmente utile per applicazioni che mirano a visualizzare i calendari delle giornate, analizzare turni specifici o fornire approfondimenti su un insieme particolare di partite durante la stagione.',
        getSeasonLeagueTable: 'Questo metodo fornisce la classifica di una stagione specifica, inclusi posizionamenti, punti, vittorie, pareggi, sconfitte e altre statistiche rilevanti per ogni squadra. Questo endpoint è essenziale per applicazioni focalizzate sul monitoraggio delle classifiche delle squadre, sull\'analisi della progressione del campionato o sulla presentazione di classifiche aggiornate agli utenti durante la stagione.',
        getTeamDetail: 'Questo metodo fornisce informazioni dettagliate su una squadra specifica, inclusi nome, anno di fondazione, stadio e altri metadati. Questo endpoint è ideale per applicazioni che richiedono approfondimenti specifici sulle squadre, abilitando funzionalità come profili dettagliati, contesto storico o esperienze utente migliorate con dati ricchi relativi alla squadra.',
        getTeamLoans: 'Questo metodo recupera informazioni sulle transazioni di prestito che coinvolgono una squadra specifica. Questo endpoint è particolarmente utile per applicazioni focalizzate sull\'analisi dei trasferimenti, la gestione delle rose o il monitoraggio dei movimenti dei giocatori durante una stagione.',
        getTeamRoster: 'Questo metodo fornisce un elenco completo dei giocatori nella rosa di una squadra specifica. È ideale per applicazioni che devono mostrare le formazioni delle squadre, analizzare i ruoli dei giocatori o gestire funzionalità legate alla rosa di una squadra.',
        getTeamGames: 'Questo metodo recupera un elenco di tutte le partite giocate da una squadra specifica. È particolarmente utile per applicazioni focalizzate sulle prestazioni della squadra, sul monitoraggio del calendario o sul fornire agli utenti l\'accesso alla cronologia completa delle partite di una squadra.',
        getTeamGameStats: 'Questo metodo fornisce statistiche dettagliate per una squadra specifica in una determinata partita. È particolarmente utile per applicazioni che si concentrano sull\'analisi delle partite, valutazioni delle prestazioni o approfondimenti dettagliati sulle prestazioni della squadra in singoli incontri.',
        getTeamTransfers: 'Questo metodo recupera informazioni sulle transazioni di trasferimento che coinvolgono una squadra specifica. È particolarmente utile per applicazioni focalizzate sull\'analisi del mercato dei trasferimenti, sui cambiamenti nella rosa della squadra o sul monitoraggio dei movimenti dei giocatori nel tempo.',
        getGameStatus: 'Questo metodo fornisce un elenco di tutti i possibili stati delle partite disponibili nell\'API, come programmata, in corso, completata, rinviata o annullata. Questo endpoint è particolarmente utile per applicazioni che richiedono il monitoraggio in tempo reale delle partite, la filtrazione delle partite per stato o l\'offerta di aggiornamenti chiari agli utenti sul progresso o lo stato di una partita.',
        getPlayerPositions: 'Questo metodo restituisce un elenco di tutte le possibili posizioni dei giocatori, come portiere, difensore, centrocampista e attaccante. Questo endpoint è particolarmente utile per applicazioni che classificano i giocatori, analizzano dati posizionali o consentono agli utenti di filtrare i giocatori in base ai loro ruoli in campo.',
        getGameDetail: 'Questo metodo fornisce informazioni complete su una partita specifica, inclusi dettagli come squadre partecipanti, data e ora, luogo, punteggio e altri metadati chiave. Questo endpoint è ideale per applicazioni che richiedono approfondimenti dettagliati sulle partite, abilitando funzionalità come anteprime dettagliate, report o analisi.',
        getGameStats: 'Questo metodo fornisce statistiche dettagliate su una partita specifica, incluse metriche come gol, tiri, percentuali di possesso palla, passaggi e azioni difensive. Questo endpoint è particolarmente utile per applicazioni focalizzate su analisi delle partite, report post-partita o visualizzazioni delle prestazioni delle squadre durante una gara.',
        getGamePlayerStats: 'Questo metodo recupera statistiche dettagliate sulle prestazioni di tutti i giocatori che hanno partecipato a una partita specifica. È particolarmente utile per applicazioni che analizzano le prestazioni individuali dei giocatori, generano report sulle partite o confrontano i giocatori nel contesto di una singola gara.',
        getGamePlayerPhysicalStats: 'Questo metodo fornisce metriche dettagliate sulle prestazioni fisiche dei giocatori in una partita specifica. È particolarmente utile per applicazioni che si concentrano sull\'analisi della condizione fisica dei giocatori, sul monitoraggio delle prestazioni fisiche o sulla generazione di approfondimenti dettagliati sulle partite per i singoli giocatori.',
        getGameTeamPhysicalStats: 'Questo metodo fornisce metriche dettagliate sulle prestazioni fisiche delle squadre in una partita specifica. Include dati come la distanza totale percorsa, il numero di sprint, le corse ad alta intensità e altri attributi fisici. È particolarmente utile per applicazioni focalizzate sull\'analisi della condizione fisica delle squadre, sul confronto degli sforzi fisici tra squadre o sulla valutazione delle prestazioni complessive in una partita.',
        getGamePlayerArrigoMetrics: 'Questo metodo fornisce metriche arrigo dettagliate per i giocatori in una partita specifica. È particolarmente utile per le applicazioni incentrate sull\'analisi e sulla generazione di informazioni dettagliate sui giocatori in una partita.',
        getGameTeamArrigoMetrics: 'Questo metodo fornisce metriche dettagliate sul team Arrigo in una partita specifica. Include dati come i giocatori battuti e altri attributi. È particolarmente utile per le applicazioni focalizzate sull\'analisi della valutazione delle prestazioni complessive della partita.',
        getGameLineup: 'Questo metodo recupera la formazione di una partita specifica, inclusi i titolari, i sostituti e le rispettive posizioni. Questo endpoint è particolarmente utile per applicazioni che mostrano informazioni pre-partita, analizzano le formazioni tattiche o forniscono approfondimenti sulle decisioni strategiche prese dalle squadre per una determinata partita.',
        getGameTimeline: 'Questo metodo fornisce un elenco cronologico degli eventi accaduti durante una partita specifica. È particolarmente utile per applicazioni che offrono aggiornamenti in tempo reale, riepiloghi post-partita o analisi dettagliate degli eventi di gara.',
        getGameTracking: 'Questo metodo fornisce un link per scaricare il file di dati di tracciamento di una partita specifica. Questo file contiene dati dettagliati sui movimenti e sul posizionamento dei giocatori e della palla durante la gara. È particolarmente utile per applicazioni focalizzate su analisi avanzate, analisi tattiche o creazione di visualizzazioni dei movimenti di giocatori e palla durante la partita.',
        getTrackingStatus: 'Questo metodo restituisce un elenco completo di tutti gli stati disponibili nel monitoraggio, fornendo dettagli chiave come l\'identificatore univoco e il nome di ciascuno stato. Questo endpoint è ideale per le applicazioni che richiedono il monitoraggio delle corrispondenze, abilitando funzionalità come la selezione dello stato, il filtraggio e l\'analisi. Serve anche come risorsa fondamentale per interagire con altri endpoint che dipendono da un parametro statusId, garantendo una navigazione e un\'integrazione fluide con il set di dati più ampio dell\'API.',
        getPlayerTransfersTypes: 'Questo metodo recupera un elenco dei possibili tipi di trasferimenti dei giocatori, come trasferimento permanente, prestito, trasferimento gratuito o scambio. Questo endpoint è particolarmente utile per applicazioni che analizzano le tendenze del mercato dei trasferimenti, categorizzano i movimenti dei giocatori o forniscono approfondimenti dettagliati sui tipi di transazioni che coinvolgono i giocatori.',
        getPlayerDetail: 'Questo metodo fornisce informazioni dettagliate su un giocatore specifico, inclusi dettagli personali, statistiche di carriera e affiliazione alla squadra attuale. Questo endpoint è ideale per applicazioni che offrono profili dei giocatori, approfondimenti storici o analisi delle prestazioni individuali e delle traiettorie di carriera.',
        getPlayerGames: 'Questo metodo recupera un elenco di tutte le partite a cui ha partecipato un giocatore specifico. È particolarmente utile per applicazioni focalizzate sul monitoraggio delle prestazioni del giocatore, sull\'analisi della cronologia delle partite o sulla fornitura di registri completi delle partite per singoli giocatori.',
        getPlayerInjuries: 'Questo metodo fornisce un registro dettagliato delle lesioni subite da un giocatore specifico. È particolarmente utile per applicazioni focalizzate sull\'analisi della salute del giocatore, sulla valutazione dell\'impatto sulla carriera o sul monitoraggio dei tempi di recupero.',
        getPlayerNationalTeam: 'Questo metodo recupera informazioni dettagliate sulla partecipazione di un giocatore a partite della nazionale. È particolarmente utile per applicazioni che analizzano le prestazioni dei giocatori a livello nazionale, seguono le carriere internazionali o forniscono approfondimenti sui contributi durante tornei e amichevoli.',
        getPlayerSeasons: 'Questo metodo fornisce un elenco di tutte le stagioni a cui ha partecipato un giocatore specifico. È particolarmente utile per applicazioni che monitorano la progressione della carriera di un giocatore, analizzano le prestazioni nel corso delle stagioni o forniscono un contesto storico per le sue conquiste.',
        getPlayerTransfers: 'Questo metodo recupera una cronologia dettagliata delle transazioni di trasferimento che coinvolgono un giocatore specifico. È particolarmente utile per applicazioni focalizzate sull\'analisi della carriera del giocatore, sui dati del mercato dei trasferimenti o sul monitoraggio dei movimenti dei giocatori tra squadre nel tempo.',
        getPlayerSeasonTeamStats: 'Questo metodo fornisce statistiche dettagliate sulle prestazioni di un giocatore specifico durante una stagione con una squadra. È particolarmente utile per applicazioni focalizzate sull\'analisi delle prestazioni del giocatore per tutta la stagione, sui confronti tra squadre o stagioni e sul monitoraggio dei contributi individuali al successo della squadra.',
        getPlayerSeasonPhysicalStats: 'Questo metodo fornisce metriche dettagliate sulle prestazioni fisiche di un giocatore specifico durante una stagione. È particolarmente utile per applicazioni che monitorano la condizione fisica del giocatore, analizzano le prestazioni fisiche o valutano il carico di lavoro di un giocatore durante la stagione.',
        getPlayerSeasonGamePhysicalStats: 'Questo metodo fornisce metriche dettagliate sulle prestazioni fisiche di un giocatore specifico per ogni partita di una stagione. È particolarmente utile per applicazioni che analizzano la condizione fisica in partite specifiche, monitorano il carico di lavoro dei giocatori o confrontano le prestazioni fisiche in diverse partite.',
        getPlayerSeasonGameStats: 'Questo metodo recupera statistiche dettagliate sulle prestazioni di un giocatore specifico per ogni partita di una stagione. È particolarmente utile per applicazioni focalizzate sull\'analisi specifica per partita del giocatore, sulle tendenze di rendimento o sui confronti dettagliati tra partite all\'interno di una stagione.',
        getCoachDetail: 'Questo metodo fornisce informazioni dettagliate su un allenatore specifico, inclusi nome, carriera, squadre allenate e risultati significativi. Questo endpoint è particolarmente utile per applicazioni che evidenziano profili di allenatori, monitorano le carriere tecniche o analizzano l\'impatto degli allenatori sulle prestazioni delle squadre.',
        getCoachHistory: 'Questo metodo recupera una cronologia completa della carriera di un allenatore specifico, incluse le squadre allenate, le competizioni a cui ha partecipato e la durata dei suoi incarichi. Questo endpoint è particolarmente utile per applicazioni che analizzano le carriere tecniche, monitorano i cambiamenti nella gestione o forniscono approfondimenti sul percorso professionale e sui successi di un allenatore.',
        getGameEventing: 'Questo metodo fornisce tutti gli eventi',
        getLinkStream: 'Questo metodo recupera il collegamento per guardare il video del gioco',
        getLinkDownload: 'Questo metodo recupera il collegamento per scaricare il video del gioco',
        getGameTs: 'Questo metodo fornisce l\'ultimo timestamp in una partita specifica',
        getGameFileTypes: 'Questo metodo fornisce i tipi di file per la corrispondenza',
        deletePlayer: 'This method delete a player',
        getGeneralPositions: 'Questo metodo restituisce un elenco di possibili posizioni generali, come portiere, difensore, centrocampista e attaccante.',
        getPercentiles: 'Questo metodo fornisce tutti i percentili disponibili',
        getPlayerPercentilesEventing: 'Questo metodo fornisce tutte le statistiche per un percentile e una posizione specifici'
      },
      responseCodes: 'Codici di risposta',
      furtherInformation: 'Per ulteriori informazioni, per favore leggi la nostra documentazione API',
      clipboard: 'Copiato negli appunti!',
      limit50: 'Mostra solo i primi 50 risultati'
    }
  },
  globalSearch: {
    subtitle: 'Filtro Intensivo'
  },
  global: {
    teamElos: {
      title: 'ELO DI SQUADRE',
      subtitle: 'Classifiche e analisi globali delle squadre',
      team: 'Squadra',
      teams: 'Squadre',
      dates: 'Date',
      excludeInternational: 'Escludi squadre internazionali',
      elo: 'ELO',
      selectButton: 'Seleziona In alto',
      selectTeamFromTable: 'Seleziona una squadra dalla tabella per visualizzare il trend ELO.',
      showingTeamAveragesLastSeason: 'Visualizza le medie di squadra per l\'ultima stagione',
      showingTeamStatsLastSeason: 'Visualizza solo le statistiche di squadra per la loro ultima stagione attiva',
      searchToolTip: 'Suggerimento: premi Ctrl + B per accedere direttamente alla barra di ricerca',
      selectTopTooltip: 'Visualizza squadre aggiuntive nella tabella per il confronto',
      loadingPage: 'Preparazione dei dati...'
    },
    leagueElos: {
      title: 'LEAGUE ELO\'S',
      subtitle: 'Classifiche e analisi globali delle leghe',
      rankings: 'CLASSIFICHE',
      insights: 'APPROFONDIMENTI',
      filters: 'FILTRI',
      leagues: 'Leghe',
      from: 'Da',
      to: 'A',
      elo: 'ELO',
      change: 'Variazione',
      league: 'Lega',
      excludeContinental: 'Escludi Competizioni Internazionali',
      eloTrend: 'Trend ELO',
      eloRanking: 'Classifica ELO',
      currentELOLabel: '(ELO attuale)',
      allTime: 'Tutto il tempo',
      average: 'Media',
      noChartData: 'Nessun dato di grafico disponibile per i filtri selezionati.',
      selectLeagueFromTable: 'Seleziona un campionato dalla tabella per visualizzare la tendenza ELO.',
      noInsightsData: 'Nessun approfondimento disponibile per le leghe selezionate. Assicurati che le leghe abbiano stagioni e dati di approfondimento delle squadre disponibili.',
      showingLeagueAveragesLastSeason: 'Visualizzazione solo delle medie delle leghe per la loro ultima stagione attiva',
      selectTopTooltip: 'Visualizza ulteriori campionati nella tabella per il confronto',
      confederations: {
        world: 'Mondo',
        top5: 'TOP 5',
        uefa: 'UEFA',
        conmebol: 'CONMEBOL',
        concacaf: 'CONCACAF',
        caf: 'CAF',
        afc: 'AFC'
      },
      numberOfLeagues: 'Numero di leghe',
      minimumElo: 'ELO minimo'
    },
    players: {
      title: 'GPI del giocatore',
      subtitle: 'Classifiche e approfondimenti globali sui giocatori',
      gpiRanking: 'Classifica GPI',
      rankTooltip: 'Passa il mouse per visualizzare la classifica globale',
      globalRanking: 'Classifica globale',
      player: 'Giocatore',
      players: 'Giocatori',
      gpiTrend: 'Tendenza GPI',
      currentGPILabel: '(GPI corrente)',
      nationality: 'Paese di nascita',
      position: 'Posizione',
      marketValue: 'Valore di mercato',
      apply: 'Fare domanda a',
      marketValueAndAgeTooltip: 'Immettere un intervallo e fare clic su Applica o premere Invio.',
      searchPlaceholder: 'Cerca un giocatore...',
      selectTopTooltip: 'Visualizza altri giocatori nella tabella per il confronto',
      gpi: 'GPI',
      numberOfPlayers: 'Numero di giocatori',
      showingPlayerStatsLastSeason: 'Mostra solo le statistiche medie dei giocatori per la loro ultima stagione attiva',
      date: 'DATA',
      showChartLabels: 'Mostra etichette',
      marketValueTooltip: 'Immettere un intervallo e fare clic su Applica o premere Invio.',
      freeAgents: 'Agenti liberi',
      selectPlayerFromTable: 'Seleziona un giocatore dalla tabella per visualizzare l\'andamento del GPI.'
    }
  },
  iso: {
    AF: 'Afghanistan',
    DZ: 'Algeria',
    AO: 'Angola',
    AR: 'Argentina',
    AU: 'Australia',
    AZ: 'Azerbaijan',
    BH: 'Bahrain',
    BB: 'Barbados',
    BE: 'Belgio',
    BJ: 'Benin',
    BO: 'Bolivia',
    BW: 'Botswana',
    BN: 'Brunei',
    BF: 'Burkina Faso',
    KH: 'Cambogia',
    CA: 'Canada',
    CF: 'Republica Centroafricana',
    CL: 'Cile',
    CO: 'Colombia',
    CD: 'Congo DR',
    CG: 'Congo',
    CI: 'Costa d\'Avorio',
    CU: 'Cuba',
    CZ: 'Repubblica Ceca',
    DJ: 'Gibuti',
    DO: 'Repubblica Dominicana',
    EC: 'Ecuador',
    SV: 'El Salvador',
    ER: 'Eritrea',
    ET: 'Etiopia',
    FI: 'Finlandia',
    PF: 'Polinesia Francese',
    GM: 'Gambia',
    DE: 'Germania',
    GI: 'Gibilterra',
    GL: 'Groenlandia',
    GP: 'Guadalupe',
    GN: 'Guinea',
    GY: 'Guyana',
    HN: 'Honduras',
    HU: 'Ungheria',
    IN: 'India',
    IR: 'Iran',
    IE: 'Irlanda',
    IT: 'Italia',
    JP: 'Giappone',
    KZ: 'Kazakistan',
    KI: 'Kiribati',
    KR: 'Corea del sud',
    KG: 'Kyrgyzstan',
    LV: 'Lettonia',
    LS: 'Lesotho',
    LY: 'Libia',
    LT: 'Lituania',
    MO: 'Macau SAR',
    MG: 'Madagascar',
    MY: 'Malesia',
    ML: 'Mali',
    MH: 'Isole Marshall',
    MR: 'Mauritania',
    MX: 'Messico',
    MD: 'Moldavia',
    MN: 'Mongolia',
    MA: 'Marocco',
    MM: 'Myanmar',
    NR: 'Nauru',
    NL: 'Paesi Bassi',
    NZ: 'Nuova Zelanda',
    NE: 'Nigeria',
    MP: 'Isole Marianas',
    OM: 'Oman',
    PW: 'Palau',
    PA: 'Panama',
    PY: 'Paraguay',
    PH: 'Filippine',
    PT: 'Portogallo',
    QA: 'Qatar',
    RO: 'Romania',
    RW: 'Ruanda',
    LC: 'Santa Lucia',
    SM: 'San Marino',
    SA: 'Arabia Saudita',
    RS: 'Serbia',
    SL: 'Sierra Leona',
    SK: 'Slovacchia',
    SB: 'Isole Salomone',
    ZA: 'Sudafrica',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SZ: 'Eswatini',
    CH: 'Svizzera',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    TG: 'Togo',
    TT: 'Trinidad y Tobago',
    TR: 'Turchia',
    TV: 'Tuvalu',
    UA: 'Ucrania',
    GB: 'Regni Unito',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VG: 'Isole Vergini Britanniche',
    EH: 'Sahara occidentale',
    ZM: 'Zambia',
    AL: 'Albania',
    AD: 'Andorra',
    AG: 'Antigua e Barbuda',
    AM: 'Armenia',
    AT: 'Austria',
    BS: 'Bahamas',
    BD: 'Bangladesh',
    BY: 'Bielorussia',
    BZ: 'Belize',
    BT: 'Butan',
    BA: 'Bosnia e Herzegovina',
    BR: 'Brasile',
    BG: 'Bulgaria',
    BI: 'Burundi',
    CM: 'Camerun',
    CV: 'Capo Verde',
    TD: 'Chad',
    CN: 'Cina',
    KM: 'Comore',
    CR: 'Costa Rica',
    HR: 'Croazia',
    CY: 'Cipro',
    DK: 'Danamarca',
    DM: 'Dominica',
    TL: 'Timor Orientale',
    EG: 'Egitto',
    GQ: 'Guinea Equatoriale',
    EE: 'Estonia',
    FJ: 'Fiji',
    FR: 'Francia',
    GA: 'Gabon',
    GE: 'Georgia',
    GH: 'Ghana',
    GR: 'Grecia',
    GD: 'Granada',
    GT: 'Guatemala',
    GW: 'Guinea-Bissau',
    HT: 'Haiti',
    HK: 'Hong Kong SAR',
    IS: 'Islanda',
    ID: 'Indonesia',
    IQ: 'Iraq',
    IL: 'Israel',
    JM: 'Giamaica',
    JO: 'Jordania',
    KE: 'Kenya',
    KP: 'Corea del nord',
    KW: 'Kuwait',
    LA: 'Laos',
    LB: 'Libano',
    LR: 'Liberia',
    LI: 'Liechtenstein',
    LU: 'Lussemburgo',
    MK: 'Macedonia',
    MW: 'Malawi',
    MV: 'Maldive',
    MT: 'Malta',
    MQ: 'Martinica',
    MU: 'Mauritius',
    FM: 'Micronesia',
    MC: 'Monaco',
    ME: 'Montenegro',
    MZ: 'Mozambico',
    NA: 'Namibia',
    NP: 'Nepal',
    NC: 'Nuova Caledonia',
    NI: 'Nicaragua',
    NG: 'Nigeria',
    NO: 'Norvegia',
    PK: 'Pakistan',
    PS: 'Territori Palestinesi',
    PG: 'Papua Nuova Guinea',
    PE: 'Perú',
    PL: 'Polonia',
    PR: 'Porto Rico',
    RE: 'Réunion',
    RU: 'Federazione Russa',
    KN: 'San Cristobal e Nieves',
    WS: 'Samoa',
    ST: 'Santo Tomé e Príncipe',
    SN: 'Senegal',
    SC: 'Seychelles',
    SG: 'Singapore',
    SI: 'Slovenia',
    SO: 'Somalia',
    ES: 'Spagna',
    VC: 'San Vicente e le Granadine',
    SR: 'Suriname',
    SE: 'Svezia',
    SY: 'Siria',
    TJ: 'Tajikistan',
    TH: 'Thailandia',
    TO: 'Tonga',
    TN: 'Tunisia',
    TM: 'Turkmenistan',
    UG: 'Uganda',
    AE: 'Emirati Arabi Uniti',
    US: 'Stati Uniti',
    UZ: 'Uzbekistan',
    VA: 'Città del Vaticano',
    VN: 'Vietnam',
    VI: 'Isole Vergini degli USA',
    YE: 'Yemen',
    ZW: 'Zimbabwe',
    EU: 'Europa',
    INT: 'Internazionale',
    CW: 'Curaçao',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': 'Inghilterra',
    'GB-WLS': 'Galles',
    'GB-SCT': 'Scozia',
    LATAM: 'America del Sud',
    CAF: 'CAF',
    XK: 'Kosovo',
    AI: 'Anguilla',
    AN: 'Netherlands Antilles',
    AS: 'American Samoa',
    AW: 'Aruba',
    BM: 'Bermuda',
    BQ: 'Bonaire, SE and Saba',
    CK: 'The Cook Islands',
    FO: 'The Faroe Islands',
    GF: 'Guyane',
    GG: 'The Bailiwick of Guernsey',
    GU: 'The Territory of Guam',
    IM: 'The Isle of Man',
    JE: 'The Bailiwick of Jersey',
    KY: 'The Cayman Islands',
    MF: 'The Collectivity of Saint-Martin',
    MS: 'Montserrat',
    NU: 'Niue',
    OC: 'Oceania',
    RI: 'Indonesia',
    SS: 'The Republic of South Sudan',
    TC: 'The Turks and Caicos Islands',
    YT: 'The Department of Mayotte',
    SX: 'Sint Maarten'
  },
  loadingMessages: {
    players: 'Prepara giocatori',
    teams: 'Ordina squadre',
    games: 'Recupera partite',
    stats: 'Calcola parametri',
    graphs: 'Traccia grafici',
    gettingReady: 'Caricamento',
    placeholder: 'Carica'
  },
  requestReport: {
    subtitle: 'Recevi un report approfondito con ciò di cui hai bisogno',
    categories: {
      scouting: {
        title: 'Scouting',
        subtitle: 'Quali sono i migliori giocatori di un campionato? E di vari campionati? Inviaci una richiesta personalizzata, con i filtri che ritieni opportuni (età, altezza, scadenza contratto) e scopri quali sono giocatori che si adattano meglio alle tue richieste.'
      },
      coaches: {
        title: 'Allenatori',
        subtitle: 'Come gioca un allenatore e in che modo il suo stile di gioco si adatterebbe al tuo club? Ottieni informazioni dettagliate o, dato un profilo, conosci quali allenatori soddisfano le tue esigenze.'
      },
      'team analysis': {
        title: 'Analisi squadra',
        subtitle: 'Ottieni un report dettagliato di una squadra: stile, prestazioni difensive e offensive, punti deboli, migliori giocatori, ecc ...'
      },
      'game analysis': {
        title: 'Analisi partita',
        subtitle: 'Data una partita, ottieni un\'analisi pre/post partita con informazioni dettagliate'
      },
      'special projects': {
        title: 'Progetti speciali',
        subtitle: 'Come si comporta un giocatore fuori casa? Come cambiano i giocatori da campionato a campionato? Quali giocatori sono disponibili al prestito? Chiedici tutto ciò che ti possa venire in mente.'
      },
      conversation: {
        title: 'Conversazione',
        subtitle: 'Inizia una conversazione con noi'
      }
    },
    notesPlaceholder: 'Indica campionato, profilo, allenatore, squadra o partita su cui hai bisogno di informazioni',
    chooseType: 'Seleziona tipo di report',
    requestSummary: 'Riepilogo richiesta',
    reportType: 'Tipo di report',
    reportLanguage: 'Lingua della report',
    detailTitle: 'Seguito del report',
    detailSubtitle: 'Tutte le informazioni sul report richiesto'
  },
  bugReport: {
    modalSubtitle: 'Aiutaci a migliorare',
    about: 'A proposito di',
    sendSuccess: 'Inviata con successo. Controlla gli aggiornamenti dalla tua casella di posta',
    bugs: 'Errori'
  },
  gbe: {
    autopass: 'Auto Pass',
    bandX: 'Band {0}',
    bandXCont: 'Band {0} Competizione continentale',
    points: 'Punti',
    titleWinner: 'Vincitore del Titolo',
    qualifiedGroupsBandX: 'Qualificato per la fase a gruppi of a Band {0} competizione continentale',
    qualifiedQualifiersBandX: 'Qualified for qualifiers of a Band {0} Continental Competition',
    midTable: 'Metà classifica',
    relegation: 'Retrocessione',
    promotion: 'Promozione',
    final: 'Finale',
    semifinal: 'Semi-Finale',
    quarterfinal: 'Quarti di Finale',
    round16: 'Ottavi di Finale',
    round32: 'Sedicesimi di finale',
    groupstage: 'Fase a Gruppi',
    firstRound: '1º Turno',
    secondRound: '2º Turno',
    thirdRound: '3º Turno',
    fourthRound: '4º Turno',
    preliminaryRound: 'Turno Preliminare',
    other: 'Altro',
    score: 'Punteggio',
    totalSummary: 'Riassunto totale',
    currentlyPlayingInUK: 'Il calciatore è un cittadino del Regno Unito o Irlanda, o il giocatore è un residente permanente del Regno Unito',
    bandsAlert: 'There are minutes played in more than one band, total is the max value',
    bandsAlertMax: 'There are minutes played in more than one band, total is the max value',
    bandsAlertAvg: 'There are minutes played in more than one band, total is the average value',
    generate: 'GBEApplicationForm',
    debutYouthPlayer: 'Debut for Youth Player',
    table1: {
      name: 'Presenze internazionali del giocatore',
      title1: 'Aggregated FIFA World Ranking of the Player’s National Association',
      title2: 'Presenze internazionali del giocatore'
    },
    table2: {
      name: 'Player’s Domestic Minutes',
      title1: 'Player’s Domestic Minutes'
    },
    table3: {
      name: 'Player’s Continental Minutes',
      title1: 'Player’s Continental Minutes'
    },
    table4: {
      name: 'Final League Position of Player´s Last Club',
      title1: 'Last Club’s Final League Position'
    },
    table5: {
      name: 'Continental Progression of Player´s Last Club',
      title1: 'Continental Progression'
    },
    table6: {
      name: 'League Quality of Player´s Current Club',
      title1: 'Band of Player’s Current Club'
    },
    table7: {
      name: 'Youth - Debut',
      title1: 'Band'
    },
    table8: {
      name: 'Youth - Final League Position',
      title1: 'Last Club’s Final League Position'
    },
    table9: {
      name: 'Youth - Continental Progression',
      title1: 'Continental Progression'
    },
    table10: {
      name: 'Youth - League Quality of Player´s Current',
      title1: 'Band of Player’s Current Club'
    },
    table11: {
      name: 'Youth - League Quality of Player´s Current',
      title1: 'Band of Player’s Current Club'
    },
    table12: {
      name: 'Youth - Presenza Internazionali',
      title1: 'Presenze Internazionali'
    }
  },
  mediaMode: {
    borderColor: 'Colore del bordo',
    fillColor: 'Colore di riempimento',
    bgColor: 'Colore di sfondo',
    upperText: 'Testo superiore',
    lowerText: 'Testo inferiore',
    socialMedia: 'Social media',
    textColor: 'Colore del testo',
    axisColor: 'Colore degli assi',
    logo: 'Logo',
    comparisonBorderColor: 'Confronto colore del bordo',
    comparisonFillColor: 'Confronto colore di sfondo',
    comparisonUpperText: 'Confronto testo superiore',
    comparisonLowerText: 'Confronto testo inferiore',
    homeFillColor: 'Colore di riempimento (Locale)',
    homeBorderColor: 'Colore del bordo (Locale)',
    awayFillColor: 'Colore di riempimento (Ospiti)',
    awayBorderColor: 'Colore del bordo (Ospiti)',
    face: 'Facciata',
    nationalTeam: 'Nazionale',
    comparisonFace: 'Confronta facciata',
    upperTextX: 'Testo superiore {0}',
    lowerTextX: 'Testo inferiore {0}',
    borderColorX: 'Colore del bordo {0}',
    fillColorX: 'Colore di riempimento {0}',
    homeFillColorX: 'Colore di riempimento (Locale) {0}',
    homeBorderColorX: 'Colore del bordo (Locale) {0}',
    awayFillColorX: 'Colore di riempimento (Ospiti) {0}',
    awayBorderColorX: 'Colore del bordo (Ospiti) {0}',
    faceX: 'Faccia {0}',
    selectField: 'Seleziona un campo',
    orientationX: 'Orientamento {0}',
    searchBarPlaceholder: 'Cerca giocatori e/o partite...',
    title: 'Media - Comandi',
    pageSubtitle: 'Sfogliare e scaricare mappe e grafici',
    chooseChart: 'Seleziona grafico...',
    headerTextX: 'Testo superiore {0}',
    avatarLineLength: 'Lunghezza linea avatar',
    avatarLineWeight: 'Spessore linea Avatar',
    avatarSize: 'Dimensione avatar',
    chartX: 'Grafico {0}',
    chartHeaderFontSize: 'Dimensione titolo grafici',
    chartHeaderFontWeight: 'Spessore titolo grafici',
    upperTextFontSize: 'Dimensione testo superiore',
    upperTextFontWeight: 'Spessore testo superiore',
    lowerTextFontSize: 'Dimnesione testo inferiore',
    lowerTextFontWeight: 'Spessore testo inferiore',
    socialMediaFontSize: 'Dimensione testo social media',
    socialMediaFontWeight: 'Spessore testo social media',
    subtitle: 'Sottotitolo',
    subtitleFontSize: 'Dimensione sottotitolo',
    subtitleFontWeight: 'Spessore sottotitolo',
    subtitleX: 'Sottotitolo {0}',
    subtitleFontSizeX: 'Dimensione sottotitolo {0}',
    subtitleFontWeightX: 'Spessore sottotitolo {0}',
    titleX: 'Titolo {0}',
    titleFontSize: 'Dimensione titolo',
    titleFontWeight: 'Spessore Sottotitolo',
    sponsor: 'Sponsor',
    fontFamily: 'Font family'
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'Report scouting',
      GAME_REPORT: 'Report partite',
      MEDICAL_REPORT: 'Report medico',
      PHYSICAL_REPORT: 'Report fisico',
      PSYCHOLOGICAL_REPORT: 'Report psicologico',
      OTHER: 'Altri',
      QUICK_NOTES: 'Note',
      PLAYER_REPORT: 'Report Giocatore',
      GENERAL_COMMENTS: 'Commenti generali',
      PLAYER_ANALYSIS: 'Analisi dei giocatori'
    },
    uploadDocument: 'Carica documento',
    notesPlaceholder: 'Aggiungi note o commenti relativi al documento',
    notesPlaceholderAlt: 'Aggiunge note o commenti relativi al giocatore',
    uploadedBy: 'Caricato da',
    updatedBy: 'Aggioranto da',
    seeNotes: 'Vedi note',
    addNote: 'Aggiungi nota',
    rating: 'Rating',
    position: 'Posizione migliore',
    physical: 'Physical',
    onBall: 'On Ball',
    offBall: 'Off Ball',
    mental: 'Mental',
    potential: 'Potential',
    conclusion: 'Conclusion',
    recommendation: {
      1: 'Ingaggiare',
      2: 'Monitorare',
      3: 'Scartare',
      4: 'Interessante',
      label: 'Raccomandazione'
    },
    match: 'Partita',
    deleteQuickNote: 'Elimina nota',
    deleteQuickNoteMessage: 'La nota verrà eliminata permanentemente. Sei sicuro?',
    noQuickNotes: 'Nessun dato. Inizia aggiungendo delle note!',
    deleteDocument: 'Elimina documento',
    deleteDocumentMessage: 'Il documento verrà eliminato permanentemente. Sei sicuro?',
    noDocuments: 'Nessun dato. Inizia aggiungendo alcuni documenti!'
  },
  notifications: {
    newReportMessage: 'C\'è un nuovo messaggio nel report'
  },
  blog: {
    subtitle: 'Ultimi articoli, anteprime e novità',
    newEntry: 'Nuovi arrivi',
    title: 'Titolo',
    text: 'Testo',
    link: 'Link',
    image: 'Immagine',
    author: 'Autore',
    date: 'Data di pubblicazione',
    deleteEntry: 'Elimina voce',
    deleteEntryMessage: 'Sei sicuro di voler eliminare questa voce?',
    readMore: 'Leggi di più'
  },
  positionsOrlegi: {
    GK: 'Portero',
    DC: 'Central',
    DR: 'Lateral',
    MC: 'Centrocampista',
    AMC: 'Mezzapunta',
    FW: 'Delantero',
    FWR: 'Extremo'
  },
  library: {
    subtitle: 'Visualizzazione e condivisione di documenti aggiornati',
    mediaSubtitle: 'Visualizzare e condividere i grafici esportati',
    charts: 'Grafici',
    goToLibrary: 'Andare in biblioteca'
  },
  scatterPlot: {
    bubbleSize: 'Dimensione Bolla',
    byMinutes: 'per minuti',
    byAge: 'per età',
    byMarketValue: 'per valore di mercato'
  },
  eventChart: {
    successfulEvent: 'Riuscito',
    unsuccessfulEvent: 'Senza successo',
    possessionLost: 'Riuscito non recuperato',
    successfulPass: 'Passaggio completato',
    unsuccessfulPass: 'Passaggio completato',
    successfulCarry: 'Conduzione completata',
    unsuccessfulCarry: 'Conduzione non completata ',
    carryAndKeyPass: 'Conduzione & Passaggio Chiave',
    carryAndAssist: 'Conduzione & Assist',
    carryAndShot: 'Conduzione & Shot',
    ballProgressionAndPass: 'Progressione Palla & Passaggio',
    ballProgression: 'Progressione Palla',
    ballProgressionAndKeyPass: 'Progressioni Palla & Passaggio Chiave',
    ballProgressionAndAssist: 'Progressione Palla & Assist',
    ballProgressionAndShot: 'Progressione Palla & Tiro',
    ballProgressionAndGoal: 'Progressione Palla & Gol',
    pass: 'Passaggio',
    carryAndPass: 'Conduzione & Passaggio',
    carryAndGoal: 'Conduzione & Gol',
    totalTouches: 'Tocchi Totali',
    totalPasses: 'Passaggi Totali',
    successful: 'Con successo',
    unsuccessful: 'Senza successo',
    tacklePossessionLost: 'Riuscito - Possesso perso',
    gamesSelected: '{count} partite selezionate',
    allGamesOfSeason: 'Tutte le partite della stagione',
    allGamesOfSeasons: 'Tutte le partite delle stagioni',
    allEvents: 'Tutti gli eventi',
    eventTypesCount: '{count} tipi di eventi',
    totalEvents: 'Eventi totali',
    zoneDominanceNote: 'I tocchi mostrati da ciascuna squadra in ciascuna zona rappresentano solo i tocchi riusciti',
    selectedEvents: 'Eventi selezionati'
  },
  event: {
    Pass: 'Passaggio',
    TakeOn: 'Dribbling',
    Takeon: 'Dribbling',
    Foul: 'Punizione',
    Error: 'Errore',
    Tackle: 'Contrasto',
    Interception: 'Intercetto',
    Clearance: 'Disimpegno',
    MissedShot: 'Tiro Sbagliato',
    ShotOnPost: 'Tiro Sul Palo',
    SavedShot: 'Tiro Parato',
    Goal: 'Gol',
    Aerial: 'Duello Aereo',
    BallRecovery: 'Recupero del Pallone',
    Dispossessed: 'Palla persa',
    ChanceMissed: 'Occasione Sbagliata',
    BallTouch: 'Tocco di Palla',
    BlockedPass: 'Passaggio Intercettato',
    Challenge: 'Sfida',
    lossPossession: 'Perdita del possesso',
    OffsidePass: 'Passaggio in fuorigioco',
    groundDuelsLost: 'Duelli a terra persi',
    'Ball touch': 'Tocco palla',
    Smother: 'Smother',
    'Keeper pickup': 'Keeper pickup',
    'Good skill': 'Good skill',
    Punch: 'Punch',
    'Saved shot': 'Tiro Parato',
    'Shot on post': 'Tiro sul palo',
    'Missed shot': 'Tiro sbagliato',
    Save: 'Parata',
    'Take on': 'dribbling',
    'Offside pass': 'Passaggio in Fuorigioco',
    Claim: 'Presa',
    'Blocked pass': 'Passaggio Intercettato',
    KeeperPickup: 'Raccolta del custode',
    'Ball recovery': 'Recupero del Pallone',
    'Ball Recovery': 'Recupero del Pallone',
    'Chance missed': 'Occasione Sbagliata',
    'Loss possession': 'Perdita del possesso',
    Carries: 'Conduzione',
    BallProgression: 'Progressione della palla',
    MissedChance: 'Occasione persa',
    Event: 'Evento',
    Shot: 'Tiro',
    Assist: 'Assist',
    KeyPass: 'Passaggio chiave',
    'Foul taken': 'Fallo ricevuto'
  },
  leagueTab: {
    leagueTable: 'Classifica',
    matchdays: 'Giorni Partita',
    playerInsights: 'Approfondimenti Giocatore',
    onlyLocalPlayers: 'Solo giocatori locali',
    teamInsights: 'Approfondimenti Squadra',
    head2head: 'Testa a Testa',
    addNewChart: 'Aggiungi un nuovo grafico',
    rounds: {
      16: 'Ottavi di Finale',
      32: 'Sedicesimi',
      W: 'Campione',
      F: 'Finale',
      SF: 'Semifinale',
      QF: 'Quarti di Finale',
      GR: 'Fase a Gruppi',
      '4R': 'Quarto Turno',
      '3R': 'Terzo Turno',
      '2R': 'Secondo Turno',
      '1R': 'Primo Turno',
      PR: 'Turno Preliminare',
      QPO1: 'Retrocessione Competizione Minore',
      QPO2: 'Preliminare Qualificazione Ottavi di Finale',
      QPO3: 'Sedicesimi di qualificazione'
    },
    positions: 'Posizione',
    prediction: 'Predizioni',
    predicted: 'Predizione',
    groups: 'Grupos',
    ranking: 'Ranking',
    numberOfTeams: 'Numero di squadre',
    statsWithMinimum: {
      message: 'Mostrando solo i giocatori con più di {0} {1} nella stagione selezionata',
      dribblesTotal90: 'dribbling ogni 90 minuti',
      crosses90: 'cross ogni 90 minuti',
      tacklesAttempted90: 'contrasti tentati ogni 90 minuti',
      aerialsTotal90: 'duelli aerei ogni 90 minuti'
    },
    numberOfLeagues: 'Numero di leghe',
    position: {
      titleWinner: 'Vincitore del titolo',
      championsLeague: 'Lega dei Campioni',
      qualifierChampionsLeague: 'Qualificazione alla Champions League',
      europeLeague: 'Lega Europa',
      qualifierEuropeLeague: 'Qualificazioni all\'Europa League',
      conferenceLeague: 'Lega delle conferenze',
      qualifierConferenceLeague: 'Lega di conferenza di qualificazione',
      midTable: 'A metà classifica',
      relegation: 'Retrocessione',
      promotion: 'Promozione',
      relegationPlayoff: 'Playoff retrocessione',
      promotionPlayoff: 'Playoff Promozione',
      championshipGroup: 'Gruppo di campionato',
      relegationGroup: 'Gruppo retrocessione',
      championshipPlayoffs: 'Playoff del campionato',
      preChampionshipPlayoffs2: 'Playoff pre-campionato 2',
      preChampionshipPlayoffs3: 'Playoff pre-campionato 3',
      playoffsQualifierBand3: 'Fascia di qualificazione playoff 3',
      continentalGroup: 'Gruppo continentale'
    },
    group: {
      1: 'UN',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'E',
      6: 'F',
      7: 'G',
      8: 'H',
      9: 'IO',
      10: 'J',
      11: 'K',
      12: 'l'
    }
  },
  similarity: {
    subtitle: 'Trova giocatori simili',
    searchBarPlaceholder: 'Cerca e seleziona un giocatore per trovarne di simili',
    radarFilters: 'Filtri Radar',
    similarityFilters: 'Filtro similarità',
    playersFilters: 'Filtri Giocatori',
    similarPlayers: 'Giocatori Simili',
    seasonWarning: 'Solo le stagioni disponibili sullo strumento Similarity in cui ha giocato più di 450 minuti'
  },
  squadBuilder: {
    subtitle: 'Disegna il tuo undici',
    playerSelector: 'Seleziona giocatore',
    loadSquad: 'Carica squadra',
    yearsOld: 'anni.',
    playersPerPosition: 'Giocatori per posizione',
    custom: 'Custom',
    removeSquad: 'Cancellare la squadra',
    removeSquadMessage: 'Sei sicuro di voler cancellare la squadra?',
    deleteSquadSuccess: 'La squadra è stata cancellata con successo',
    playerDetails: 'Visibilità dei dettagli',
    ageFormat: 'Formato dell\'età',
    mainPlayer: 'Giocatore principale',
    showDetails: 'Mostra dettagli',
    all: 'Tutti',
    squadPosition: 'Posizione nella rosa',
    noData: 'Nessun dato. Inizia aggiungendo alcuni giocatori in campo!'
  },
  tours: {
    buttons: {
      dontShowAgain: 'Non presentarti più',
      skipTour: 'Salta la visita guidata',
      previous: 'Precedente',
      next: 'Successivo',
      finish: 'Termina'
    },
    playerRadar: {
      step1: {
        title: 'SCHEDA PERSONALE',
        message: 'Controlla i dati di base del giocatore: età, altezza o scadenza del contratto'
      },
      step2: {
        title: 'FILTRO GBE',
        message: 'Funzionalità che permette di determinare se un giocatore ha abbastanza punti GBE per giocare nel Regno Unito'
      },
      step3: {
        title: 'DISPONIBILITÀ',
        message: 'Controlla la percentuale dei minuti disponibili e dei minuti giocati'
      },
      step4: {
        title: 'POSIZIONI',
        message: 'Scopri in quali posizioni ha giocato il giocatore e quale percentuale di minuti ha giocato in ciascuna posizione'
      },
      step5: {
        title: 'TIPI DI VISUALIZZAZIONE',
        message: 'Misura le prestazioni del giocatore con 4 diverse visualizzazioni, Radar, Polar, Lollipop e Testo, e lo confronta con gli altri della propria posizione'
      },
      step6: {
        title: 'RADAR',
        message: 'Riflette visivamente la performance del giocatore. Il grafico è interattivo, passando il mouse su ogni metrica si potrà ottenerne la definizione'
      },
      step7: {
        title: 'SELEZIONE STAGIONE',
        message: 'Seleziona o aggiungi stagioni per misurare le prestazioni'
      },
      step8: {
        title: 'SELEZIONE RADAR PERSONALIZZATO',
        message: 'Utilizza i radar personalizzati creati per misurare il giocatore con metriche diverse dal radar standard'
      },
      step9: {
        title: 'SELEZIONE DELLE POSIZIONE GIOCATE',
        message: 'Seleziona e deseleziona le diverse posizioni per misurare il giocatore nella posizione desiderata'
      },
      step10: {
        title: 'SELEZIONE MINIMO E MASSIMO',
        message: 'Misura il giocatore con i valori minimi e massimi della sua stagione, dei top cinque campionati o della stagione predeterminata dell\' utente'
      },
      step11: {
        title: 'CONFRONTI',
        message: 'Confronta il giocatore con le sue prestazioni precedenti, con altri giocatori nella sua posizione, con la media della posizione'
      },
      step12: {
        title: 'FORMATI DI DOWNLOAD DELLE IMMAGINI',
        message: 'Sono disponibili tre formati di download: png, svg e embed'
      }
    },
    playerRanking: {
      step1: {
        title: 'STAGIONE, RADAR E POSIZIONE',
        message: 'Seleziona la stagione, il radar e la posizione con cui confrontare il giocatore'
      },
      step2: {
        title: 'FILTRI DI BASE',
        message: 'Filtra le caratteristiche dei giocatori per età, minuti e altezza'
      },
      step3: {
        title: 'EVIDENZIA ED ESCLUDI',
        message: 'Evidenzia i cerchi (giocatori) desiderati ed escludi squadre dalla visualizzazione'
      },
      step4: {
        title: 'FILTRA PER SITUAZIONE DI GIOCO',
        message: 'Seleziona le statistiche per gruppo: associazione, difesa, passaggi, controllo palla, ecc'
      },
      step5: {
        title: 'FORMATI DI DOWNLOAD DELLE IMMAGINI',
        message: 'Sono disponibili tre formati di download: png, svg e embed'
      }
    },
    playerFinishing: {
      step1: {
        title: 'SELEZIONA VISUALIZZAZIONE',
        message: 'È possibile visualizzare la mappa dei tiri in veduta aerea, con vista della porta e in una tabella di distribuzione'
      },
      step2: {
        title: 'SELEZIONE STAGIONE',
        message: 'Aggiungi più stagioni per misurare l’efficacia del tiro del giocatore'
      },
      step3: {
        title: 'POSIZIONE DEL TIRO',
        message: 'Seleziona la possibilità di visualizzare la posizione esatta del colpo (cerchi) o per zone dell\'area e del campo (aree)'
      },
      step4: {
        title: 'xG IN PORTA',
        message: 'Seleziona le caselle xG in Porta e xG FInalizzazione per vedere il valore aggiunto del giocatore dopo il tiro'
      },
      step5: {
        title: 'TIPO DI TIRO',
        message: 'Filtra per tipo di tiro, strategia, area o parte del corpo'
      },
      step6: {
        title: 'FILTRA MINUTI',
        message: 'Barra dei minuti per selezionare i tiri e i gol segnati per periodi specifici di una partita'
      },
      step7: {
        title: 'FORMATI DI DOWNLOAD DELLE IMMAGINI',
        message: 'Sono disponibili tre formati di download: png, svg e embed'
      },
      step8: {
        title: 'MAPPA TIRI',
        message: 'La mappa è interattiva. Controlla ogni cerchio con il mouse per conoscere l\'xG di ogni tiro'
      }
    },
    playerKeyPass: {
      step1: {
        title: 'SELEZIONE STAGIONE',
        message: 'Aggiungi più stagioni per misurare l’efficacia dei passaggi chiave del giocatore'
      },
      step2: {
        title: 'POSIZIONE DEL PASSAGGIO CHIAVE',
        message: 'Seleziona la possibilità di visualizzare la posizione esatta del passaggio chiave (cerchio) o per zone dell\'area e del campo (aree)'
      },
      step3: {
        title: 'TIPO DI TIRO DOPO IL PASSAGGIO CHIAVE',
        message: 'Filtra per tipo di tiro, strategia, area o parte del corpo dopo il passaggio chiave'
      },
      step4: {
        title: 'FILTRA MINUTI',
        message: 'Barra dei minuti per selezionare i passaggi chiave per periodi specifici di una partita'
      },
      step5: {
        title: 'FORMATI DI DOWNLOAD DELLE IMMAGINI',
        message: 'Sono disponibili tre formati di download: png, svg e embed'
      },
      step6: {
        title: 'MAPPA PASSAGGI CHIAVE',
        message: 'La mappa è interattiva. Controlla ogni cerchio con il mouse per conoscere l\'xA di ogni passaggio'
      }
    },
    playerThreat: {
      step1: {
        title: 'SELEZIONE STAGIONE',
        message: 'Aggiungi più stagioni per misurare il pericolo del giocatore'
      },
      step2: {
        title: 'POSIZIONE DEL PERICOLO',
        message: 'Seleziona la possibilità di visualizzare le azioni di pericolo'
      },
      step3: {
        title: 'AZIONE E FINALIZZAZIONE',
        message: 'Seleziona e deseleziona a seconda del tipo di azione e finalizzazione che si desidera visualizzare sulla mappa'
      },
      step4: {
        title: 'MINUTI E PERICOLO',
        message: 'Filtra per periodo di tempo, per minuti e per valore di pericolo delle azioni'
      },
      step5: {
        title: 'FORMATI DI DOWNLOAD DELLE IMMAGINI',
        message: 'Sono disponibili tre formati di download: png, svg e embed'
      },
      step6: {
        title: 'MAPPA DI PERICOLO',
        message: 'La mappa è interattiva. Controlla ogni cerchio con il mouse per vedere il pericolo generato xT in ogni partita'
      }
    },
    playerTouches: {
      step1: {
        title: 'SELEZIONE PARTITE E EVENTI',
        message: 'Seleziona le partite e gli eventi che si desidera visualizzare sulla mappa'
      },
      step2: {
        title: 'TIPO DI EVENTO',
        message: 'Seleziona e deseleziona la natura difensiva o offensiva dell\'evento del giocatore durante la partita'
      },
      step3: {
        title: 'FILTRO DI VISUALIZZAZIONE',
        message: 'Filtra la mappa per azioni di base, mappa di calore, cerchi o aree'
      },
      step4: {
        title: 'FORMATI DI DOWNLOAD DELLE IMMAGINI',
        message: 'Sono disponibili tre formati di download: png, svg e embed'
      },
      step5: {
        title: 'MAPPA TOCCHI',
        message: 'La mappa è interattiva. Cliccando ogni evento è possibile consultarlo'
      }
    },
    playerAllGames: {
      step1: {
        title: 'DISPONIBILITÀ',
        message: 'Verifica la disponibilità e i minuti giocati partita per partita'
      },
      step2: {
        title: 'POSIZIONI',
        message: 'Verifica le posizioni in cui ha giocato in ogni partita'
      }
    },
    playerInjuries: {
      step1: {
        title: 'CARRIERA E DURATA',
        message: 'Controlla gli infortuni dell’ultimo anno o dell\'intera carriera e il periodoin base alla loro durata'
      },
      step2: {
        title: 'INFORTUNI PER CLUB',
        message: 'Consulta gli infortuni divisi per stagione e/o club nella sua carriera'
      }
    },
    playerInfo: {
      step1: {
        title: 'CRONOLOGIA CARRIERA E TRASFERIMENTI',
        message: 'È possibile controllare i minuti, la posizione o la disponibilità del giocatore con il suo club, la sua nazionale e i suoi trasferimenti nel corso della carriera'
      }
    },
    teamOverview: {
      step1: {
        title: 'SCHEDA SQUADRA',
        message: 'Consultare i dati di base della squadra: età media, formazione di base, ELO o bilancio dei trasferimenti.'
      },
      step2: {
        title: 'STATISTICHE DI BASE',
        message: 'Consultare possesso, xG, tiri, PPDA o Verticalità'
      },
      step3: {
        title: 'RADAR E STAGIONE',
        message: 'Selezionare il radar, la stagione e le partite in casa o in trasferta per misurare le prestazioni della squadra.'
      },
      step4: {
        title: 'FILTRARE PER ALLENATORE E PARTITE',
        message: 'Selezionare le prestazioni per fase per ogni allenatore'
      },
      step5: {
        title: 'RADAR DI PERFORMANCE',
        message: 'Il pannello è interattivo: è possibile passare il mouse su ogni metrica e ottenerne la definizione'
      },
      step6: {
        title: 'FORMATI DI DOWNLOAD DELLE IMMAGINI',
        message: 'Sono disponibili due formati per il download: png e svg'
      },
      step7: {
        title: 'CALENDARIO',
        message: 'Visualizza il calendario delle partite della squadra'
      },
      step8: {
        title: 'MIGLIORI GIOCATORI PER METRICA',
        message: 'In questo pannello è possibile selezionare diverse metriche e vedere quali sono i giocatori più importanti'
      },
      step9: {
        title: 'PROSSIMA PARTITA E INFORTUNI',
        message: 'Controllare il prossimo avversario e i giocatori infortunati e sospesi della squadra'
      },
      step10: {
        title: 'GRAFICI E TENDENZE',
        message: 'Visualizzare diversi grafici per le ultime 10 o 20 partite'
      }
    },
    teamRoster: {
      step1: {
        title: 'TIPO DI VISTA',
        message: 'Visualizzate la squadra in 6 diverse categorie: per posizione, fine contratto, età, disponibilità, profilo d\'età e campo di gioco'
      }
    },
    teamLoans: {
      step1: {
        title: 'GIOCATORI DI PRESTITO',
        message: 'Consultare i giocatori ceduti in prestito ad altre squadre e la posizione in cui giocano'
      }
    },
    teamBeeswarm: {
      step1: {
        title: 'STAGIONE E SQUADRA',
        message: 'Filtrare per stagione, squadra radar e confrontare con i campionati di vostra scelta'
      },
      step2: {
        title: 'PERFORMANCE PER METRICHE',
        message: 'Vedere la posizione della squadra in ciascuna metrica rispetto a tutte le squadre dei campionati precedentemente selezionati'
      },
      step3: {
        title: 'FORMATI DI DOWNLOAD DELLE IMMAGINI',
        message: 'Sono disponibili tre formati di download: png, svg e embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: 'SELEZIONE DELLA STAGIONE',
        message: 'Aggiungere le stagioni per misurare l\'efficienza di tiro'
      },
      step2: {
        title: 'FINITURA PROPRIA O DELL\'AVVERSARIO',
        message: 'Scegliere se visualizzare la mappa di completamento della squadra o di tutti gli avversari.'
      },
      step3: {
        title: 'POSIZIONAMENTO DEI COLPIT',
        message: 'Selezionare la modalità di visualizzazione dei tiri della squadra, per cerchi o per zone (riquadri)'
      },
      step4: {
        title: 'TIPO DI TIRO',
        message: 'Filtrare in base al tipo di scatto, alla strategia, all\'area o alla parte del corpo'
      },
      step5: {
        title: 'FILTRO MINUTI',
        message: 'Barra dei minuti per selezionare i tiri e i gol segnati in determinati periodi della partita'
      },
      step6: {
        title: 'FORMATI DI DOWNLOAD DELLE IMMAGINI',
        message: 'Sono disponibili tre formati di download: png, svg e embed'
      },
      step7: {
        title: 'MAPPA DEI COLPI',
        message: 'La mappa è interattiva. Controllare ogni cerchio con il mouse per scoprire l\'xG di ogni tiro'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: 'SELEZIONE DELLA STAGIONE',
        message: 'Aggiungere le stagioni per misurare l\'efficienza di tiro'
      },
      step2: {
        title: 'PASSAGGI CHIAVE PROPRI O DI RIVALI',
        message: 'Scegliere se si vuole vedere una mappa dei passaggi chiave della squadra o di tutti i suoi avversari'
      },
      step3: {
        title: 'POSIZIONE DEL KEY PASS',
        message: 'Selezionare se si desidera visualizzare la posizione esatta del passaggio chiave (cerchio) o per area e campo (caselle)'
      },
      step4: {
        title: 'TIPO DI FINITURA DOPO IL PASSAGGIO',
        message: 'Filtrare in base al tipo di tiro, alla strategia, all\'area o alla parte del corpo effettuata dopo il passaggio chiave'
      },
      step5: {
        title: 'FILTRO MINUTI',
        message: 'Barra dei minuti per selezionare i tiri e i gol segnati in determinati periodi della partita'
      },
      step6: {
        title: 'FORMATI DI DOWNLOAD DELLE IMMAGINI',
        message: 'Sono disponibili tre formati di download: png, svg e embed'
      },
      step7: {
        title: 'MAPPA DEI COLPI',
        message: 'La mappa è interattiva. Consultate ogni cerchio con il mouse per conoscere la xA di ogni passaggio'
      }
    },
    teamLatestGames: {
      step1: {
        title: 'GLI ULTIMI GIOCHI',
        message: 'Consultare i risultati, il possesso, gli xG e la percentuale di vittorie di tutte le partite della squadra'
      }
    },
    teamTransfers: {
      step1: {
        title: 'ARRIVI',
        message: 'Consultare tutti gli arrivi (acquisti + trasferimenti) per anno solare'
      },
      step2: {
        title: 'PARTENZE',
        message: 'Consultare tutte le partenze (vendite + trasferimenti) per anno solare'
      }
    },
    teamAnalysis: {
      step1: {
        title: 'TENDENZE',
        message: 'Interrogare lo stato di forma della squadra attraverso strisce, vittorie, clean sheet, rimonte, periodi con gol o tipologie di gol'
      },
      step2: {
        title: 'DA CALCIO PIAZZATO',
        message: 'Confronta le prestazioni della squadra tra i calci piazzati e quelli aperti e ottieni una panoramica dettagliata dei diversi tipi di calci piazzati'
      },
      step3: {
        title: 'SOSTITUZIONI',
        message: 'Vedere quando la squadra effettua le sostituzioni e quali sono i giocatori che vengono sostituiti di più.'
      },
      step4: {
        title: 'COLLEGAMENTI',
        message: 'Consulta i collegamenti più comuni tra i giocatori. Filtrare per stagione e tipo di gioco'
      },
      step5: {
        title: 'ZONE DI ATTACCO',
        message: 'Scoprire le zone d\'attacco della squadra e filtrare per stagione o tipo di attacco'
      },
      step6: {
        title: 'FORMAZIONI',
        message: 'Controllare le formazioni più utilizzate e la loro percentuale di vittorie, pareggi e sconfitte con ognuna di esse'
      },
      step7: {
        title: 'ZONE DI TIRO',
        message: 'Filtro per stagione, squadra o avversario, modalità di visualizzazione della mappa, tipi di tiro o minuti'
      },
      step8: {
        title: 'INCROCI',
        message: 'Interrogazione e filtro in base alla stagione, al tipo di visualizzazione, al successo o al fallimento, alla posizione di partenza e di arrivo o ai calci d\'angolo.'
      },
      step9: {
        title: 'GIOCATORI',
        message: 'Filtrare per stagione, tipo di visualizzazione, successo o non successo, da dove iniziano e finiscono o inclusi i calci d\'angolo'
      }
    },
    teamOnOff: {
      step1: {
        title: 'STAGIONI E PARTITE',
        message: 'Filtrare per stagione, partite o per partite in casa o in trasferta'
      },
      step2: {
        title: 'GIOCATORI',
        message: 'Visualizzare le prestazioni di tutti i giocatori della squadra attraverso innumerevoli metriche'
      }
    }
  },
  alerts: {
    numPlayers: 'Numero di giocatori',
    newPlayersLastWeek: 'Nuovi giocatori della scorsa settimana',
    subtitle: 'Ricevi avvisi quando nuovi giocatori soddisfano i tuoi criteri di ricerca',
    generalSubtitle: 'Avvisi su nuovi giocatori in base ai vostri criteri e notizie sui vostri giocatori preferiti',
    subtitlePlayer: 'Ricevi avvisi quando abbiamo notizie sui tuoi giocatori preferiti',
    subtitleSearch: 'Ricevi avvisi quando nuovi giocatori corrispondono ai tuoi criteri di ricerca',
    favorite: 'Preferito',
    newEventCalendar: 'Nuovo Evento',
    updatedEventCalendar: 'Evento Aggiornato',
    newShareFrom: 'Nuova Condivisione da',
    injuryAlert: 'Allerta Infortunio',
    contractAlert: 'Allerta Contratto',
    teamAlert: 'Allerta Firma',
    marketValueAlert: 'Allerta Valore di Mercato',
    gameAlert: 'Allerta Partita Giocata'
  },
  videoEvents: {
    highlights: 'Highlights',
    fullGame: 'Partita intera',
    autoplay: 'Autoplay',
    searchBarPlaceholder: 'Cerca un giocatore, una partita o una squadra...',
    subtitle: 'Analizza gli eventi tramite video',
    successful: 'con successo',
    unsuccessful: 'Non riuscito',
    playing: 'Gioco',
    games: 'Partite',
    moreFilters: 'Più filtri...',
    startArea: 'Area di partenza',
    endArea: 'Area finale',
    select: 'Seleziona',
    selectLastXGames: 'Selezione le ultime {0} partite',
    advancedFilters: 'Filtri avanzati',
    freeKicks: 'Calci di punizione',
    cornerKicks: 'Calci d\'angolo',
    allShots: 'Tutti i tiri',
    generateZip: 'Generate ZIP',
    zippedModalMessage: 'ZIP process has been started, could take some minutes. You would receive an email when is finished',
    clickToSeeVideo: 'Click to see video'
  },
  videoUpload: {
    subtitle: 'Carica il video e crea un nuova partita',
    uploadVideo: 'Carica video',
    selectPeriod: 'Selziona periodo',
    gameData: 'Dati di gioco',
    venue: 'Sede',
    matchType: 'Tipo di partita',
    matchGroup: 'Gruppo di Partite',
    roundType: 'Tipo di incontro',
    roundNumber: 'Numero dell’incontro',
    offsetFh: 'Compensazione primo tempo',
    offsetSh: 'Compensazione secondo tempo',
    offsetFhOT: 'Compensazione primo tempo supplementare',
    offsetShOT: 'Compensazione secondo tempo supplementare',
    homeLineup: 'Formazione di casa',
    awayLineup: 'Formazione in trasferta',
    existingPlayer: 'Giocatore esistente',
    newPlayer: 'Nuovo giocatore',
    startingTeam: 'Titolari',
    saveAndUpload: 'Salva e carica',
    existingGame: 'Game exists already',
    sendToKora: 'Send',
    invalidForm: 'Invalid form',
    warningModalTitle: 'Anomalies have been detected',
    noScoreSheetWarning: 'No scoresheet attached',
    onlyOnePartUploadedWarning: 'Only one half time attached',
    continueQuestion: 'continue?',
    slaLimit: 'Hai caricato {0} giochi con {1}. Il tuo limite è {2}',
    requestedGames: 'Partite richieste',
    limitClose: 'Sono rimaste solo {0} partite da richiedere',
    limitReached: 'Hai raggiunto il limite di caricamento dei video. Caricare altre partite potrebbe comportare costi aggiuntivi.',
    seasonFinishedWarning: 'Questo creerà una partita in una stagione già terminata. Si prega di verificare che sia corretto.',
    teamCountryWarning: 'Questa squadra proviene da un paese diverso rispetto a quello della lega scelta. Si prega di verificare che sia corretto.',
    uploading: 'Caricamento',
    doNotNavigateAway: 'Si prega di non chiudere questa scheda, aggiornare la pagina o allontanarsi mentre il caricamento è in corso.',
    severalMinutes: 'Questo processo potrebbe richiedere diversi minuti.'
  },
  videoPlaylists: {
    subtitle: 'Collections of video highlights filters',
    savePlaylist: 'Save Playlist',
    seeAllPlaylists: 'Vedi tutte le liste'
  },
  videoHighlights: {
    recap: 'Ricapitolare',
    homeCondensed: 'Partita condensata in casa',
    awayCondensed: 'Partita condensata in trasferta',
    selectedActions: 'Azioni selezionate',
    noActions: 'Nessuna azione corrisponde ai criteri di filtro specificati',
    noGames: 'Nessuna partita è ancora stata caricata',
    attackingActions: 'Azioni offensive',
    defensiveActions: 'Azioni difensive',
    groundDuels: 'Duelli a terra',
    penaltiesProvoked: 'Rigori provocati',
    goalkeeperActions: 'Azioni del Portiere',
    addSomeGames: 'Inizia aggiungendo alcune partite!',
    goToVideoUploadTool: 'Vai a Caricare Video',
    ballInPlay: 'Palla in gioco',
    filterSeasons: 'Filtra Stagioni',
    streaming: 'Streaming',
    clips: 'Clip',
    qualifiers: {
      Pass: 'Passaggio',
      Save: 'Parata',
      'Saved Shot': 'Tiro Parato',
      Shot: 'Tiro',
      Goal: 'Gol',
      'Missed Shot': 'Tiro Fuori',
      'Shot on Post': 'Tiro sul Palo',
      Error: 'Errore',
      Clearance: 'Sgombero',
      Aerial: 'Duello Aereo',
      Challenge: 'Duello Perso',
      Dispossessed: 'Palla Persa',
      Foul: 'Fallo',
      Card: 'Cartellino',
      'Offside Pass': 'Passaggio in Fuorigioco',
      Claim: 'Presa',
      'Keeper Pickup': 'Presa a Terra',
      'Ball Touch': 'Tocco di Palla',
      Dribble: 'Dribbling',
      Interception: 'Intercetto',
      Tackle: 'Contrasto',
      'Ball Recovery': 'Recupero Palla',
      Takeon: 'Dribbling'
    },
    qualifierIds: {
      1: 'Passaggio lungo',
      2: 'Cross',
      5: 'Calcio di punizione diretto',
      6: 'Calcio d\'angolo',
      9: 'Rigore',
      15: 'Di testa',
      20: 'Piede destro',
      21: 'Altra parte del corpo',
      22: 'Gioco aperto',
      23: 'Contropiede',
      24: 'Palla inattiva',
      25: 'Da calcio d\'angolo',
      26: 'Calcio di punizione',
      28: 'Autogol',
      29: 'Assistito',
      31: 'Cartellino giallo',
      32: 'Secondo cartellino giallo',
      33: 'Cartellino rosso',
      72: 'Piede sinistro',
      73: 'Sinistra',
      82: 'Tiro parato (senza portiere)',
      94: 'Blocco difensivo',
      123: 'Rimessa del portiere',
      124: 'Rinvio dal fondo',
      160: 'Rimessa laterale',
      170: 'Che porta al gol',
      173: 'Sgombero sicuro',
      174: 'Sgombero pericoloso',
      177: 'Raccolto',
      178: 'In piedi',
      179: 'In tuffo',
      182: 'Mani',
      183: 'Piedi',
      185: 'Cross bloccato',
      210: 'Assist',
      215: 'Azione individuale',
      279: 'Calcio d\'inizio',
      285: 'Difensivo',
      286: 'Offensivo'
    },
    areas: {
      goalArea: 'Area di Porta',
      boxLeft: 'Area Sinistra',
      boxCenter: 'Area Centrale',
      boxRight: 'Area Destra',
      outBoxDeepLeft: 'Fuori Area Profonda Sinistra',
      outBoxDeepRight: 'Fuori Area Profonda Destra',
      outBoxLeft: 'Fuori Area Sinistra',
      outBoxCentreLeft: 'Fuori Area Centro-Sinistra',
      outBoxCentre: 'Fuori Area Centrale',
      outBoxCentreRight: 'Fuori Area Centro-Destra',
      outBoxRight: 'Fuori Area Destra',
      midfieldLeft35: 'Metà Campo Sinistra',
      midfieldCentreLeft35: 'Metà Campo Centro-Sinistra',
      midfieldCentre35: 'Metà Campo Centrale',
      midfieldCentreRight35: 'Metà Campo Centro-Destra',
      midfieldRight35: 'Metà Campo Destra',
      ownGoalArea: 'Propria Area di Porta',
      ownBoxLeft: 'Propria Area Sinistra',
      ownBoxCenter: 'Propria Area Centrale',
      ownBoxRight: 'Propria Area Destra',
      ownFieldOutOfBoxDeepLeft: 'Proprio Campo Fuori Area Profonda Sinistra',
      ownFieldOutOfBoxDeepRight: 'Proprio Campo Fuori Area Profonda Destra',
      ownFieldOutOfBoxLeft: 'Proprio Campo Fuori Area Sinistra',
      ownFieldOutOfBoxCentreLeft: 'Proprio Campo Fuori Area Centro-Sinistra',
      ownFieldOutOfBoxCentre: 'Proprio Campo Fuori Area Centrale',
      ownFieldOutOfBoxCentreRight: 'Proprio Campo Fuori Area Centro-Destra',
      ownFieldOutOfBoxRight: 'Proprio Campo Fuori Area Destra',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: 'Successo',
      fail: 'Fallimento',
      possessionWon: 'Possesso Vinto',
      possessionNotWon: 'Possesso Non Vinto',
      received: 'Ricevuto',
      provoked: 'Provocato'
    },
    homePlayerHighlights: 'Highlights dei giocatori di casa',
    awayPlayerHighlights: 'Highlights dei giocatori in trasferta'
  },
  share: {
    shareTo: 'Send to',
    viaApp: 'App (Driblab Message)',
    viaEmail: 'Email',
    description: 'Description',
    titleTab: 'Shares',
    toMe: 'Ricevuto',
    fromMe: 'Inviato',
    typeInternal: 'Internal',
    typeExternal: 'External',
    title: 'Condivisi',
    subtitle: 'Panoramica degli elementi nella tua lista di condivisione',
    selectUser: 'Seleziona l\'utente',
    expired: 'Scaduto',
    limitReached: 'Il collegamento ha raggiunto il limite di utilizzo'
  },
  homeStats: {
    data: 'Dati disponibili',
    players: 'giocatori',
    totalPlayers: 'giocatori totali',
    teams: 'squadre',
    totalTeams: 'totale squadre',
    leagues: 'campionati',
    totalLeagues: 'campionati totali',
    seasons: 'stagioni',
    totalSeasons: 'stagioni totali',
    games: 'giochi',
    totalGames: 'giochi totali'
  },
  scoutingCalendar: {
    subtitle: 'Crea e organizza le tue attività di scouting',
    myCalendars: 'Calendario privato',
    publicCalendars: 'Calendari pubblici',
    otherCalendars: 'Altri calendari',
    calendarSettings: 'Impostazioni del calendario',
    moreInfo: 'Più informazioni',
    individualScouting: 'Scouting Individuale',
    matchScouting: 'Scouting di Partita',
    calendarView: {
      type: 'Tipo di calendario',
      month: 'Mese',
      week: 'Settimana',
      day: 'Giorno'
    },
    weekView: {
      type: 'Tipo di settimana',
      monSun: 'Lunedì - Domenica',
      sunSat: 'Domenica - Sabato',
      monFri: 'Lunedì - Venerdì'
    },
    tasks: {
      addNew: 'Aggiungi nuova attività',
      myTasks: 'Le mie attività',
      filterTasks: 'Filtra attività',
      sharedWithMe: 'Condiviso con me',
      createTask: 'Crea attività',
      newTask: 'Nuova attività',
      taskName: 'Nome dell\'attività',
      allDay: 'Tutto il giorno',
      startDate: 'Data di inizio',
      endDate: 'Data di fine',
      startHour: 'Ora di inizio',
      endHour: 'Ora di fine',
      assignedTo: 'Assegnato a',
      assignedToMe: 'Assegnato a me',
      color: 'Colore',
      scoutingType: 'Tipo di scouting',
      taskLocation: 'Ubicazione dell\'attività',
      selectLeague: 'Seleziona lega',
      selectMatch: 'Seleziona partita',
      useMatchdate: 'Usa la data della partita come data',
      stadium: 'Stadio',
      travel: 'Viaggio',
      hotel: 'Hotel',
      tickets: 'Biglietti',
      taskNotes: 'Digita note descrittive o commenti relativi all\'attività',
      states: {
        toDo: 'Da fare',
        inProgress: 'In corso',
        done: 'Completato'
      },
      type: {
        player: 'Valutazione del giocatore',
        team: 'Valutazione della squadra',
        other: 'Altro'
      },
      location: {
        stadium: 'In stadio',
        video: 'Video'
      },
      accommodation: {
        accommodationDetails: 'Dettagli dell\'alloggio',
        ownArrangement: 'Accordo personale',
        required: 'Richiesto',
        notRequired: 'Non richiesto',
        booked: 'Prenotato'
      },
      assignToMe: 'Assegnati a me',
      addOther: 'Aggiungi altro',
      deleteTask: 'Elimina attività',
      deleteTaskMessage: 'L\'attività verrà rimossa, sei sicuro?',
      cancelUpdate: 'Annulla aggiornamento',
      cancelUpdateMessage: 'Le modifiche non verranno salvate, sei sicuro?',
      selectGame: 'Per favore, seleziona una partita per aggiungere file',
      noData: 'Nessun dato. Inizia aggiungendo alcune attività!',
      widgetSubtitle: 'Controlla le tue prossime attività',
      scoutingDetails: 'Dettagli dello scouting',
      taskDetails: 'Dettagli del compito',
      playerDocuments: 'Documenti del giocatore',
      teamDocuments: 'Documenti della squadra',
      gameDocuments: 'Documenti della partita',
      taskDocuments: 'Documenti del compito',
      task: 'Attività'
    },
    nextGames: 'Prossime partite'
  },
  scoutingTasksBoard: {
    period: {
      week: 'Questa settimana',
      month: 'Questo mese',
      year: 'Quest\'anno'
    },
    noTasks: 'Crea nuove attività o trascinane una qui!',
    goToBoard: 'Andare al board'
  },
  profile: {
    title: 'Profilo',
    subtitle: 'Personalizza i dettagli del tuo account e dell\'abbonamento'
  },
  hub: {
    onlyHub: 'Disponibile solo in Driblab Hub',
    blue: 'blu',
    purple: 'viola',
    orange: 'arancia',
    grey: 'grigio',
    indigo: 'indaco',
    teal: 'verde acqua',
    lightBlue: 'azzurro',
    brown: 'marrone'
  },
  uploadedGames: {
    subtitle: 'All uploaded games',
    timeRequested: 'Time it was requested',
    timeReceived: 'When it was received',
    diffHours: 'Difference in hours',
    collectionCompleted: 'Collection completed',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    goToUploadedGames: 'Vai alle Partite Caricate',
    sla: 'Accordo sul Livello di Servizio',
    matchDate: 'Data della partita',
    rejectedGame: 'Rifiutato',
    reviewed: 'Revisionato',
    requested: 'Richiesto',
    koraStatus: 'Stato Kora',
    aws: 'AWS',
    fullVideo: 'Video completo',
    offset: 'Offset',
    updateFullVideo: 'Aggiornare il video completo?'
  },
  gameMap: {
    title: 'Mappa delle Partite',
    subtitle: 'Esplora le partite dei prossimi giorni',
    warning: 'L\'orario e il luogo potrebbero non essere corretti. Si prega di confermare queste informazioni.',
    taskAdded: 'Compito creato con successo. Controlla il Scouting Calendar.'
  },
  leagueRequestAccess: {
    sendSuccess: 'Notifica inviata con successo',
    notPermissions: 'Non hai il permesso di vedere',
    notPermissionsLeague: 'Non hai il permesso di vedere questa lega',
    notPermissionsGame: 'Non hai il permesso di vedere questa partita',
    requestAccessTo: 'Richiedi accesso a',
    sendRequest: 'Invia Richiesta'
  },
  videoTeams: {
    subtitle: 'Trova le ultime partite etichettate per squadra',
    noGamesUploaded: 'Nessuna partita caricata ancora'
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'Scouting Analisi',
    scoutingAnalyses: 'Scouting Analisi',
    playerScoutingAnalyses: 'Scouting Analisi Giocatore',
    gameScoutingAnalyses: 'Scouting Analisi Partita',
    analyses: 'Analisi',
    addReport: 'Aggiungi un\'analisi',
    technical: 'Tecnico',
    tactical: 'Tattico',
    physical: 'Fisico',
    mental: 'Psicologico',
    technicalNotes: 'Note tecniche',
    tacticalNotes: 'Note tattiche',
    physicalNotes: 'Note fisiche',
    mentalNotes: 'Note sul profilo psicologico',
    conclusion: 'Conclusione',
    charactersMax: 'Massimo 1000 caratteri',
    globalRating: 'Valutazione globale',
    noData: 'Nessun dato. Inizia aggiungendo alcune analisi di scouting!',
    deleteAnalysis: 'Elimina Analisi Scouting',
    deleteAnalysisMessage: 'L\'analisi sarà rimossa permanentemente. Sei sicuro?',
    avgTooltip: 'Media basata sulle valutazioni finali delle analisi visibili a te',
    avgOverallScoreTooltip: 'Media basata sui punteggi generali del giocatore visibili a te',
    scouter: 'Scouter',
    lastEdited: 'Ultima modifica',
    analysisFilters: 'Filtri di Analisi',
    generalFilters: 'Filtri Generali',
    widgetSubtitle: 'Ultime analisi aggiunte',
    addPlayerReport: 'Aggiungere un\'analisi di scouting del giocatore',
    seeReports: 'Vedere i rapporti',
    addGameReport: 'Aggiungi Analisi della Partita',
    keyPlayers: 'Giocatori Chiave',
    formation: 'Formazione',
    inPossession: 'In Possesso',
    notesIP: 'Note in Possesso',
    outOfPossession: 'Senza Possesso',
    notesOP: 'Note senza Possesso',
    transitions: 'Transizioni',
    notesTransitions: 'Note sulle Transizioni',
    notesSP: 'Note sui Calci Piazzati',
    finalRating: 'Valutazione Finale',
    gameNotesPlaceholder: 'Scrivi note descrittive o commenti relativi alla partita',
    avgPotentialTooltip: 'Media basata sul potenziale delle analisi visibili a te',
    potential: 'Potenziale',
    tags: 'Tag',
    tagsPlaceholder: 'Aggiungi alcuni tag',
    tagsHint: 'Digita e premi Invio per aggiungere un tag',
    exampleTags: {
      leadership: 'Direzione',
      resilience: 'Resilienza',
      competitiveMindset: 'Mentalità competitiva',
      calmUnderPressure: 'Calma sotto pressione',
      focus: 'Messa a fuoco',
      discipline: 'Disciplina',
      coachability: 'Coachabilità',
      poorBodyLanguage: 'Linguaggio del corpo inadeguato',
      lowConfidence: 'Bassa fiducia',
      easilyFrustrated: 'Facilmente frustrato'
    },
    totals: 'Totals',
    byPossession: 'By Possession'
  },
  addPlayerForm: {
    noLeague: 'Creare una squadra senza lega può avere un effetto negativo sulla sua indicizzazione e ricerca successiva all\'interno dell\'applicazione.'
  },
  expenses: {
    expense: 'Spesa',
    expenses: 'Spese',
    addExpense: 'Aggiungi spesa',
    transportation: 'Trasporto',
    accommodation: 'Alloggio',
    dietary: 'Dietetico',
    eventTicket: 'Biglietto per l\'evento',
    expenseType: 'Tipo di spesa',
    amount: 'Importo',
    expenseDate: 'Data della spesa',
    expenseFilters: 'Filtri di spesa',
    noData: 'Nessun dato. Inizia aggiungendo alcune spese!',
    deleteExpense: 'Elimina spesa',
    deleteExpenseMessage: 'La spesa verrà rimossa permanentemente. Sei sicuro?'
  },
  disabledTooltips: {
    general: 'Questa funzione è attualmente disabilitata',
    youth: 'Deve essere giovanile per impostare un\'età',
    unit: 'La statistica deve essere Runs, HSR o SPR',
    seasonsWithout60MinsGames: 'Il giocatore non ha giocato più di 60 minuti in una singola partita nella/e stagione/i selezionata/e',
    notEditable: 'Questo non può essere modificato',
    noMatchdate: 'Data della partita non disponibile',
    selectGame: 'Seleziona prima una partita',
    selectPlayer: 'Seleziona prima un giocatore',
    selectTeam: 'Seleziona prima una squadra',
    selectBoxes: 'Deve essere selezionata la visualizzazione delle caselle',
    selectYear: 'Seleziona prima un anno',
    pdScoreNotAvailable: 'Punteggio non disponibile per i giocatori che non hanno raggiunto i 60 minuti di gioco in una partita',
    pdSeasonNotAvailable: 'Dati fisici non disponibili per questa stagione',
    pdGameNotAvailable: 'Dati fisici non disponibili per questa partita'
  },
  leagueTypes: {
    regular: 'Regolare',
    continental: 'Continentale',
    nationalTeam: 'Squadra Nazionale',
    countryCup: 'Coppa Nazionale',
    qualifier: 'Qualificazioni',
    playOff: 'Play-Off',
    regionalLeague: 'Lega Regionale',
    friendly: 'Amichevole',
    nationalFriendly: 'Amichevole Nazionale',
    nationaQualifier: 'Qualificazioni Nazionali'
  },
  playerSides: {
    'Left/Right': 'Sinistra/Destra',
    'Left/Centre/Right': 'Sinistra/Centro/Destra',
    Right: 'Destra',
    Centre: 'Centro',
    'Centre/Right': 'Centro/Destra',
    Left: 'Sinistra',
    'Left/Centre': 'Sinistra/Centro'
  },
  areaSelector: {
    selectAreas: 'Seleziona aree',
    filterAreas: 'Filtra aree'
  },
  spatialCoverage: {
    lastDefenderDist: 'Distanza ultimo difensore',
    defensiveLineDist: 'Distanza della linea difensiva',
    fullBackAvgDist: 'Distanza laterale media',
    offensiveLineDist: 'Distanza della linea offensiva',
    distanceToGoal: 'Distanza dall\'obiettivo',
    avgLineWidth: 'Larg. media linea',
    leagueAvgDistanceToGoal: 'Dist. media lega al goal',
    leagueAvgLineWidth: 'Larg. media linea lega',
    avgShort: 'Media',
    meters: 'metri',
    leagueAvgDist: 'Media dist. lega',
    distance: 'Distanza',
    avgPositionYAxis: 'Media dist. in campo (Y)',
    leagueAvgPositionYAxis: 'Media dist. lega in campo (Y)',
    lbRbDistanceSeparation: 'Distanza LB–RB',
    leagueAvgLbRbDistanceSeparation: 'Media lega distanza LB–RB',
    legendTeam: 'Squadra',
    legendLeagueAvg: 'Media Lega',
    maxLength: 'Lunghezza massima',
    maxWidth: 'Larghezza massima',
    avgBlockDistance: 'Media distanza di blocco'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'Dati intelligenti',
    passesUnderPressureSubtitle: 'Analizza la percentuale di successo dei passaggi effettuati sotto pressione difensiva',
    onBallPressureSubtitle: 'Analizza eventi di pressione difensiva e la loro tasso di successo per zone del campo',
    ballReceiptsInSpaceSubtitle: 'Analizza i passaggi ricevuti nello spazio per zona di campo',
    ballReceipts: 'ricevute',
    totalBallReceipts: 'Total Ricezioni in Spazio',
    totalBallReceiptsCompleted: 'Total Ricezioni in Spazio Completate',
    completed: 'Completate',
    lineBreakingPassesSubtitle: 'Analizza i passaggi che superano le linee e creano vantaggi',
    bypassed: 'Bypassato',
    oppsBypassed: 'Avversari surclassati',
    passer: 'Regista',
    passedTo: 'Passa a',
    receivedFrom: 'Ricevuto da',
    distanceToNearestDefender: 'Distanza al difensore più vicino',
    lineBreaking: 'interruzione di riga {0}',
    keyPass: 'Passachiave',
    receiver: 'Ricevitore',
    dynamicTracking: 'Tracciamento dinamico',
    eventLockTooltip: 'Alcuni giocatori non sono visibili nel gioco',
    bypassedPlayers: '{0} giocatori superati',
    playersCount: '{0} giocatori',
    bothTeams: 'Entrambe le squadre',
    matchesCount: '{0} partite',
    lbpType: {
      F: 'Linea offensiva',
      M: 'Linea di centrocampo',
      B: 'Linea difensiva',
      MF: 'Linee di centrocampo e offensiva',
      BM: 'Linee difensiva e di centrocampo',
      BF: 'Linee difensiva e offensiva',
      BMF: 'Linee difensiva, di centrocampo e offensiva'
    },
    lbpCategory: {
      'G-IN-T': 'Rasoterra dentro (rompe la linea difensiva)',
      'G-IN-NT': 'Rasoterra dentro (non rompe la linea difensiva)',
      'G-OUT-T': 'Rasoterra fuori (rompe la linea difensiva)',
      'G-OUT-NT': 'Rasoterra fuori (non rompe la linea difensiva)',
      'O-IN-T': 'Alto dentro (rompe la linea difensiva)',
      'O-IN-NT': 'Alto dentro (non rompe la linea difensiva)',
      'O-OUT-T': 'Alto fuori (rompe la linea difensiva)',
      'O-OUT-NT': 'Alto fuori (non rompe la linea difensiva)',
      ground: 'Rasoterra',
      over: 'Alto',
      inside: 'Dentro',
      outside: 'Fuori',
      through: 'Rompe la linea difensiva',
      notThrough: 'Non rompe la linea difensiva',
      throughAbbr: 'Rottura def. linea',
      notThroughAbbr: 'Non si rompe definitivamente. linea'
    },
    lbpCategorySplit: {
      G: 'Terra: Il passaggio è stato terra',
      O: 'Vola: Il passaggio è stato volante',
      OUT: 'Esterno: Il passaggio è andato fuori',
      IN: 'Interno: Il passaggio è andato dentro',
      T: 'Rompe la linea difensiva: il passaggio rompe la linea difensiva dall\'interno',
      NT: 'Non rompe la linea difensiva: il passaggio non rompe la linea dall\'interno; la aggira dall\'esterno'
    },
    obrType: {
      OL: 'Sovrapposizione',
      UL: 'Sottosquadra',
      RA: 'Corri avanti',
      RB: 'Corri dietro',
      CR: 'Ricevitore incrociato',
      SP: 'Supporto',
      CS: 'Arresto corto'
    },
    visualization: 'Visualizzazione',
    points: 'Circoli',
    zones: 'Mappa di Calore',
    pressureIntensity: 'Intensità della pressione',
    pressureOutcome: 'Risultato della pressione',
    passesOutcome: 'Risultati dei Passaggi',
    strong: 'Forte',
    light: 'Leggero',
    normal: 'Normale',
    successful: 'Riuscito',
    unsuccessful: 'Non riuscito',
    presses: 'Pressioni',
    passes: 'Passa',
    passUnder: 'Passa Sotto',
    successRate: 'Tasso di successo',
    pressureOn: 'Pressione su',
    pressureOf: 'Pressione di',
    pressure: 'Pressione',
    totalLabel: 'totale',
    totalPasses: 'Passaggi Totali',
    unknown: 'sconosciuto',
    selectGameToViewMap: 'Seleziona un gioco per visualizzare la mappa della pressione',
    noEventsFoundForGame: 'Nessun evento di pressione trovato per questo gioco',
    noEventsFoundForTeamAndSeason: 'Nessun evento di pressione trovato per questa squadra e stagione',
    noEventsFoundForPlayerAndSeason: 'Nessun evento di pressione trovato per questo giocatore e stagione',
    noEventsMatchFilters: 'Nessun evento corrisponde ai filtri correnti',
    totalEventsAvailable: 'totale degli eventi disponibili',
    passType: {
      P: 'Passaggio',
      A: 'Assistere',
      KP: 'Passaggio chiave',
      PiOB: 'Passare all\'Opp. Scatola',
      PiFT: 'Passare al terzo finale',
      SoPP: 'Passaggio a Play Pass'
    },
    minFrom: 'Min da',
    minTo: 'Min a',
    secondFrom: 'Seg da',
    secondTo: 'Seg a',
    positionPlayed: 'Posizione giocata',
    highlight: 'Evidenziare',
    passTypeLabel: 'Tipo di passaggio',
    offBallRunSubtitle: 'Analizza le corse fuori palla',
    insights: 'Approfondimenti',
    insightsSubtitle: 'Classifica dei migliori con Advanced Arrigo Analytics',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: 'Come posso aiutarti oggi?',
    chatSubtext: 'Chiedi qualsiasi cosa sui dati calcistici!',
    thinking: 'Pensiero...',
    giveFeedback: 'Dai un feedback',
    disclaimer: 'DriblabAI può commettere errori. Per favore, assicurati di verificare le informazioni.',
    recent: 'Recente',
    noConversations: 'Qui vedrai le tue conversazioni recenti!',
    rename: 'Rinominare',
    deleteConversation: 'Elimina conversazione',
    confirmDelete: 'Sei sicuro di voler eliminare questa conversazione?',
    feedback: 'Feedback',
    feedbackQuestion: 'Questa risposta è stata utile?',
    feedbackComments: 'Ulteriori commenti',
    feedbackPlaceholder: 'Raccontaci cosa è stato utile o cosa potrebbe essere migliorato...',
    errorMessage: 'Impossibile elaborare il messaggio. Per favore riprova.',
    newConversation: 'Nuova chiacchierata',
    write: 'Scrivi un messaggio...'
  },
  periodId: {
    1: 'Primo tempo',
    2: 'Secondo tempo',
    3: 'Tempo supplementare - 1º',
    4: 'Tempo supplementare - 2º',
    5: 'Rigori',
    6: 'A tempo pieno',
    7: 'Pre-partita',
    8: 'Abbandonato',
    9: 'Vivere',
    10: '0-15',
    11: '16-30',
    12: '31+',
    13: '45-60',
    14: '61-75',
    15: '76+',
    '-1': 'Altro'
  }
};
